// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/bounty-hero.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/game.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!*************************************************************************************!*\\
  !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/magnific-popup.css ***!
  \\*************************************************************************************/
/* Magnific Popup CSS */

@tailwind base;
@tailwind components;
@tailwind utilities;


body{
    background: #0f0f0f;
}

.mfp-bg {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1042;
    overflow: hidden;
    position: fixed;
    background: #0b0b0b;
    opacity: 0.8;
  }
  
  .mfp-wrap {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1043;
    position: fixed;
    outline: none !important;
    -webkit-backface-visibility: hidden;
  }
  
  .mfp-container {
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    padding: 0 8px;
    box-sizing: border-box;
  }
  
  .mfp-container:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  
  .mfp-align-top .mfp-container:before {
    display: none;
  }
  
  .mfp-content {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin: 0 auto;
    text-align: left;
    z-index: 1045;
  }
  
  .mfp-inline-holder .mfp-content,
  .mfp-ajax-holder .mfp-content {
    width: 100%;
    cursor: auto;
  }
  
  .mfp-ajax-cur {
    cursor: progress;
  }
  
  .mfp-zoom-out-cur,
  .mfp-zoom-out-cur .mfp-image-holder .mfp-close {
    cursor: zoom-out;
  }
  
  .mfp-zoom {
    cursor: pointer;
    cursor: zoom-in;
  }
  
  .mfp-auto-cursor .mfp-content {
    cursor: auto;
  }
  
  .mfp-close,
  .mfp-arrow,
  .mfp-preloader,
  .mfp-counter {
    -webkit-user-select: none;
    user-select: none;
  }
  
  .mfp-loading.mfp-figure {
    display: none;
  }
  
  .mfp-hide {
    display: none !important;
  }
  
  .mfp-preloader {
    color: #ccc;
    position: absolute;
    top: 50%;
    width: auto;
    text-align: center;
    margin-top: -0.8em;
    left: 8px;
    right: 8px;
    z-index: 1044;
  }
  .mfp-preloader a {
    color: #ccc;
  }
  .mfp-preloader a:hover {
    color: #fff;
  }
  
  .mfp-s-ready .mfp-preloader {
    display: none;
  }
  
  .mfp-s-error .mfp-content {
    display: none;
  }
  
  button.mfp-close,
  button.mfp-arrow {
    overflow: visible;
    cursor: pointer;
    background: transparent;
    border: 0;
    -webkit-appearance: none;
    display: block;
    outline: none;
    padding: 0;
    z-index: 1046;
    box-shadow: none;
    touch-action: manipulation;
  }
  button::-moz-focus-inner {
    padding: 0;
    border: 0;
  }
  
  .mfp-close {
    width: 44px;
    height: 44px;
    line-height: 44px;
    position: absolute;
    right: 0;
    top: 0;
    text-decoration: none;
    text-align: center;
    opacity: 0.65;
    padding: 0 0 18px 10px;
    color: #fff;
    font-style: normal;
    font-size: 28px;
    font-family: Arial, Baskerville, monospace;
  }
  .mfp-close:hover,
  .mfp-close:focus {
    opacity: 1;
  }
  .mfp-close:active {
    top: 1px;
  }
  
  .mfp-close-btn-in .mfp-close {
    color: #ffff;
    margin-right: 6px;
  }
  
  .mfp-image-holder .mfp-close,
  .mfp-iframe-holder .mfp-close {
    color: #fff;
    right: -6px;
    text-align: right;
    padding-right: 6px;
    width: 100%;
  }
  
  .mfp-counter {
    position: absolute;
    top: 0;
    right: 0;
    color: #ccc;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
  }
  
  .mfp-arrow {
    position: absolute;
    opacity: 0.65;
    margin: 0;
    top: 50%;
    margin-top: -55px;
    padding: 0;
    width: 90px;
    height: 110px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  .mfp-arrow:active {
    margin-top: -54px;
  }
  .mfp-arrow:hover,
  .mfp-arrow:focus {
    opacity: 1;
  }
  .mfp-arrow:before,
  .mfp-arrow:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 35px;
    margin-left: 35px;
    border: medium inset transparent;
  }
  .mfp-arrow:after {
    border-top-width: 13px;
    border-bottom-width: 13px;
    top: 8px;
  }
  .mfp-arrow:before {
    border-top-width: 21px;
    border-bottom-width: 21px;
    opacity: 0.7;
  }
  
  .mfp-arrow-left {
    left: 0;
  }
  .mfp-arrow-left:after {
    border-right: 17px solid #fff;
    margin-left: 31px;
  }
  .mfp-arrow-left:before {
    margin-left: 25px;
    border-right: 27px solid #3f3f3f;
  }
  
  .mfp-arrow-right {
    right: 0;
  }
  .mfp-arrow-right:after {
    border-left: 17px solid #fff;
    margin-left: 39px;
  }
  .mfp-arrow-right:before {
    border-left: 27px solid #3f3f3f;
  }
  
  .mfp-iframe-holder {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .mfp-iframe-holder .mfp-content {
    line-height: 0;
    width: 100%;
    max-width: 900px;
  }
  .mfp-iframe-holder .mfp-close {
    top: -40px;
  }
  
  .mfp-iframe-scaler {
    width: 100%;
    height: 0;
    overflow: hidden;
    padding-top: 56.25%;
  }
  .mfp-iframe-scaler iframe {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #000;
  }
  
  /* Main image in popup */
  img.mfp-img {
    width: auto;
    max-width: 100%;
    height: auto;
    display: block;
    line-height: 0;
    box-sizing: border-box;
    padding: 40px 0 40px;
    margin: 0 auto;
  }
  
  /* The shadow behind the image */
  .mfp-figure {
    line-height: 0;
  }
  .mfp-figure:after {
    content: "";
    position: absolute;
    left: 0;
    top: 40px;
    bottom: 40px;
    display: block;
    right: 0;
    width: auto;
    height: auto;
    z-index: -1;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
    background: #444;
  }
  .mfp-figure small {
    color: #bdbdbd;
    display: block;
    font-size: 12px;
    line-height: 14px;
  }
  .mfp-figure figure {
    margin: 0;
  }
  
  .mfp-bottom-bar {
    margin-top: -36px;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    cursor: auto;
  }
  
  .mfp-title {
    text-align: left;
    line-height: 18px;
    color: #f3f3f3;
    word-wrap: break-word;
    padding-right: 36px;
  }
  
  .mfp-image-holder .mfp-content {
    max-width: 100%;
  }
  
  .mfp-gallery .mfp-image-holder .mfp-figure {
    cursor: pointer;
  }
  
  @media screen and (max-width: 800px) and (orientation: landscape),
    screen and (max-height: 300px) {
    /**
     * Remove all paddings around the image on small screen
     */
    .mfp-img-mobile .mfp-image-holder {
      padding-left: 0;
      padding-right: 0;
    }
    .mfp-img-mobile img.mfp-img {
      padding: 0;
    }
    .mfp-img-mobile .mfp-figure:after {
      top: 0;
      bottom: 0;
    }
    .mfp-img-mobile .mfp-figure small {
      display: inline;
      margin-left: 5px;
    }
    .mfp-img-mobile .mfp-bottom-bar {
      background: rgba(0, 0, 0, 0.6);
      bottom: 0;
      margin: 0;
      top: auto;
      padding: 3px 5px;
      position: fixed;
      box-sizing: border-box;
    }
    .mfp-img-mobile .mfp-bottom-bar:empty {
      padding: 0;
    }
    .mfp-img-mobile .mfp-counter {
      right: 5px;
      top: 3px;
    }
    .mfp-img-mobile .mfp-close {
      top: 0;
      right: 0;
      width: 35px;
      height: 35px;
      line-height: 35px;
      background: rgba(0, 0, 0, 0.6);
      position: fixed;
      text-align: center;
      padding: 0;
    }
  }
  @media all and (max-width: 900px) {
    .mfp-arrow {
      transform: scale(0.75);
    }
  
    .mfp-arrow-left {
      transform-origin: 0;
    }
  
    .mfp-arrow-right {
      transform-origin: 100%;
    }
  
    .mfp-container {
      padding-left: 6px;
      padding-right: 6px;
    }
  }
  
  /*!***********************************************************************************!*\\
    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/odometer-min.css ***!
    \\***********************************************************************************/
  .odometer.odometer-auto-theme,.odometer.odometer-auto-theme .odometer-digit,.odometer.odometer-theme-default,.odometer.odometer-theme-default .odometer-digit{display:inline-block;vertical-align:middle;position:relative}.odometer.odometer-auto-theme .odometer-digit .odometer-digit-spacer,.odometer.odometer-theme-default .odometer-digit .odometer-digit-spacer{display:inline-block;vertical-align:middle;visibility:hidden}.odometer.odometer-auto-theme .odometer-digit .odometer-digit-inner,.odometer.odometer-theme-default .odometer-digit .odometer-digit-inner{text-align:left;display:block;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.odometer.odometer-auto-theme .odometer-digit .odometer-ribbon,.odometer.odometer-theme-default .odometer-digit .odometer-ribbon{display:block}.odometer.odometer-auto-theme .odometer-digit .odometer-ribbon-inner,.odometer.odometer-theme-default .odometer-digit .odometer-ribbon-inner{display:block;-webkit-backface-visibility:hidden}.odometer.odometer-auto-theme .odometer-digit .odometer-value,.odometer.odometer-theme-default .odometer-digit .odometer-value{display:block;-webkit-transform:translateZ(0)}.odometer.odometer-auto-theme .odometer-digit .odometer-value.odometer-last-value,.odometer.odometer-theme-default .odometer-digit .odometer-value.odometer-last-value{position:absolute}.odometer.odometer-auto-theme.odometer-animating-up .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-up .odometer-ribbon-inner{transition:transform 2s}.odometer.odometer-auto-theme.odometer-animating-down .odometer-ribbon-inner,.odometer.odometer-auto-theme.odometer-animating-up.odometer-animating .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-down .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-up.odometer-animating .odometer-ribbon-inner{transform:translateY(-100%)}.odometer.odometer-auto-theme.odometer-animating-down.odometer-animating .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-down.odometer-animating .odometer-ribbon-inner{transition:transform 2s;transform:translateY(0)}.odometer.odometer-auto-theme .odometer-value,.odometer.odometer-theme-default .odometer-value{text-align:center}
  /*!*********************************************************************************!*\\
    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/swiper.min.css ***!
    \\*********************************************************************************/
  /**
   * Swiper 8.4.7
   * Most modern mobile touch slider and framework with hardware accelerated transitions
   * https://swiperjs.com
   *
   * Copyright 2014-2023 Vladimir Kharlampidi
   *
   * Released under the MIT License
   *
   * Released on: January 30, 2023
   */
  
   @font-face{font-family:swiper-icons;src:url(${___CSS_LOADER_URL_REPLACEMENT_0___});font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-virtual .swiper-slide{-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:'next'}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:50%;background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube .swiper-slide{pointer-events:none;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl .swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-next+.swiper-slide,.swiper-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right,.swiper-cube .swiper-slide-shadow-top{z-index:0;backface-visibility:hidden}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-flip{overflow:visible}.swiper-flip .swiper-slide{pointer-events:none;backface-visibility:hidden;z-index:1}.swiper-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right,.swiper-flip .swiper-slide-shadow-top{z-index:0;backface-visibility:hidden}.swiper-creative .swiper-slide{backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards .swiper-slide{transform-origin:center bottom;backface-visibility:hidden;overflow:hidden}
  /*!**************************************************************************!*\\
    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/aos.css ***!
    \\**************************************************************************/
  [data-aos][data-aos][data-aos-duration="50"],body[data-aos-duration="50"] [data-aos]{transition-duration:50ms}[data-aos][data-aos][data-aos-delay="50"],body[data-aos-delay="50"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="50"].aos-animate,body[data-aos-delay="50"] [data-aos].aos-animate{transition-delay:50ms}[data-aos][data-aos][data-aos-duration="100"],body[data-aos-duration="100"] [data-aos]{transition-duration:.1s}[data-aos][data-aos][data-aos-delay="100"],body[data-aos-delay="100"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="100"].aos-animate,body[data-aos-delay="100"] [data-aos].aos-animate{transition-delay:.1s}[data-aos][data-aos][data-aos-duration="150"],body[data-aos-duration="150"] [data-aos]{transition-duration:.15s}[data-aos][data-aos][data-aos-delay="150"],body[data-aos-delay="150"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="150"].aos-animate,body[data-aos-delay="150"] [data-aos].aos-animate{transition-delay:.15s}[data-aos][data-aos][data-aos-duration="200"],body[data-aos-duration="200"] [data-aos]{transition-duration:.2s}[data-aos][data-aos][data-aos-delay="200"],body[data-aos-delay="200"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="200"].aos-animate,body[data-aos-delay="200"] [data-aos].aos-animate{transition-delay:.2s}[data-aos][data-aos][data-aos-duration="250"],body[data-aos-duration="250"] [data-aos]{transition-duration:.25s}[data-aos][data-aos][data-aos-delay="250"],body[data-aos-delay="250"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="250"].aos-animate,body[data-aos-delay="250"] [data-aos].aos-animate{transition-delay:.25s}[data-aos][data-aos][data-aos-duration="300"],body[data-aos-duration="300"] [data-aos]{transition-duration:.3s}[data-aos][data-aos][data-aos-delay="300"],body[data-aos-delay="300"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="300"].aos-animate,body[data-aos-delay="300"] [data-aos].aos-animate{transition-delay:.3s}[data-aos][data-aos][data-aos-duration="350"],body[data-aos-duration="350"] [data-aos]{transition-duration:.35s}[data-aos][data-aos][data-aos-delay="350"],body[data-aos-delay="350"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="350"].aos-animate,body[data-aos-delay="350"] [data-aos].aos-animate{transition-delay:.35s}[data-aos][data-aos][data-aos-duration="400"],body[data-aos-duration="400"] [data-aos]{transition-duration:.4s}[data-aos][data-aos][data-aos-delay="400"],body[data-aos-delay="400"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="400"].aos-animate,body[data-aos-delay="400"] [data-aos].aos-animate{transition-delay:.4s}[data-aos][data-aos][data-aos-duration="450"],body[data-aos-duration="450"] [data-aos]{transition-duration:.45s}[data-aos][data-aos][data-aos-delay="450"],body[data-aos-delay="450"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="450"].aos-animate,body[data-aos-delay="450"] [data-aos].aos-animate{transition-delay:.45s}[data-aos][data-aos][data-aos-duration="500"],body[data-aos-duration="500"] [data-aos]{transition-duration:.5s}[data-aos][data-aos][data-aos-delay="500"],body[data-aos-delay="500"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="500"].aos-animate,body[data-aos-delay="500"] [data-aos].aos-animate{transition-delay:.5s}[data-aos][data-aos][data-aos-duration="550"],body[data-aos-duration="550"] [data-aos]{transition-duration:.55s}[data-aos][data-aos][data-aos-delay="550"],body[data-aos-delay="550"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="550"].aos-animate,body[data-aos-delay="550"] [data-aos].aos-animate{transition-delay:.55s}[data-aos][data-aos][data-aos-duration="600"],body[data-aos-duration="600"] [data-aos]{transition-duration:.6s}[data-aos][data-aos][data-aos-delay="600"],body[data-aos-delay="600"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="600"].aos-animate,body[data-aos-delay="600"] [data-aos].aos-animate{transition-delay:.6s}[data-aos][data-aos][data-aos-duration="650"],body[data-aos-duration="650"] [data-aos]{transition-duration:.65s}[data-aos][data-aos][data-aos-delay="650"],body[data-aos-delay="650"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="650"].aos-animate,body[data-aos-delay="650"] [data-aos].aos-animate{transition-delay:.65s}[data-aos][data-aos][data-aos-duration="700"],body[data-aos-duration="700"] [data-aos]{transition-duration:.7s}[data-aos][data-aos][data-aos-delay="700"],body[data-aos-delay="700"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="700"].aos-animate,body[data-aos-delay="700"] [data-aos].aos-animate{transition-delay:.7s}[data-aos][data-aos][data-aos-duration="750"],body[data-aos-duration="750"] [data-aos]{transition-duration:.75s}[data-aos][data-aos][data-aos-delay="750"],body[data-aos-delay="750"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="750"].aos-animate,body[data-aos-delay="750"] [data-aos].aos-animate{transition-delay:.75s}[data-aos][data-aos][data-aos-duration="800"],body[data-aos-duration="800"] [data-aos]{transition-duration:.8s}[data-aos][data-aos][data-aos-delay="800"],body[data-aos-delay="800"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="800"].aos-animate,body[data-aos-delay="800"] [data-aos].aos-animate{transition-delay:.8s}[data-aos][data-aos][data-aos-duration="850"],body[data-aos-duration="850"] [data-aos]{transition-duration:.85s}[data-aos][data-aos][data-aos-delay="850"],body[data-aos-delay="850"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="850"].aos-animate,body[data-aos-delay="850"] [data-aos].aos-animate{transition-delay:.85s}[data-aos][data-aos][data-aos-duration="900"],body[data-aos-duration="900"] [data-aos]{transition-duration:.9s}[data-aos][data-aos][data-aos-delay="900"],body[data-aos-delay="900"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="900"].aos-animate,body[data-aos-delay="900"] [data-aos].aos-animate{transition-delay:.9s}[data-aos][data-aos][data-aos-duration="950"],body[data-aos-duration="950"] [data-aos]{transition-duration:.95s}[data-aos][data-aos][data-aos-delay="950"],body[data-aos-delay="950"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="950"].aos-animate,body[data-aos-delay="950"] [data-aos].aos-animate{transition-delay:.95s}[data-aos][data-aos][data-aos-duration="1000"],body[data-aos-duration="1000"] [data-aos]{transition-duration:1s}[data-aos][data-aos][data-aos-delay="1000"],body[data-aos-delay="1000"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1000"].aos-animate,body[data-aos-delay="1000"] [data-aos].aos-animate{transition-delay:1s}[data-aos][data-aos][data-aos-duration="1050"],body[data-aos-duration="1050"] [data-aos]{transition-duration:1.05s}[data-aos][data-aos][data-aos-delay="1050"],body[data-aos-delay="1050"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1050"].aos-animate,body[data-aos-delay="1050"] [data-aos].aos-animate{transition-delay:1.05s}[data-aos][data-aos][data-aos-duration="1100"],body[data-aos-duration="1100"] [data-aos]{transition-duration:1.1s}[data-aos][data-aos][data-aos-delay="1100"],body[data-aos-delay="1100"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1100"].aos-animate,body[data-aos-delay="1100"] [data-aos].aos-animate{transition-delay:1.1s}[data-aos][data-aos][data-aos-duration="1150"],body[data-aos-duration="1150"] [data-aos]{transition-duration:1.15s}[data-aos][data-aos][data-aos-delay="1150"],body[data-aos-delay="1150"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1150"].aos-animate,body[data-aos-delay="1150"] [data-aos].aos-animate{transition-delay:1.15s}[data-aos][data-aos][data-aos-duration="1200"],body[data-aos-duration="1200"] [data-aos]{transition-duration:1.2s}[data-aos][data-aos][data-aos-delay="1200"],body[data-aos-delay="1200"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1200"].aos-animate,body[data-aos-delay="1200"] [data-aos].aos-animate{transition-delay:1.2s}[data-aos][data-aos][data-aos-duration="1250"],body[data-aos-duration="1250"] [data-aos]{transition-duration:1.25s}[data-aos][data-aos][data-aos-delay="1250"],body[data-aos-delay="1250"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1250"].aos-animate,body[data-aos-delay="1250"] [data-aos].aos-animate{transition-delay:1.25s}[data-aos][data-aos][data-aos-duration="1300"],body[data-aos-duration="1300"] [data-aos]{transition-duration:1.3s}[data-aos][data-aos][data-aos-delay="1300"],body[data-aos-delay="1300"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1300"].aos-animate,body[data-aos-delay="1300"] [data-aos].aos-animate{transition-delay:1.3s}[data-aos][data-aos][data-aos-duration="1350"],body[data-aos-duration="1350"] [data-aos]{transition-duration:1.35s}[data-aos][data-aos][data-aos-delay="1350"],body[data-aos-delay="1350"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1350"].aos-animate,body[data-aos-delay="1350"] [data-aos].aos-animate{transition-delay:1.35s}[data-aos][data-aos][data-aos-duration="1400"],body[data-aos-duration="1400"] [data-aos]{transition-duration:1.4s}[data-aos][data-aos][data-aos-delay="1400"],body[data-aos-delay="1400"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1400"].aos-animate,body[data-aos-delay="1400"] [data-aos].aos-animate{transition-delay:1.4s}[data-aos][data-aos][data-aos-duration="1450"],body[data-aos-duration="1450"] [data-aos]{transition-duration:1.45s}[data-aos][data-aos][data-aos-delay="1450"],body[data-aos-delay="1450"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1450"].aos-animate,body[data-aos-delay="1450"] [data-aos].aos-animate{transition-delay:1.45s}[data-aos][data-aos][data-aos-duration="1500"],body[data-aos-duration="1500"] [data-aos]{transition-duration:1.5s}[data-aos][data-aos][data-aos-delay="1500"],body[data-aos-delay="1500"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1500"].aos-animate,body[data-aos-delay="1500"] [data-aos].aos-animate{transition-delay:1.5s}[data-aos][data-aos][data-aos-duration="1550"],body[data-aos-duration="1550"] [data-aos]{transition-duration:1.55s}[data-aos][data-aos][data-aos-delay="1550"],body[data-aos-delay="1550"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1550"].aos-animate,body[data-aos-delay="1550"] [data-aos].aos-animate{transition-delay:1.55s}[data-aos][data-aos][data-aos-duration="1600"],body[data-aos-duration="1600"] [data-aos]{transition-duration:1.6s}[data-aos][data-aos][data-aos-delay="1600"],body[data-aos-delay="1600"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1600"].aos-animate,body[data-aos-delay="1600"] [data-aos].aos-animate{transition-delay:1.6s}[data-aos][data-aos][data-aos-duration="1650"],body[data-aos-duration="1650"] [data-aos]{transition-duration:1.65s}[data-aos][data-aos][data-aos-delay="1650"],body[data-aos-delay="1650"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1650"].aos-animate,body[data-aos-delay="1650"] [data-aos].aos-animate{transition-delay:1.65s}[data-aos][data-aos][data-aos-duration="1700"],body[data-aos-duration="1700"] [data-aos]{transition-duration:1.7s}[data-aos][data-aos][data-aos-delay="1700"],body[data-aos-delay="1700"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1700"].aos-animate,body[data-aos-delay="1700"] [data-aos].aos-animate{transition-delay:1.7s}[data-aos][data-aos][data-aos-duration="1750"],body[data-aos-duration="1750"] [data-aos]{transition-duration:1.75s}[data-aos][data-aos][data-aos-delay="1750"],body[data-aos-delay="1750"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1750"].aos-animate,body[data-aos-delay="1750"] [data-aos].aos-animate{transition-delay:1.75s}[data-aos][data-aos][data-aos-duration="1800"],body[data-aos-duration="1800"] [data-aos]{transition-duration:1.8s}[data-aos][data-aos][data-aos-delay="1800"],body[data-aos-delay="1800"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1800"].aos-animate,body[data-aos-delay="1800"] [data-aos].aos-animate{transition-delay:1.8s}[data-aos][data-aos][data-aos-duration="1850"],body[data-aos-duration="1850"] [data-aos]{transition-duration:1.85s}[data-aos][data-aos][data-aos-delay="1850"],body[data-aos-delay="1850"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1850"].aos-animate,body[data-aos-delay="1850"] [data-aos].aos-animate{transition-delay:1.85s}[data-aos][data-aos][data-aos-duration="1900"],body[data-aos-duration="1900"] [data-aos]{transition-duration:1.9s}[data-aos][data-aos][data-aos-delay="1900"],body[data-aos-delay="1900"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1900"].aos-animate,body[data-aos-delay="1900"] [data-aos].aos-animate{transition-delay:1.9s}[data-aos][data-aos][data-aos-duration="1950"],body[data-aos-duration="1950"] [data-aos]{transition-duration:1.95s}[data-aos][data-aos][data-aos-delay="1950"],body[data-aos-delay="1950"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="1950"].aos-animate,body[data-aos-delay="1950"] [data-aos].aos-animate{transition-delay:1.95s}[data-aos][data-aos][data-aos-duration="2000"],body[data-aos-duration="2000"] [data-aos]{transition-duration:2s}[data-aos][data-aos][data-aos-delay="2000"],body[data-aos-delay="2000"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2000"].aos-animate,body[data-aos-delay="2000"] [data-aos].aos-animate{transition-delay:2s}[data-aos][data-aos][data-aos-duration="2050"],body[data-aos-duration="2050"] [data-aos]{transition-duration:2.05s}[data-aos][data-aos][data-aos-delay="2050"],body[data-aos-delay="2050"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2050"].aos-animate,body[data-aos-delay="2050"] [data-aos].aos-animate{transition-delay:2.05s}[data-aos][data-aos][data-aos-duration="2100"],body[data-aos-duration="2100"] [data-aos]{transition-duration:2.1s}[data-aos][data-aos][data-aos-delay="2100"],body[data-aos-delay="2100"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2100"].aos-animate,body[data-aos-delay="2100"] [data-aos].aos-animate{transition-delay:2.1s}[data-aos][data-aos][data-aos-duration="2150"],body[data-aos-duration="2150"] [data-aos]{transition-duration:2.15s}[data-aos][data-aos][data-aos-delay="2150"],body[data-aos-delay="2150"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2150"].aos-animate,body[data-aos-delay="2150"] [data-aos].aos-animate{transition-delay:2.15s}[data-aos][data-aos][data-aos-duration="2200"],body[data-aos-duration="2200"] [data-aos]{transition-duration:2.2s}[data-aos][data-aos][data-aos-delay="2200"],body[data-aos-delay="2200"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2200"].aos-animate,body[data-aos-delay="2200"] [data-aos].aos-animate{transition-delay:2.2s}[data-aos][data-aos][data-aos-duration="2250"],body[data-aos-duration="2250"] [data-aos]{transition-duration:2.25s}[data-aos][data-aos][data-aos-delay="2250"],body[data-aos-delay="2250"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2250"].aos-animate,body[data-aos-delay="2250"] [data-aos].aos-animate{transition-delay:2.25s}[data-aos][data-aos][data-aos-duration="2300"],body[data-aos-duration="2300"] [data-aos]{transition-duration:2.3s}[data-aos][data-aos][data-aos-delay="2300"],body[data-aos-delay="2300"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2300"].aos-animate,body[data-aos-delay="2300"] [data-aos].aos-animate{transition-delay:2.3s}[data-aos][data-aos][data-aos-duration="2350"],body[data-aos-duration="2350"] [data-aos]{transition-duration:2.35s}[data-aos][data-aos][data-aos-delay="2350"],body[data-aos-delay="2350"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2350"].aos-animate,body[data-aos-delay="2350"] [data-aos].aos-animate{transition-delay:2.35s}[data-aos][data-aos][data-aos-duration="2400"],body[data-aos-duration="2400"] [data-aos]{transition-duration:2.4s}[data-aos][data-aos][data-aos-delay="2400"],body[data-aos-delay="2400"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2400"].aos-animate,body[data-aos-delay="2400"] [data-aos].aos-animate{transition-delay:2.4s}[data-aos][data-aos][data-aos-duration="2450"],body[data-aos-duration="2450"] [data-aos]{transition-duration:2.45s}[data-aos][data-aos][data-aos-delay="2450"],body[data-aos-delay="2450"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2450"].aos-animate,body[data-aos-delay="2450"] [data-aos].aos-animate{transition-delay:2.45s}[data-aos][data-aos][data-aos-duration="2500"],body[data-aos-duration="2500"] [data-aos]{transition-duration:2.5s}[data-aos][data-aos][data-aos-delay="2500"],body[data-aos-delay="2500"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2500"].aos-animate,body[data-aos-delay="2500"] [data-aos].aos-animate{transition-delay:2.5s}[data-aos][data-aos][data-aos-duration="2550"],body[data-aos-duration="2550"] [data-aos]{transition-duration:2.55s}[data-aos][data-aos][data-aos-delay="2550"],body[data-aos-delay="2550"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2550"].aos-animate,body[data-aos-delay="2550"] [data-aos].aos-animate{transition-delay:2.55s}[data-aos][data-aos][data-aos-duration="2600"],body[data-aos-duration="2600"] [data-aos]{transition-duration:2.6s}[data-aos][data-aos][data-aos-delay="2600"],body[data-aos-delay="2600"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2600"].aos-animate,body[data-aos-delay="2600"] [data-aos].aos-animate{transition-delay:2.6s}[data-aos][data-aos][data-aos-duration="2650"],body[data-aos-duration="2650"] [data-aos]{transition-duration:2.65s}[data-aos][data-aos][data-aos-delay="2650"],body[data-aos-delay="2650"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2650"].aos-animate,body[data-aos-delay="2650"] [data-aos].aos-animate{transition-delay:2.65s}[data-aos][data-aos][data-aos-duration="2700"],body[data-aos-duration="2700"] [data-aos]{transition-duration:2.7s}[data-aos][data-aos][data-aos-delay="2700"],body[data-aos-delay="2700"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2700"].aos-animate,body[data-aos-delay="2700"] [data-aos].aos-animate{transition-delay:2.7s}[data-aos][data-aos][data-aos-duration="2750"],body[data-aos-duration="2750"] [data-aos]{transition-duration:2.75s}[data-aos][data-aos][data-aos-delay="2750"],body[data-aos-delay="2750"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2750"].aos-animate,body[data-aos-delay="2750"] [data-aos].aos-animate{transition-delay:2.75s}[data-aos][data-aos][data-aos-duration="2800"],body[data-aos-duration="2800"] [data-aos]{transition-duration:2.8s}[data-aos][data-aos][data-aos-delay="2800"],body[data-aos-delay="2800"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2800"].aos-animate,body[data-aos-delay="2800"] [data-aos].aos-animate{transition-delay:2.8s}[data-aos][data-aos][data-aos-duration="2850"],body[data-aos-duration="2850"] [data-aos]{transition-duration:2.85s}[data-aos][data-aos][data-aos-delay="2850"],body[data-aos-delay="2850"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2850"].aos-animate,body[data-aos-delay="2850"] [data-aos].aos-animate{transition-delay:2.85s}[data-aos][data-aos][data-aos-duration="2900"],body[data-aos-duration="2900"] [data-aos]{transition-duration:2.9s}[data-aos][data-aos][data-aos-delay="2900"],body[data-aos-delay="2900"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2900"].aos-animate,body[data-aos-delay="2900"] [data-aos].aos-animate{transition-delay:2.9s}[data-aos][data-aos][data-aos-duration="2950"],body[data-aos-duration="2950"] [data-aos]{transition-duration:2.95s}[data-aos][data-aos][data-aos-delay="2950"],body[data-aos-delay="2950"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="2950"].aos-animate,body[data-aos-delay="2950"] [data-aos].aos-animate{transition-delay:2.95s}[data-aos][data-aos][data-aos-duration="3000"],body[data-aos-duration="3000"] [data-aos]{transition-duration:3s}[data-aos][data-aos][data-aos-delay="3000"],body[data-aos-delay="3000"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay="3000"].aos-animate,body[data-aos-delay="3000"] [data-aos].aos-animate{transition-delay:3s}[data-aos][data-aos][data-aos-easing=linear],body[data-aos-easing=linear] [data-aos]{transition-timing-function:cubic-bezier(.25,.25,.75,.75)}[data-aos][data-aos][data-aos-easing=ease],body[data-aos-easing=ease] [data-aos]{transition-timing-function:ease}[data-aos][data-aos][data-aos-easing=ease-in],body[data-aos-easing=ease-in] [data-aos]{transition-timing-function:ease-in}[data-aos][data-aos][data-aos-easing=ease-out],body[data-aos-easing=ease-out] [data-aos]{transition-timing-function:ease-out}[data-aos][data-aos][data-aos-easing=ease-in-out],body[data-aos-easing=ease-in-out] [data-aos]{transition-timing-function:ease-in-out}[data-aos][data-aos][data-aos-easing=ease-in-back],body[data-aos-easing=ease-in-back] [data-aos]{transition-timing-function:cubic-bezier(.6,-.28,.735,.045)}[data-aos][data-aos][data-aos-easing=ease-out-back],body[data-aos-easing=ease-out-back] [data-aos]{transition-timing-function:cubic-bezier(.175,.885,.32,1.275)}[data-aos][data-aos][data-aos-easing=ease-in-out-back],body[data-aos-easing=ease-in-out-back] [data-aos]{transition-timing-function:cubic-bezier(.68,-.55,.265,1.55)}[data-aos][data-aos][data-aos-easing=ease-in-sine],body[data-aos-easing=ease-in-sine] [data-aos]{transition-timing-function:cubic-bezier(.47,0,.745,.715)}[data-aos][data-aos][data-aos-easing=ease-out-sine],body[data-aos-easing=ease-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.39,.575,.565,1)}[data-aos][data-aos][data-aos-easing=ease-in-out-sine],body[data-aos-easing=ease-in-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.445,.05,.55,.95)}[data-aos][data-aos][data-aos-easing=ease-in-quad],body[data-aos-easing=ease-in-quad] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quad],body[data-aos-easing=ease-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quad],body[data-aos-easing=ease-in-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-cubic],body[data-aos-easing=ease-in-cubic] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-cubic],body[data-aos-easing=ease-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-cubic],body[data-aos-easing=ease-in-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-quart],body[data-aos-easing=ease-in-quart] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quart],body[data-aos-easing=ease-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quart],body[data-aos-easing=ease-in-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos^=fade][data-aos^=fade]{opacity:0;transition-property:opacity,transform}[data-aos^=fade][data-aos^=fade].aos-animate{opacity:1;transform:translateZ(0)}[data-aos=fade-up]{transform:translate3d(0,100px,0)}[data-aos=fade-down]{transform:translate3d(0,-100px,0)}[data-aos=fade-right]{transform:translate3d(-100px,0,0)}[data-aos=fade-left]{transform:translate3d(100px,0,0)}[data-aos=fade-up-right]{transform:translate3d(-100px,100px,0)}[data-aos=fade-up-left]{transform:translate3d(100px,100px,0)}[data-aos=fade-down-right]{transform:translate3d(-100px,-100px,0)}[data-aos=fade-down-left]{transform:translate3d(100px,-100px,0)}[data-aos^=zoom][data-aos^=zoom]{opacity:0;transition-property:opacity,transform}[data-aos^=zoom][data-aos^=zoom].aos-animate{opacity:1;transform:translateZ(0) scale(1)}[data-aos=zoom-in]{transform:scale(.6)}[data-aos=zoom-in-up]{transform:translate3d(0,100px,0) scale(.6)}[data-aos=zoom-in-down]{transform:translate3d(0,-100px,0) scale(.6)}[data-aos=zoom-in-right]{transform:translate3d(-100px,0,0) scale(.6)}[data-aos=zoom-in-left]{transform:translate3d(100px,0,0) scale(.6)}[data-aos=zoom-out]{transform:scale(1.2)}[data-aos=zoom-out-up]{transform:translate3d(0,100px,0) scale(1.2)}[data-aos=zoom-out-down]{transform:translate3d(0,-100px,0) scale(1.2)}[data-aos=zoom-out-right]{transform:translate3d(-100px,0,0) scale(1.2)}[data-aos=zoom-out-left]{transform:translate3d(100px,0,0) scale(1.2)}[data-aos^=slide][data-aos^=slide]{transition-property:transform}[data-aos^=slide][data-aos^=slide].aos-animate{transform:translateZ(0)}[data-aos=slide-up]{transform:translate3d(0,100%,0)}[data-aos=slide-down]{transform:translate3d(0,-100%,0)}[data-aos=slide-right]{transform:translate3d(-100%,0,0)}[data-aos=slide-left]{transform:translate3d(100%,0,0)}[data-aos^=flip][data-aos^=flip]{backface-visibility:hidden;transition-property:transform}[data-aos=flip-left]{transform:perspective(2500px) rotateY(-100deg)}[data-aos=flip-left].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-right]{transform:perspective(2500px) rotateY(100deg)}[data-aos=flip-right].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-up]{transform:perspective(2500px) rotateX(-100deg)}[data-aos=flip-up].aos-animate{transform:perspective(2500px) rotateX(0)}[data-aos=flip-down]{transform:perspective(2500px) rotateX(100deg)}[data-aos=flip-down].aos-animate{transform:perspective(2500px) rotateX(0)}
  /*!****************************************************************************!*\\
    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/lenis.css ***!
    \\****************************************************************************/
  html.lenis,
  html.lenis body {
    height: auto;
  }
  .lenis.lenis-smooth [data-lenis-prevent] {
    overscroll-behavior: contain;
  }
  .lenis.lenis-stopped {
    overflow: clip;
  }
  .lenis.lenis-smooth iframe {
    pointer-events: none;
  }
  
  /*!***********************************************************************************!*\\
    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/fonts/fontssheet.css ***!
    \\***********************************************************************************/
  /* @font-face {
      font-family: 'Outfit';
      src: url(../../e1ea969df8d6180041fc.woff2) format('woff2'),
          url(../../a5e8bfd70b3d1e85cac5.woff) format('woff');
      font-weight: 900;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../666034473b9e795630bc.woff2) format('woff2'),
          url(../../c74427bd9ad8aa578047.woff) format('woff');
      font-weight: 100;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../f57facd89540c8266079.woff2) format('woff2'),
          url(../../d9020b8d98ddb5dd0096.woff) format('woff');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../2042e98f726bba6575a4.woff2) format('woff2'),
          url(../../d3b8dfd22bd5c5321ee3.woff) format('woff');
      font-weight: 200;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../f06abb0216a6d29d98e5.woff2) format('woff2'),
          url(../../e59dd696d0eaa24d06a2.woff) format('woff');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../f45af692fc4b8e0ebb13.woff2) format('woff2'),
          url(../../48c93fcdf7aca0b7d879.woff) format('woff');
      font-weight: 600;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../2905368f4c2d332bb2f5.woff2) format('woff2'),
          url(../../986130b3058b61f28dd6.woff) format('woff');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../4778f5f8a0f7abc3264c.woff2) format('woff2'),
          url(../../b37239988a1c40c98331.woff) format('woff');
      font-weight: 300;
      font-style: normal;
      font-display: swap;
  }
  
  @font-face {
      font-family: 'Outfit';
      src: url(../../74ec9eaf7e28cc27b2b5.woff2) format('woff2'),
          url(../../705e9dc8aaf333441d29.woff) format('woff');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
  } */
  
  
  /*!************************************************************************************************************************************************************************************!*\\
    !*** css ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/scss/style.scss ***!
    \\************************************************************************************************************************************************************************************/
  /*
  Template Name: gameWolf - gaming HTML Template;
  Author: ThemesWolf;
  Version: 1.0;
  Description: gaming HTML Template;
  Tags: HTML, SASS, Tailwind CSS,  JavaScript;
  */
  /*
  ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
  */
  /*
  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
  2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
  */
  *,
  ::before,
  ::after {
    box-sizing: border-box; /* 1 */
    border-width: 0; /* 2 */
    border-style: solid; /* 2 */
    border-color: #e5e7eb; /* 2 */
  }
  ::before,
  ::after {
    --tw-content: '';
  }
  /*
  1. Use a consistent sensible line-height in all browsers.
  2. Prevent adjustments of font size after orientation changes in iOS.
  3. Use a more readable tab size.
  4. Use the user's configured \`sans\` font-family by default.
  5. Use the user's configured \`sans\` font-feature-settings by default.
  6. Use the user's configured \`sans\` font-variation-settings by default.
  7. Disable tap highlights on iOS
  */
  html,
  :host {
    line-height: 1.5; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
    tab-size: 4; /* 3 */
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
    font-feature-settings: normal; /* 5 */
    font-variation-settings: normal; /* 6 */
    -webkit-tap-highlight-color: transparent; /* 7 */
  }
  /*
  1. Remove the margin in all browsers.
  2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
  */
  body {
    margin: 0; /* 1 */
    line-height: inherit; /* 2 */
  }
  /*
  1. Add the correct height in Firefox.
  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
  3. Ensure horizontal rules are visible by default.
  */
  hr {
    height: 0; /* 1 */
    color: inherit; /* 2 */
    border-top-width: 1px; /* 3 */
  }
  /*
  Add the correct text decoration in Chrome, Edge, and Safari.
  */
  abbr:where([title]) {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
            text-decoration: underline dotted;
  }
  /*
  Remove the default font size and weight for headings.
  */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  /*
  Reset links to optimize for opt-in styling instead of opt-out.
  */
  a {
    color: inherit;
    text-decoration: inherit;
  }
  /*
  Add the correct font weight in Edge and Safari.
  */
  b,
  strong {
    font-weight: bolder;
  }
  /*
  1. Use the user's configured \`mono\` font-family by default.
  2. Use the user's configured \`mono\` font-feature-settings by default.
  3. Use the user's configured \`mono\` font-variation-settings by default.
  4. Correct the odd \`em\` font sizing in all browsers.
  */
  code,
  kbd,
  samp,
  pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
    font-feature-settings: normal; /* 2 */
    font-variation-settings: normal; /* 3 */
    font-size: 1em; /* 4 */
  }
  /*
  Add the correct font size in all browsers.
  */
  small {
    font-size: 80%;
  }
  /*
  Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
  */
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  /*
  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
  3. Remove gaps between table borders by default.
  */
  table {
    text-indent: 0; /* 1 */
    border-color: inherit; /* 2 */
    border-collapse: collapse; /* 3 */
  }
  /*
  1. Change the font styles in all browsers.
  2. Remove the margin in Firefox and Safari.
  3. Remove default padding in all browsers.
  */
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-feature-settings: inherit; /* 1 */
    font-variation-settings: inherit; /* 1 */
    font-size: 100%; /* 1 */
    font-weight: inherit; /* 1 */
    line-height: inherit; /* 1 */
    letter-spacing: inherit; /* 1 */
    color: inherit; /* 1 */
    margin: 0; /* 2 */
    padding: 0; /* 3 */
  }
  /*
  Remove the inheritance of text transform in Edge and Firefox.
  */
  button,
  select {
    text-transform: none;
  }
  /*
  1. Correct the inability to style clickable types in iOS and Safari.
  2. Remove default button styles.
  */
  button,
  input:where([type='button']),
  input:where([type='reset']),
  input:where([type='submit']) {
    -webkit-appearance: button; /* 1 */
    background-color: transparent; /* 2 */
    background-image: none; /* 2 */
  }
  /*
  Use the modern Firefox focus style for all focusable elements.
  */
  :-moz-focusring {
    outline: auto;
  }
  /*
  Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
  */
  :-moz-ui-invalid {
    box-shadow: none;
  }
  /*
  Add the correct vertical alignment in Chrome and Firefox.
  */
  progress {
    vertical-align: baseline;
  }
  /*
  Correct the cursor style of increment and decrement buttons in Safari.
  */
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }
  /*
  1. Correct the odd appearance in Chrome and Safari.
  2. Correct the outline style in Safari.
  */
  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }
  /*
  Remove the inner padding in Chrome and Safari on macOS.
  */
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  /*
  1. Correct the inability to style clickable types in iOS and Safari.
  2. Change font properties to \`inherit\` in Safari.
  */
  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }
  /*
  Add the correct display in Chrome and Safari.
  */
  summary {
    display: list-item;
  }
  /*
  Removes the default spacing and border for appropriate elements.
  */
  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  figure,
  p,
  pre {
    margin: 0;
  }
  fieldset {
    margin: 0;
    padding: 0;
  }
  legend {
    padding: 0;
  }
  ol,
  ul,
  menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  /*
  Reset default styling for dialogs.
  */
  dialog {
    padding: 0;
  }
  /*
  Prevent resizing textareas horizontally by default.
  */
  textarea {
    resize: vertical;
  }
  /*
  1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
  2. Set the default placeholder color to the user's configured gray 400 color.
  */
  input::placeholder,
  textarea::placeholder {
    opacity: 1; /* 1 */
    color: #9ca3af; /* 2 */
  }
  /*
  Set the default cursor for buttons.
  */
  button,
  [role="button"] {
    cursor: pointer;
  }
  /*
  Make sure disabled buttons don't get the pointer cursor.
  */
  :disabled {
    cursor: default;
  }
  /*
  1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
  2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
     This can trigger a poorly considered lint error in some tools but is included by design.
  */
  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block; /* 1 */
    vertical-align: middle; /* 2 */
  }
  /*
  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
  */
  img,
  video {
    max-width: 100%;
    height: auto;
  }
  /* Make elements with the HTML hidden attribute stay hidden by default */
  [hidden] {
    display: none;
  }
  i {
      font-size: 1.5rem;
    }
  a,
    p,
    span,
    td{
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 300;
  }
  @media (min-width: 768px){
    a,
    p,
    span,
    td{
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
  }
  span{
    display: block;
  }
  h1{
    font-size: 30px;
    font-weight: 700;
    line-height: 120%;
  }
  @media (min-width: 576px){
    h1{
      font-size: 24px;
    }
  }
  @media (min-width: 768px){
    h1{
      font-size: 36px;
    }
  }
  @media (min-width: 1200px){
    h1{
      font-size: 64px;
    }
  }
  h2{
    font-size: 20px;
    font-weight: 700;
    line-height: 120%;
  }
  @media (min-width: 576px){
    h2{
      font-size: 24px;
    }
  }
  @media (min-width: 992px){
    h2{
      font-size: 30px;
    }
  }
  @media (min-width: 1200px){
    h2{
      font-size: 40px;
    }
  }
  h3{
    font-size: 20px;
    font-weight: 700;
    line-height: 120%;
  }
  @media (min-width: 576px){
    h3{
      font-weight: 700;
    }
  }
  @media (min-width: 992px){
    h3{
      font-size: 24px;
    }
  }
  @media (min-width: 1200px){
    h3{
      font-size: 32px;
    }
  }
  h4{
    font-size: 18px;
    font-weight: 700;
    line-height: 120%;
  }
  @media (min-width: 768px){
    h4{
      font-size: 20px;
      font-weight: 700;
    }
  }
  @media (min-width: 1200px){
    h4{
      font-size: 24px;
    }
  }
  h5{
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
  }
  @media (min-width: 768px){
    h5{
      font-size: 20px;
      font-weight: 700;
    }
  }
  h6{
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  }
  input:focus,
    textarea:focus{
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  *, ::before, ::after{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
    --tw-ring-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
  }
  ::backdrop{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
    --tw-ring-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
  }
  .container{
    width: 100%;
  }
  @media (min-width: 576px){
    .container{
      max-width: 576px;
    }
  }
  @media (min-width: 768px){
    .container{
      max-width: 768px;
    }
  }
  @media (min-width: 992px){
    .container{
      max-width: 992px;
    }
  }
  @media (min-width: 1200px){
    .container{
      max-width: 1200px;
    }
  }
  @media (min-width: 1296px){
    .container{
      max-width: 1296px;
    }
  }
  @media (min-width: 1600px){
    .container{
      max-width: 1600px;
    }
  }
  @media (min-width: 1800px){
    .container{
      max-width: 1800px;
    }
  }
  .container{
    margin-left: auto;
    margin-right: auto;
  }
  @media not all and (min-width: 576px){
    .container{
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
  }
  @media (min-width: 576px){
    .container{
      max-width: 540px;
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  @media (min-width: 768px){
    .container{
      max-width: 720px;
    }
  }
  @media (min-width: 992px){
    .container{
      max-width: 960px;
    }
  }
  @media (min-width: 1200px){
    .container{
      max-width: 1140px;
    }
  }
  @media (min-width: 1296px){
    .container{
      max-width: 1296px;
    }
  }
  .lin {
      color: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    }
  .visible{
    visibility: visible;
  }
  .collapse{
    visibility: collapse;
  }
  .static{
    position: static;
  }
  .fixed{
    position: fixed;
  }
  .absolute{
    position: absolute;
  }
  .relative{
    position: relative;
  }
  .sticky{
    position: sticky;
  }
  .bottom-\\[18px\\]{
    bottom: 18px;
  }
  .bottom-\\[20px\\]{
    bottom: 20px;
  }
  .left-0{
    left: 0px;
  }
  .left-1\\/2{
    left: 50%;
  }
  .right-0{
    right: 0px;
  }
  .top-0{
    top: 0px;
  }
  .top-1\\/2{
    top: 50%;
  }
  .-z-10{
    z-index: -10;
  }
  .z-0{
    z-index: 0;
  }
  .z-10{
    z-index: 10;
  }
  .z-30{
    z-index: 30;
  }
  .z-40{
    z-index: 40;
  }
  .col-span-12{
    grid-column: span 12 / span 12;
  }
  .col-span-2{
    grid-column: span 2 / span 2;
  }
  .col-span-6{
    grid-column: span 6 / span 6;
  }
  .m-auto{
    margin: auto;
  }
  .-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }
  .mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .-ml-4{
    margin-left: -1rem;
  }
  .-ml-5{
    margin-left: -1.25rem;
  }
  .-ml-6{
    margin-left: -1.5rem;
  }
  .-ml-\\[14px\\]{
    margin-left: -14px;
  }
  .-mt-4{
    margin-top: -1rem;
  }
  .-mt-5{
    margin-top: -1.25rem;
  }
  .-mt-8{
    margin-top: -2rem;
  }
  .-mt-\\[0\\.6rem\\]{
    margin-top: -0.6rem;
  }
  .-mt-\\[16px\\]{
    margin-top: -16px;
  }
  .-mt-\\[30px\\]{
    margin-top: -30px;
  }
  .mb-3{
    margin-bottom: 0.75rem;
  }
  .mb-4{
    margin-bottom: 1rem;
  }
  .ml-0{
    margin-left: 0px;
  }
  .ml-1{
    margin-left: 0.25rem;
  }
  .ml-2{
    margin-left: 0.5rem;
  }
  .ml-3{
    margin-left: 0.75rem;
  }
  .ml-4{
    margin-left: 1rem;
  }
  .ml-\\[10rem\\]{
    margin-left: 10rem;
  }
  .ml-\\[6rem\\]{
    margin-left: 6rem;
  }
  .ml-\\[8px\\]{
    margin-left: 8px;
  }
  .mr-2{
    margin-right: 0.5rem;
  }
  .mr-\\[0\\.5rem\\]{
    margin-right: 0.5rem;
  }
  .mt-1{
    margin-top: 0.25rem;
  }
  .mt-10{
    margin-top: 2.5rem;
  }
  .mt-2{
    margin-top: 0.5rem;
  }
  .mt-3{
    margin-top: 0.75rem;
  }
  .mt-4{
    margin-top: 1rem;
  }
  .mt-6{
    margin-top: 1.5rem;
  }
  .mt-\\[1\\.5rem\\]{
    margin-top: 1.5rem;
  }
  .mt-\\[24\\%\\]{
    margin-top: 24%;
  }
  .mt-\\[2rem\\]{
    margin-top: 2rem;
  }
  .block{
    display: block;
  }
  .inline-block{
    display: inline-block;
  }
  .inline{
    display: inline;
  }
  .flex{
    display: flex;
  }
  .table{
    display: table;
  }
  .grid{
    display: grid;
  }
  .contents{
    display: contents;
  }
  .hidden{
    display: none;
  }
  .size-10{
    width: 2.5rem;
    height: 2.5rem;
  }
  .size-9{
    width: 2.25rem;
    height: 2.25rem;
  }
  .h-\\[100px\\]{
    height: 100px;
  }
  .h-\\[110px\\]{
    height: 110px;
  }
  .h-\\[220px\\]{
    height: 220px;
  }
  .h-\\[25px\\]{
    height: 25px;
  }
  .h-\\[34px\\]{
    height: 34px;
  }
  .h-\\[40px\\]{
    height: 40px;
  }
  .h-\\[50px\\]{
    height: 50px;
  }
  .h-auto{
    height: auto;
  }
  .h-full{
    height: 100%;
  }
  .\\!w-fit{
    width: fit-content !important;
  }
  .w-\\[100px\\]{
    width: 100px;
  }
  .w-\\[140px\\]{
    width: 140px;
  }
  .w-\\[200px\\]{
    width: 200px;
  }
  .w-\\[240px\\]{
    width: 240px;
  }
  .w-\\[25px\\]{
    width: 25px;
  }
  .w-\\[34px\\]{
    width: 34px;
  }
  .w-\\[40\\%\\]{
    width: 40%;
  }
  .w-\\[40px\\]{
    width: 40px;
  }
  .w-\\[45px\\]{
    width: 45px;
  }
  .w-\\[50px\\]{
    width: 50px;
  }
  .w-full{
    width: 100%;
  }
  .-translate-x-1\\/2{
    --tw-translate-x: -50%;
    transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .-translate-y-1\\/2{
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .-rotate-3{
    --tw-rotate: -3deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-3deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .rotate-3{
    --tw-rotate: 3deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(3deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .transform{
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .cursor-pointer{
    cursor: pointer;
  }
  .resize{
    resize: both;
  }
  .grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  .grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .flex-col{
    flex-direction: column;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .items-center{
    align-items: center;
  }
  .justify-end{
    justify-content: flex-end;
  }
  .justify-center{
    justify-content: center;
  }
  .justify-between{
    justify-content: space-between;
  }
  .gap-1{
    gap: 0.25rem;
  }
  .gap-2{
    gap: 0.5rem;
  }
  .gap-3{
    gap: 0.75rem;
  }
  .gap-4{
    gap: 1rem;
  }
  .gap-6{
    gap: 1.5rem;
  }
  .gap-8{
    gap: 2rem;
  }
  .overflow-hidden{
    overflow: hidden;
  }
  .overflow-scroll{
    overflow: scroll;
  }
  .overflow-x-hidden{
    overflow-x: hidden;
  }
  .rounded-2xl{
    border-radius: 1rem;
  }
  .rounded-3xl{
    border-radius: 1.5rem;
  }
  .rounded-full{
    border-radius: 9999px;
  }
  .rounded-lg{
    border-radius: 0.5rem;
  }
  .rounded-xl{
    border-radius: 0.75rem;
  }
  .rounded-b-2xl{
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }
  .rounded-b-3xl{
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
  .rounded-t-2xl{
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  .rounded-t-3xl{
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }
  .border{
    border-width: 1px;
  }
  .border-2{
    border-width: 2px;
  }
  .border-b-2{
    border-bottom-width: 2px;
  }
  .border-t-2{
    border-top-width: 2px;
  }
  .border-dotted{
    border-style: dotted;
  }
  .border-none{
    border-style: none;
  }
  .border-nu2{
    --tw-border-opacity: 1;
    border-color: rgba(15, 15, 15, 1);
    border-color: rgba(15, 15, 15, var(--tw-border-opacity));
  }
  .border-nu4{
    --tw-border-opacity: 1;
    border-color: rgba(24, 25, 31, 1);
    border-color: rgba(24, 25, 31, var(--tw-border-opacity));
  }
  .border-nu7{
    --tw-border-opacity: 1;
    border-color: rgba(19, 24, 31, 1);
    border-color: rgba(19, 24, 31, var(--tw-border-opacity));
  }
  .border-nu8{
    --tw-border-opacity: 1;
    border-color: rgba(35, 38, 39, 1);
    border-color: rgba(35, 38, 39, var(--tw-border-opacity));
  }
  .border-nu9{
    --tw-border-opacity: 1;
    border-color: rgba(135, 139, 149, 1);
    border-color: rgba(135, 139, 149, var(--tw-border-opacity));
  }
  .border-primary{
    --tw-border-opacity: 1;
    border-color: rgba(255, 50, 90, 1);
    border-color: rgba(255, 50, 90, var(--tw-border-opacity));
  }
  .border-secondary{
    --tw-border-opacity: 1;
    border-color: rgba(242, 150, 32, 1);
    border-color: rgba(242, 150, 32, var(--tw-border-opacity));
  }
  .border-white{
    --tw-border-opacity: 1;
    border-color: rgba(255, 255, 255, 1);
    border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  }
  .bg-nu12{
    --tw-bg-opacity: 1;
    background-color: rgba(0, 0, 0, 1);
    background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  }
  .bg-nu2{
    --tw-bg-opacity: 1;
    background-color: rgba(15, 15, 15, 1);
    background-color: rgba(15, 15, 15, var(--tw-bg-opacity));
  }
  .bg-nu4{
    --tw-bg-opacity: 1;
    background-color: rgba(24, 25, 31, 1);
    background-color: rgba(24, 25, 31, var(--tw-bg-opacity));
  }
  .bg-nu6{
    --tw-bg-opacity: 1;
    background-color: rgba(52, 56, 57, 1);
    background-color: rgba(52, 56, 57, var(--tw-bg-opacity));
  }
  .bg-nu7{
    --tw-bg-opacity: 1;
    background-color: rgba(19, 24, 31, 1);
    background-color: rgba(19, 24, 31, var(--tw-bg-opacity));
  }
  .bg-nu8{
    --tw-bg-opacity: 1;
    background-color: rgba(35, 38, 39, 1);
    background-color: rgba(35, 38, 39, var(--tw-bg-opacity));
  }
  .bg-primary{
    --tw-bg-opacity: 1;
    background-color: rgba(255, 50, 90, 1);
    background-color: rgba(255, 50, 90, var(--tw-bg-opacity));
  }
  .bg-secondary{
    --tw-bg-opacity: 1;
    background-color: rgba(242, 150, 32, 1);
    background-color: rgba(242, 150, 32, var(--tw-bg-opacity));
  }
  .object-cover{
    object-fit: cover;
  }
  .px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }
  .px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }
  .px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .px-\\[2px\\]{
    padding-left: 2px;
    padding-right: 2px;
  }
  .px-\\[3px\\]{
    padding-left: 3px;
    padding-right: 3px;
  }
  .px-\\[8px\\]{
    padding-left: 8px;
    padding-right: 8px;
  }
  .py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .py-\\[10px\\]{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .py-\\[110px\\]{
    padding-top: 110px;
    padding-bottom: 110px;
  }
  .py-\\[2px\\]{
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .py-\\[3px\\]{
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .py-\\[60px\\]{
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .py-\\[6px\\]{
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .pb-10{
    padding-bottom: 2.5rem;
  }
  .pb-12{
    padding-bottom: 3rem;
  }
  .pb-2{
    padding-bottom: 0.5rem;
  }
  .pb-20{
    padding-bottom: 5rem;
  }
  .pb-3{
    padding-bottom: 0.75rem;
  }
  .pb-4{
    padding-bottom: 1rem;
  }
  .pb-6{
    padding-bottom: 1.5rem;
  }
  .pb-8{
    padding-bottom: 2rem;
  }
  .pb-\\[10px\\]{
    padding-bottom: 10px;
  }
  .pb-\\[2rem\\]{
    padding-bottom: 2rem;
  }
  .pb-\\[90px\\]{
    padding-bottom: 90px;
  }
  .pl-0{
    padding-left: 0px;
  }
  .pl-1{
    padding-left: 0.25rem;
  }
  .pl-2{
    padding-left: 0.5rem;
  }
  .pl-3{
    padding-left: 0.75rem;
  }
  .pl-4{
    padding-left: 1rem;
  }
  .pl-6{
    padding-left: 1.5rem;
  }
  .pr-1{
    padding-right: 0.25rem;
  }
  .pr-2{
    padding-right: 0.5rem;
  }
  .pr-3{
    padding-right: 0.75rem;
  }
  .pr-4{
    padding-right: 1rem;
  }
  .pr-\\[5px\\]{
    padding-right: 5px;
  }
  .pr-\\[90px\\]{
    padding-right: 90px;
  }
  .pt-0{
    padding-top: 0px;
  }
  .pt-1{
    padding-top: 0.25rem;
  }
  .pt-10{
    padding-top: 2.5rem;
  }
  .pt-12{
    padding-top: 3rem;
  }
  .pt-2{
    padding-top: 0.5rem;
  }
  .pt-3{
    padding-top: 0.75rem;
  }
  .pt-4{
    padding-top: 1rem;
  }
  .pt-5{
    padding-top: 1.25rem;
  }
  .pt-6{
    padding-top: 1.5rem;
  }
  .pt-8{
    padding-top: 2rem;
  }
  .pt-\\[1rem\\]{
    padding-top: 1rem;
  }
  .pt-\\[2px\\]{
    padding-top: 2px;
  }
  .pt-\\[60px\\]{
    padding-top: 60px;
  }
  .pt-\\[6px\\]{
    padding-top: 6px;
  }
  .pt-\\[6rem\\]{
    padding-top: 6rem;
  }
  .text-left{
    text-align: left;
  }
  .text-center{
    text-align: center;
  }
  .text-\\[14px\\]{
    font-size: 14px;
  }
  .text-\\[16px\\]{
    font-size: 16px;
  }
  .text-\\[18px\\]{
    font-size: 18px;
  }
  .text-\\[20px\\]{
    font-size: 20px;
  }
  .text-\\[24px\\]{
    font-size: 24px;
  }
  .text-\\[34px\\]{
    font-size: 34px;
  }
  .font-bold{
    font-weight: 700;
  }
  .font-medium{
    font-weight: 500;
  }
  .font-semibold{
    font-weight: 600;
  }
  .text-nu1{
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
  .text-nu14{
    --tw-text-opacity: 1;
    color: rgba(182, 182, 182, 1);
    color: rgba(182, 182, 182, var(--tw-text-opacity));
  }
  .text-nu2{
    --tw-text-opacity: 1;
    color: rgba(15, 15, 15, 1);
    color: rgba(15, 15, 15, var(--tw-text-opacity));
  }
  .text-nu3{
    --tw-text-opacity: 1;
    color: rgba(0, 17, 0, 1);
    color: rgba(0, 17, 0, var(--tw-text-opacity));
  }
  .text-nu9{
    --tw-text-opacity: 1;
    color: rgba(135, 139, 149, 1);
    color: rgba(135, 139, 149, var(--tw-text-opacity));
  }
  .text-primary{
    --tw-text-opacity: 1;
    color: rgba(255, 50, 90, 1);
    color: rgba(255, 50, 90, var(--tw-text-opacity));
  }
  .text-secondary{
    --tw-text-opacity: 1;
    color: rgba(242, 150, 32, 1);
    color: rgba(242, 150, 32, var(--tw-text-opacity));
  }
  .shadow{
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  }
  .outline-none{
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .outline{
    outline-style: solid;
  }
  .blur{
    --tw-blur: blur(8px);
    filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .invert{
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) invert(100%) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .filter{
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .transition{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .duration-500{
    transition-duration: 500ms;
  }
  .duration-700{
    transition-duration: 700ms;
  }
  .ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  @media (min-width: 576px){
    table thead tr th:first-of-type{
      border-top-left-radius: 0.5rem;
    }
    table thead tr th:last-of-type{
      border-top-right-radius: 0.5rem;
    }
    table tbody tr:last-of-type td:first-of-type{
      border-bottom-left-radius: 0.5rem;
    }
    table tbody tr:last-of-type td:last-of-type{
      border-bottom-right-radius: 0.5rem;
    }
  }
  td {
      vertical-align: middle !important;
    }
  input[type=date]::-webkit-inner-spin-button,
    input[type=date]::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }
  * {
      -webkit-tap-highlight-color: transparent;
    }
  input:checked + div{
    --tw-border-opacity: 1;
    border-color: rgba(255, 50, 90, 1);
    border-color: rgba(255, 50, 90, var(--tw-border-opacity));
  }
  input:checked + div svg{
    display: block;
  }
  body {
      font-family: "Outfit", sans-serif;
      color: #050505;
      margin: 0;
      padding: 0;
      line-height: 160%;
      font-size: 16px;
      overflow-y: scroll;
    }
  ::-webkit-scrollbar {
    width: 6px;
  }
  
  ::-webkit-scrollbar-track {
    background-color: #263e26;
    border-radius: 80px;
  }
  
  ::-webkit-scrollbar-thumb {
    border-radius: 80px;
    background: #F29620;
  }
  
  section,
  footer {
    overflow: hidden;
    overflow-x: hidden;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  ul,
  ol {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  ul li,
  ol li {
    font-size: inherit;
    font-weight: inherit;
  }
  
  button {
    border: none;
    cursor: pointer;
    font-size: 18px;
    line-height: 150%;
    padding: 0;
    background-color: transparent;
  }
  
  input,
  textarea {
    padding: 12px 20px;
    width: 100%;
    outline-color: transparent;
    font-size: 16px;
    border-radius: 10px;
    background-color: transparent;
    border: 1px solid #B3B6B9;
  }
  input::placeholder,
  textarea::placeholder {
    color: #F5F5DC;
    font-size: 16px;
  }
  
  .d-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .max-auto {
    max-width: 100%;
  }
  
  .max-un {
    max-width: none;
    max-width: initial;
  }
  
  .d-rtl {
    direction: rtl;
  }
  
  .v-line::before {
    position: absolute;
    content: "";
    width: 1px;
    height: 40px;
    background-color: #222;
  }
  .v-line.lg::before{
    height: 60px;
    width: 0.125rem;
    opacity: 0.4;
  }
  @media (min-width: 992px){
    .v-line.lg::before{
      height: 60px;
    }
  }
  .v-line.lgx::before{
    height: 173px;
    width: 1px;
    --tw-bg-opacity: 1;
    background-color: rgba(179, 182, 185, 1);
    background-color: rgba(179, 182, 185, var(--tw-bg-opacity));
    opacity: 0.3;
  }
  .v-line.lg2::before {
    height: 17px;
    padding: 1px;
    background-color: rgba(var(--s2), 1) !important;
  }
  .v-line.xl::before {
    background-color: rgb(var(--p7)) !important;
    height: 15px;
  }
  .v-line.sm::before {
    height: 25px;
  }
  .v-line.smx::before {
    width: 1px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
  }
  .v-line.dashed::before {
    border-right: 1px dashed rgb(var(--n5));
    background: transparent;
  }
  
  iframe {
    border: 0;
    width: 100%;
  }
  
  .display-4 {
    line-height: 120% !important;
  }
  
  .tabcontents {
    position: relative;
  }
  
  .nav-links {
    transition: 0.5s linear;
  }
  .nav-links.active {
    background-color: #282828;
  }
  
  .tabitem {
    transform: translateY(100px);
    position: absolute;
    z-index: -1;
    top: 0;
    width: 100%;
    opacity: 0;
    transition: 0.5s all;
  }
  
  .tabitem.active {
    position: static;
    position: initial;
    z-index: 1;
    opacity: 1;
    transform: translateY(0);
  }
  
  .styleshadow:hover {
    box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.08);
    transform: scale(1.05);
    z-index: 10;
  }
  
  .table-style table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border-top: 1px solid #1E2132;
    min-width: 768px;
  }
  .table-style tr {
    border-bottom: 1px solid #1E2132;
  }
  
  .max-unset {
    max-width: none;
    max-width: initial;
  }
  
  .accordion-single {
    transition: 0.5s linear;
  }
  .accordion-single.active .accordion-btn {
    transition: 0.5s linear;
  }
  .accordion-single.active .arrowclickable {
    transform: rotate(180deg);
    transition: 0.5s linear;
  }
  .accordion-single.active .arrowclickable .ph-plus {
    display: none;
  }
  .accordion-single.active .arrowclickable .ph-minus {
    display: block;
  }
  .accordion-single .arrowclickable {
    transition: 0.5s linear;
  }
  
  .trapezoid{
    width: 225px;
    border-top-width: 60px;
    --tw-border-opacity: 1;
    border-color: rgba(40, 40, 40, 1);
    border-color: rgba(40, 40, 40, var(--tw-border-opacity));
  }
  
  @media (min-width: 576px){
    .trapezoid{
      width: 325px;
      border-top-width: 80px;
    }
  }
  
  .trapezoid {
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    margin: 0 auto;
  }
  
  .btnstyle {
    position: relative;
    display: inline-block;
    background: transparent;
    transition: linear 0.6s;
  }
  .btnstyle:hover {
    box-shadow: inset 0 160px 0 0 #263e26;
  }
  .btnstyle.active {
    box-shadow: inset 0 160px 0 0 #263e26;
  }
  
  .common_area, .common_area2, .common_area3, .common_area4 {
    transform: translateY(-500px);
    transition: 0.6s linear;
  }
  .common_area.show, .common_area2.show, .common_area3.show, .common_area4.show {
    transform: translateY(0);
  }
  
  .common_areaname, .common_areaname2, .common_areaname3, .common_areaname4 {
    transform: translateY(0);
    transition: 0.6s linear;
  }
  .common_areaname.show, .common_areaname2.show, .common_areaname3.show, .common_areaname4.show {
    transform: translateY(90px);
  }
  
  input,
  textarea {
    padding: 12px 20px;
    width: 100%;
    outline-color: transparent;
    font-size: 16px;
    border-radius: 10px;
    background-color: transparent;
    border: 1px solid #B3B6B9;
  }
  input::placeholder,
  textarea::placeholder {
    color: #F5F5DC;
    font-size: 16px;
  }
  
  /*################# css contents #################*/
  /*################################################*/
  /*=============== 1. preloader section stat ===============*/
  /* Preloader start */
  body {
    overflow: hidden;
  }
  
  #preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000000;
    z-index: 9999 !important;
  }
  
  #status {
    width: 200px;
    height: 200px;
    position: absolute;
    left: 50%;
    top: 50%;
    background-repeat: no-repeat;
    background-position: center;
    margin: -100px 0 0 -100px;
  }
  
  /* progress bar start */
  :root {
    --progress-bar-width: 100px;
    --progress-bar-height: 100px;
  }
  
  .circular-progress {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .inner-circle {
    position: absolute;
    width: calc(100px - 20px);
    width: calc(var(--progress-bar-width) - 20px);
    height: calc(100px - 20px);
    height: calc(var(--progress-bar-height) - 20px);
    border-radius: 50%;
    background-color: #000000;
  }
  
  .percentage {
    position: relative;
    font-size: 20px;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.8);
  }
  
  /* Preloader end */
  /*=============== preloader section end ===============*/
  /*################# home page start #################*/
  /*=============== 2. header section stat ===============*/
  .header-section .header {
    z-index: 999 !important;
  }
  .header-section .header .dropdown-content {
    display: none;
    position: absolute;
    background-color: #263e26;
    min-width: 160px;
  }
  .header-section .header .dropdown-content a {
    float: none;
    color: white;
    padding: 7px 16px;
    display: block;
  }
  .header-section .header .dropdown-content a:hover {
    background-color: #263e26;
    color: white;
    transition: 0.8s;
  }
  .header-section .header .dropdown:hover .dropdown-content {
    display: block;
    transition: 0.8s;
  }
  .header-section .header .sidenav {
    height: 80%;
    width: 100%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    overflow-x: hidden;
    padding-top: 20px;
    margin-top: 4rem;
  }
  .header-section .header .sidenav a:hover,
  .header-section .header .dropdown-btn:hover {
    color: #f1f1f1;
  }
  .header-section .header .active {
    color: white;
  }
  .header-section .header .dropdown-container {
    display: none;
  }
  .header-section .header .nav-item a {
    color: white;
  }
  .header-section .header .nav-item.active a {
    color: #ff325a;
  }
  .header-section .header .sidepanel {
    width: 0;
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    overflow-x: hidden;
    transition: 0.5s;
    height: 100vh;
    background-color: #13181f;
  }
  .header-section .header .openbtn {
    display: block;
  }
  .header-section .header .open {
    display: block;
    width: 440px;
    height: 100vh;
  }
  .header-section .header {
    position: fixed;
    z-index: 1000;
    height: 85px;
    width: 100%;
    transition: all ease-out 0.5s;
  }
  .header-section .activetwo {
    background-color: #263e26;
  }
  .header-section .beforeAfter::before {
    content: "";
    display: block;
    width: 40px;
    height: 2px;
    background-color: #878b95;
    position: absolute;
    top: 16px;
    left: 100px;
  }
  .header-section .beforeAfter::after {
    content: "";
    display: block;
    width: 40px;
    height: 2px;
    background-color: #878b95;
    position: absolute;
    top: 16px;
    right: 100px;
  }
  .header-section .ourPartnerSection .container .brand-carouselTwo .swiper-wrapper {
    transition-timing-function: linear !important;
  }
  
  /*=============== header section end ===============*/
  /*=============== 3. hero section nav ber stat ===============*/
  .hero-section .container {
    /* hero photo up down start */
    /* hero photo up down end */
  }
  .hero-section .container .lin {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .hero-section .container img.vert-move {
    animation: mover 2s infinite alternate;
    margin-bottom: -10px;
  }
  @keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }
  .hero-section .dwon-section .brand-carouselOne .swiper-wrapper {
    transition-timing-function: linear !important;
  }
  
  /*=============== hero section nav ber stat ===============*/
  /*=============== 4. Our Games section start ===============*/
  .ourGameSection .container {
    /* swiper slider active start */
    /* swiper slider active end */
  }
  .ourGameSection .container .card2 {
    position: relative;
    border: 5px solid transparent;
    background: #18191f;
    background-clip: padding-box;
    border-radius: 10px;
    z-index: 1;
  }
  .ourGameSection .container .card2::after {
    content: "";
    position: absolute;
    top: -5px;
    bottom: -5px;
    left: -5px;
    right: -5px;
    background: linear-gradient(to bottom right, #22c1c3, #fdbb2d);
    z-index: -1;
    border-radius: 10px;
  }
  .ourGameSection .container .slider-games .swiper-slide-active {
    transform: scale(1.1);
    transition: 1s;
    background-color: #263e26;
  }
  
  /*=============== Our Games section start ===============*/
  /*=============== 5. Explore Game section start ===============*/
  .exploreGame-section .container {
    /*  Explore Game section tab video start */
    /*  Explore Game section tab video end */
  }
  .exploreGame-section .container .tab-block .tab-mnu {
    display: flex;
    flex-direction: column;
    list-style: none;
  }
  .exploreGame-section .container .tab-block .tab-mnu:after {
    content: "";
  }
  .exploreGame-section .container .tab-block .tab-mnu li {
    padding-top: 13px;
    padding-bottom: 13px;
    cursor: pointer;
    border-left: 6px solid #0f0f0f;
  }
  .exploreGame-section .container .tab-block .tab-mnu .active {
    background-color: #263e26;
    border-left: 6px solid #ff325a;
    color: white;
    cursor: pointer;
  }
  
  /*=============== Explore Game section end ===============*/
  /*################# home page start #################*/
  /*################# top trending page start #################*/
  /*=============== 6. top trending section stat ===============*/
  .topTrendingSection .container .topTrend:after {
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    background: linear-gradient(1deg, rgba(3, 3, 4, 0.9) -3.02%, rgba(3, 3, 4, 0) 99.06%);
  }
  .topTrendingSection .container .topTrend1:before {
    content: "";
    display: block;
    position: absolute;
    height: 0%;
    width: 100%;
    bottom: 2px;
    left: 0;
    z-index: 12;
    transition: height 0.5s ease-out;
    border-radius: 24px;
    background: linear-gradient(1deg, rgba(7, 255, 7, 0.555) -3.02%, rgba(3, 3, 4, 0) 99.06%);
  }
  .topTrendingSection .container .topTrend1:hover:before {
    height: 100%;
  }
  
  /*=============== top trending section end ===============*/
  /*################# top trending page start #################*/
  /*################# popular games page start #################*/
  /*=============== 7. popular games section end ===============*/
  .popularGame-section .container {
    /* popular games card before start */
    /* popular games card before start */
  }
  .popularGame-section .container .popularGame {
    background: linear-gradient(1deg, rgba(3, 3, 4, 0.9) -3.02%, rgba(3, 3, 4, 0) 99.06%);
    object-fit: cover;
    position: relative;
  }
  .popularGame-section .container .popularGame:before {
    content: "";
    display: block;
    position: absolute;
    height: 0%;
    width: 100%;
    bottom: 2px;
    left: 0;
    transition: height 0.5s ease-out;
    border-radius: 24px;
    background: linear-gradient(1deg, rgba(7, 255, 7, 0.555) -3.02%, rgba(3, 3, 4, 0) 99.06%);
  }
  .popularGame-section .container .popularGame:hover:before {
    height: 100%;
  }
  
  /*=============== popular games section end ===============*/
  /*################# popular games page start #################*/
  /*################# achievements page end #################*/
  /*=============== 8. achievements section end ===============*/
  .achievements-section .container .buttonAch {
    color: #fff;
    transition: all 0.3s ease;
  }
  .achievements-section .container .buttonAch:focus {
    animation: clickEffect 0.3s ease forwards;
    transform: scale(0.9);
  }
  .achievements-section .container .buttonAch.active {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    color: white;
  }
  
  /*=============== achievements section end ===============*/
  /*################# achievements page end #################*/
  /*################# achievements introduction page start #################*/
  /*=============== 9. achievements introduction section stat ===============*/
  .introductionStartSection .container .bttsx:hover {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    transition: 0.8s;
    border-radius: 50px;
  }
  
  /*=============== achievements introduction section stat ===============*/
  /*=============== 10. achievements introduction faq section stat ===============*/
  .achievementFaq .container .header-area {
    padding: 10px 0;
    cursor: pointer;
  }
  .achievementFaq .container .active .header-area .btnfrv {
    display: none;
  }
  .achievementFaq .container .content-area {
    display: none;
  }
  .achievementFaq .container .active .header-area .btnfadd {
    display: block;
  }
  .achievementFaq .container .active .header-area .btnfadd i {
    color: #ff325a;
  }
  .achievementFaq .container .active .header-area .text {
    color: #ff325a;
  }
  
  /*=============== achievements introduction faq section end ===============*/
  /*################# achievements introduction page end #################*/
  /*################# bounty page end #################*/
  /*=============== 11. bounty bred crumb section section start ===============*/
  .bounty-bredCrumb {
    background: linear-gradient(180deg, rgba(19, 18, 18, 0.78) 25.81%, rgba(20, 20, 20, 0.88) 63.99%, #0f0f0f 100%), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
    object-fit: cover;
  }
  
  /*=============== bounty bred crumb section section start ===============*/
  /*################# bounty page end #################*/
  /*################# bred crumb start #################*/
  /*=============== 12. bred crumb section section start ===============*/
  .bred-crumb {
    background: linear-gradient(91deg, rgba(6, 7, 7, 0.753) 0.97%, rgba(2, 2, 2, 0.897) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
    object-fit: cover;
    width: 100%;
    height: 100%;
    background-color: #0f0f0f;
  }
  
  /*=============== bred crumb section section end ===============*/
  /*################# bred crumb end #################*/
  .navbar-inverse.menu ul li a {
    background: transparent;
  }
  
  .navbar-inverse.menu ul li a:hover,
  .navbar-inverse.menu ul li a.active,
  .navbar-inverse.menu ul li a.active:hover {
    color: #ff325a;
  }
  
  /*=============== 13. global style start ===============*/
  /* our games section pagination start */
  .pageHead {
    width: 100%;
    height: 1px;
    background-color: #ff325a;
  }
  .pageHead .swiper-pagination-bullet {
    width: 140px;
    height: 4px;
    background-color: #ff325a;
    border-radius: 0px;
  }
  
  .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    width: 100%;
    margin-top: -6px;
  }
  
  .swiper-pagination {
    position: relative;
  }
  
  /* our games section pagination end */
  /* hero infinity round image tag animation css start */
  @keyframes rotate-full {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  @keyframes infinite-spinning {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }
  .animated .infinite {
    animation-iteration-count: infinite;
  }
  
  .box1 {
    border-radius: 100%;
    object-fit: cover;
    transform: rotate(0deg);
  }
  .box1 img {
    border-radius: 100%;
    object-fit: cover;
  }
  
  .rotate {
    animation: rotation-full 5s infinite linear;
  }
  
  .rotate-full {
    animation: infinite-spinning 16s infinite linear;
  }
  
  /* hero infinity round image tag animation css end */
  /* card button start */
  .salBa-area .salBa {
    padding: 2px;
    border: 2px solid #e1e500;
    border: dotted;
  }
  
  /* card button end */
  /* global button style start */
  .buttonx {
    border-radius: 50px;
    cursor: pointer;
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    transition: all 0.5s ease;
  }
  
  .buttonx:hover {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    color: #0f0f0f;
    box-shadow: #ff325a 0px 7px 29px 0px;
  }
  
  /* global button style end */
  /* img zoom in zoom out start */
  .img-box {
    overflow: hidden;
  }
  
  .img {
    background-size: cover;
    transition: all 1s ease;
  }
  
  .img:hover {
    transform: scale(1.1, 1.1);
  }
  
  /* img zoom in zoom out end */
  /* Newsletter hidden start */
  .globl {
    overflow: hidden;
  }
  
  /* Newsletter hidden end */
  /* swiper slider active start */
  .slider-researches .swiper-slide-active {
    border: 2px solid #f29620;
    transition: 1s;
    background-color: #263e26;
  }
  
  /* swiper slider active end */
  /* bounty section card & color hover start */
  .bounty-section:hover .bounty-area .bounty i {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: 0.8s;
  }
  
  .bounty-section:hover .bounty-areax .bountyx i {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: 1s;
  }
  
  .bounty-section:hover .butt-area .butt {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    box-shadow: #29171a 0px 7px 29px 0px;
    color: white;
  }
  
  .bounty-section:hover .num {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    box-shadow: #1f1013 0px 7px 29px 0px;
    color: white;
  }
  
  /* bounty section card & color hover end */
  /* tab style active start */
  .tab-btn:hover {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    box-shadow: #29171a 0px 7px 29px 0px;
    color: white;
  }
  
  .tab-btn.active {
    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);
    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));
    box-shadow: #29171a 0px 7px 29px 0px;
    color: white;
  }
  
  .content {
    display: none;
  }
  
  .content.show {
    display: flex;
  }
  
  /* tab style active end */
  /* tab propup start */
  .white-popup {
    position: relative;
    width: auto;
    max-width: 500px;
    margin: 0 auto;
  }
  
  .mfp-zoom-in .mfp-with-anim {
    opacity: 0;
    transition: all 0.2s ease-in-out;
    transform: scale(0.8);
  }
  .mfp-zoom-in.mfp-bg {
    opacity: 0;
    transition: all 0.3s ease-out;
  }
  .mfp-zoom-in.mfp-ready .mfp-with-anim {
    opacity: 1;
    transform: scale(1);
  }
  .mfp-zoom-in.mfp-ready.mfp-bg {
    opacity: 0.8;
  }
  .mfp-zoom-in.mfp-removing .mfp-with-anim {
    transform: scale(0.8);
    opacity: 0;
  }
  .mfp-zoom-in.mfp-removing.mfp-bg {
    opacity: 0;
  }
  
  @keyframes hinge {
    0% {
      transform: rotate(0);
      transform-origin: top left;
      animation-timing-function: ease-in-out;
    }
    20%, 60% {
      transform: rotate(80deg);
      transform-origin: top left;
      animation-timing-function: ease-in-out;
    }
    40% {
      transform: rotate(60deg);
      transform-origin: top left;
      animation-timing-function: ease-in-out;
    }
    80% {
      transform: rotate(60deg) translateY(0);
      opacity: 1;
      transform-origin: top left;
      animation-timing-function: ease-in-out;
    }
    100% {
      transform: translateY(700px);
      opacity: 0;
    }
  }
  .hinge {
    animation-duration: 1s;
    animation-name: hinge;
  }
  
  .mfp-with-fade .mfp-content, .mfp-with-fade.mfp-bg {
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }
  .mfp-with-fade.mfp-ready .mfp-content {
    opacity: 1;
  }
  .mfp-with-fade.mfp-ready.mfp-bg {
    opacity: 0.8;
  }
  .mfp-with-fade .mfp-close {
    color: white;
  }
  .mfp-with-fade.mfp-removing.mfp-bg {
    opacity: 0;
  }
  
  table {
    border-collapse: collapse;
    width: 100%;
    border-spacing: 0;
  }
  
  th,
  td {
    text-align: left;
    padding: 8px;
  }
  
  /* tab propup end */
  /* Gamefi Index card sing in start */
  .beforeX::before {
    content: "";
    display: block;
    width: 40px;
    height: 2px;
    background-color: #878b95;
    position: absolute;
    top: 26px;
    left: 100px;
  }
  
  .beforeX::after {
    content: "";
    display: block;
    width: 40px;
    height: 2px;
    background-color: #878b95;
    position: absolute;
    top: 26px;
    right: 100px;
  }
  
  /* Gamefi Index card sing in end */
  /* Wallet start */
  .beforeWal::before {
    content: "";
    display: block;
    width: 40px;
    height: 2px;
    background-color: #878b95;
    position: absolute;
    top: 34px;
    left: 20px;
  }
  
  .beforeWal::after {
    content: "";
    display: block;
    width: 40px;
    height: 2px;
    background-color: #878b95;
    position: absolute;
    top: 34px;
    right: 20px;
  }
  
  /* Wallet end */
  /* tab start */
  .tab__list {
    display: flex;
  }
  .tab__item:before {
    content: "";
    position: absolute;
    top: 95%;
    left: 0;
    height: 2px;
    width: 100%;
    background: #ff325a;
    transition: 0.2s;
    visibility: hidden;
    opacity: 0;
  }
  .tab__item.is--active {
    color: white;
    position: relative;
  }
  .tab__item.is--active:before {
    visibility: visible;
    opacity: 1;
  }
  .tab__content-item {
    display: none;
  }
  .tab__content-item.is--active {
    display: block;
  }
  
  /* tab end */
  /* footer Benefit hover color start */
  .icons {
    opacity: 0;
    transition: 1s;
  }
  
  .arrIcon:hover .icons {
    opacity: 100;
    color: #ff325a;
    transition: 1s;
  }
  
  /* footer Benefit hover color end */
  /*=============== global style end ===============*/
  /*=============== 14. responsive start ===============*/
  @media screen and (max-width: 992px) {
    .header-section .header .container #mobile-menu {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background: #263e26;
      transform: translateX(-100%);
      transition: transform 0.3s ease-in-out;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .header-section .header .container #mobile-menu.show-menu {
      transform: translateX(0%);
    }
    .header-section .header .container #hamburger-cross {
      display: block;
      color: white;
      cursor: pointer;
      font-size: 40px;
      position: absolute;
      top: 20px;
      right: 26px;
    }
    .header-section .header .container #hamburger-menu {
      display: block;
      color: white;
      cursor: pointer;
      font-size: 24px;
    }
    .header-section .header .container .dropdown-content {
      min-width: 220px;
      margin-left: 12rem;
      margin-top: -3rem;
      text-align: center;
      background-color: red;
    }
    .ourGameSection .container .pageHead {
      width: 100%;
      height: 1px;
      background-color: #ff325a;
    }
    .ourGameSection .container .pageHead .swiper-pagination-bullet {
      width: 20%;
      height: 4px;
      background-color: #ff325a;
      border-radius: 0px;
    }
    .ourGameSection .container .swiper-pagination-bullets,
    .ourGameSection .container .swiper-pagination-bullets.swiper-pagination-horizontal,
    .ourGameSection .container .swiper-pagination-custom,
    .ourGameSection .container .swiper-pagination-fraction {
      width: 100%;
      margin-top: -6px;
    }
    .ourGameSection .container .swiper-pagination {
      position: relative;
    }
    .leadTabel {
      overflow-x: scroll;
      width: 90rem;
    }
    .leadTabely {
      overflow-x: scroll;
      width: 60rem;
    }
    .leadTabelx {
      overflow-x: scroll;
      width: 30rem;
    }
  }
  @media (max-width: 768px) {
    .pageHead {
      width: 100%;
      height: 1px;
      background-color: #ff325a;
    }
    .pageHead .swiper-pagination-bullet {
      width: 80px;
      height: 4px;
      background-color: #ff325a;
      border-radius: 0px;
    }
    .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      width: 100%;
      margin-top: -6px;
    }
    .swiper-pagination {
      position: relative;
    }
  }
  @media screen and (max-width: 576px) {
    .icon4 {
      margin-top: 0;
    }
  }
  @media screen and (max-width: 568px) {
    .icon1 {
      margin-top: 0;
    }
    .icon2 {
      margin-top: 0;
    }
    .icon3 {
      margin-top: 0;
    }
  }
  @media (max-width: 500px) {
    .navHero-section .header .beforeAfter::before {
      content: "";
      display: block;
      width: 40px;
      height: 2px;
      background-color: #878b95;
      position: absolute;
      top: 12px;
      left: 60px;
    }
    .navHero-section .header .beforeAfter::after {
      content: "";
      display: block;
      width: 40px;
      height: 2px;
      background-color: #878b95;
      position: absolute;
      top: 12px;
      right: 60px;
    }
    .pageHead {
      width: 100%;
      height: 1px;
      background-color: #ff325a;
    }
    .pageHead .swiper-pagination-bullet {
      width: 20px;
      height: 4px;
      background-color: #ff325a;
      border-radius: 0px;
    }
    .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      width: 100%;
      margin-top: -6px;
    }
    .swiper-pagination {
      position: relative;
    }
  }
  @media screen and (max-width: 472px) {
    .icon3 {
      margin-top: 2rem;
    }
  }
  @media screen and (max-width: 408px) {
    .icon2 {
      margin-top: 2rem;
    }
  }
  @media screen and (max-width: 344px) {
    .icon4 {
      margin-top: 1rem;
    }
  }
  @media screen and (max-width: 342px) {
    .icon1 {
      margin-top: 2rem;
    }
  }
  /*=============== responsive end ===============*/
  .placeholder\\:text-nu1::placeholder{
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
  .before\\:absolute::before{
    content: var(--tw-content);
    position: absolute;
  }
  .before\\:-right-4::before{
    content: var(--tw-content);
    right: -1rem;
  }
  .before\\:-top-44::before{
    content: var(--tw-content);
    top: -11rem;
  }
  .before\\:h-28::before{
    content: var(--tw-content);
    height: 7rem;
  }
  .before\\:w-28::before{
    content: var(--tw-content);
    width: 7rem;
  }
  .before\\:rounded-full::before{
    content: var(--tw-content);
    border-radius: 9999px;
  }
  .before\\:border-8::before{
    content: var(--tw-content);
    border-width: 8px;
  }
  .before\\:bg-transparent::before{
    content: var(--tw-content);
    background-color: transparent;
  }
  .before\\:opacity-50::before{
    content: var(--tw-content);
    opacity: 0.5;
  }
  .before\\:blur-none::before{
    content: var(--tw-content);
    --tw-blur: blur(0);
    filter: blur(0) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .before\\:duration-700::before{
    content: var(--tw-content);
    transition-duration: 700ms;
  }
  .hover\\:ml-0:hover{
    margin-left: 0px;
  }
  .hover\\:border-2:hover{
    border-width: 2px;
  }
  .hover\\:border-primary:hover{
    --tw-border-opacity: 1;
    border-color: rgba(255, 50, 90, 1);
    border-color: rgba(255, 50, 90, var(--tw-border-opacity));
  }
  .hover\\:border-secondary:hover{
    --tw-border-opacity: 1;
    border-color: rgba(242, 150, 32, 1);
    border-color: rgba(242, 150, 32, var(--tw-border-opacity));
  }
  .hover\\:bg-nu10:hover{
    --tw-bg-opacity: 1;
    background-color: rgba(15, 39, 15, 1);
    background-color: rgba(15, 39, 15, var(--tw-bg-opacity));
  }
  .hover\\:bg-nu11:hover{
    --tw-bg-opacity: 1;
    background-color: rgba(43, 22, 28, 1);
    background-color: rgba(43, 22, 28, var(--tw-bg-opacity));
  }
  .hover\\:bg-nu13:hover{
    --tw-bg-opacity: 1;
    background-color: rgba(18, 38, 30, 1);
    background-color: rgba(18, 38, 30, var(--tw-bg-opacity));
  }
  .hover\\:bg-nu5:hover{
    --tw-bg-opacity: 1;
    background-color: rgba(38, 62, 38, 1);
    background-color: rgba(38, 62, 38, var(--tw-bg-opacity));
  }
  .hover\\:bg-primary:hover{
    --tw-bg-opacity: 1;
    background-color: rgba(255, 50, 90, 1);
    background-color: rgba(255, 50, 90, var(--tw-bg-opacity));
  }
  .hover\\:bg-secondary:hover{
    --tw-bg-opacity: 1;
    background-color: rgba(242, 150, 32, 1);
    background-color: rgba(242, 150, 32, var(--tw-bg-opacity));
  }
  .hover\\:text-primary:hover{
    --tw-text-opacity: 1;
    color: rgba(255, 50, 90, 1);
    color: rgba(255, 50, 90, var(--tw-text-opacity));
  }
  .hover\\:text-secondary:hover{
    --tw-text-opacity: 1;
    color: rgba(242, 150, 32, 1);
    color: rgba(242, 150, 32, var(--tw-text-opacity));
  }
  .hover\\:underline:hover{
    text-decoration-line: underline;
  }
  .hover\\:duration-500:hover{
    transition-duration: 500ms;
  }
  .hover\\:duration-700:hover{
    transition-duration: 700ms;
  }
  .group:hover .group-hover\\:bg-primary{
    --tw-bg-opacity: 1;
    background-color: rgba(255, 50, 90, 1);
    background-color: rgba(255, 50, 90, var(--tw-bg-opacity));
  }
  .group:hover .group-hover\\:before\\:right-44::before{
    content: var(--tw-content);
    right: 11rem;
  }
  .group:hover .group-hover\\:before\\:top-28::before{
    content: var(--tw-content);
    top: 7rem;
  }
  .group:hover .group-hover\\:before\\:scale-125::before{
    content: var(--tw-content);
    --tw-scale-x: 1.25;
    --tw-scale-y: 1.25;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .group:hover .group-hover\\:before\\:blur::before{
    content: var(--tw-content);
    --tw-blur: blur(8px);
    filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  @media not all and (min-width: 1296px){
    .max-2xl\\:flex-wrap{
      flex-wrap: wrap;
    }
  }
  @media not all and (min-width: 1200px){
    .max-xl\\:flex-wrap{
      flex-wrap: wrap;
    }
  }
  @media not all and (min-width: 992px){
    .max-lg\\:flex-wrap{
      flex-wrap: wrap;
    }
  }
  @media not all and (min-width: 768px){
    .max-md\\:flex-col{
      flex-direction: column;
    }
    .max-md\\:flex-wrap{
      flex-wrap: wrap;
    }
  }
  @media not all and (min-width: 576px){
    .max-sm\\:flex-col{
      flex-direction: column;
    }
    .max-sm\\:flex-wrap{
      flex-wrap: wrap;
    }
  }
  @media (min-width: 576px){
    .sm\\:col-span-1{
      grid-column: span 1 / span 1;
    }
    .sm\\:col-span-10{
      grid-column: span 10 / span 10;
    }
    .sm\\:col-span-3{
      grid-column: span 3 / span 3;
    }
    .sm\\:col-span-4{
      grid-column: span 4 / span 4;
    }
    .sm\\:col-span-6{
      grid-column: span 6 / span 6;
    }
    .sm\\:col-span-8{
      grid-column: span 8 / span 8;
    }
    .sm\\:m-0{
      margin: 0px;
    }
    .sm\\:mx-0{
      margin-left: 0px;
      margin-right: 0px;
    }
    .sm\\:my-0{
      margin-top: 0px;
      margin-bottom: 0px;
    }
    .sm\\:my-10{
      margin-top: 2.5rem;
      margin-bottom: 2.5rem;
    }
    .sm\\:-mt-0{
      margin-top: -0px;
    }
    .sm\\:-mt-4{
      margin-top: -1rem;
    }
    .sm\\:-mt-7{
      margin-top: -1.75rem;
    }
    .sm\\:-mt-\\[60px\\]{
      margin-top: -60px;
    }
    .sm\\:mb-4{
      margin-bottom: 1rem;
    }
    .sm\\:mb-6{
      margin-bottom: 1.5rem;
    }
    .sm\\:ml-2{
      margin-left: 0.5rem;
    }
    .sm\\:ml-\\[26rem\\]{
      margin-left: 26rem;
    }
    .sm\\:mt-0{
      margin-top: 0px;
    }
    .sm\\:mt-10{
      margin-top: 2.5rem;
    }
    .sm\\:mt-16{
      margin-top: 4rem;
    }
    .sm\\:mt-3{
      margin-top: 0.75rem;
    }
    .sm\\:mt-4{
      margin-top: 1rem;
    }
    .sm\\:mt-6{
      margin-top: 1.5rem;
    }
    .sm\\:mt-8{
      margin-top: 2rem;
    }
    .sm\\:mt-\\[20px\\]{
      margin-top: 20px;
    }
    .sm\\:mt-\\[2rem\\]{
      margin-top: 2rem;
    }
    .sm\\:mt-\\[30px\\]{
      margin-top: 30px;
    }
    .sm\\:inline-block{
      display: inline-block;
    }
    .sm\\:flex{
      display: flex;
    }
    .sm\\:h-\\[250px\\]{
      height: 250px;
    }
    .sm\\:h-\\[40px\\]{
      height: 40px;
    }
    .sm\\:w-\\[30\\%\\]{
      width: 30%;
    }
    .sm\\:w-\\[300px\\]{
      width: 300px;
    }
    .sm\\:w-\\[40px\\]{
      width: 40px;
    }
    .sm\\:w-auto{
      width: auto;
    }
    .sm\\:justify-normal{
      justify-content: normal;
    }
    .sm\\:justify-start{
      justify-content: flex-start;
    }
    .sm\\:gap-6{
      gap: 1.5rem;
    }
    .sm\\:gap-8{
      gap: 2rem;
    }
    .sm\\:px-10{
      padding-left: 2.5rem;
      padding-right: 2.5rem;
    }
    .sm\\:px-14{
      padding-left: 3.5rem;
      padding-right: 3.5rem;
    }
    .sm\\:px-20{
      padding-left: 5rem;
      padding-right: 5rem;
    }
    .sm\\:px-3{
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
    .sm\\:px-4{
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .sm\\:px-6{
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
    .sm\\:px-8{
      padding-left: 2rem;
      padding-right: 2rem;
    }
    .sm\\:px-\\[10px\\]{
      padding-left: 10px;
      padding-right: 10px;
    }
    .sm\\:px-\\[12px\\]{
      padding-left: 12px;
      padding-right: 12px;
    }
    .sm\\:px-\\[17px\\]{
      padding-left: 17px;
      padding-right: 17px;
    }
    .sm\\:px-\\[20px\\]{
      padding-left: 20px;
      padding-right: 20px;
    }
    .sm\\:px-\\[8px\\]{
      padding-left: 8px;
      padding-right: 8px;
    }
    .sm\\:py-1{
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    .sm\\:py-10{
      padding-top: 2.5rem;
      padding-bottom: 2.5rem;
    }
    .sm\\:py-16{
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
    .sm\\:py-2{
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .sm\\:py-3{
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    .sm\\:py-4{
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
    .sm\\:py-6{
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
    }
    .sm\\:py-8{
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
    .sm\\:py-\\[180px\\]{
      padding-top: 180px;
      padding-bottom: 180px;
    }
    .sm\\:py-\\[20px\\]{
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .sm\\:py-\\[30px\\]{
      padding-top: 30px;
      padding-bottom: 30px;
    }
    .sm\\:py-\\[60px\\]{
      padding-top: 60px;
      padding-bottom: 60px;
    }
    .sm\\:pb-0{
      padding-bottom: 0px;
    }
    .sm\\:pb-10{
      padding-bottom: 2.5rem;
    }
    .sm\\:pb-12{
      padding-bottom: 3rem;
    }
    .sm\\:pb-16{
      padding-bottom: 4rem;
    }
    .sm\\:pb-3{
      padding-bottom: 0.75rem;
    }
    .sm\\:pb-4{
      padding-bottom: 1rem;
    }
    .sm\\:pb-6{
      padding-bottom: 1.5rem;
    }
    .sm\\:pb-8{
      padding-bottom: 2rem;
    }
    .sm\\:pb-\\[30px\\]{
      padding-bottom: 30px;
    }
    .sm\\:pb-\\[60px\\]{
      padding-bottom: 60px;
    }
    .sm\\:pl-0{
      padding-left: 0px;
    }
    .sm\\:pl-2{
      padding-left: 0.5rem;
    }
    .sm\\:pl-4{
      padding-left: 1rem;
    }
    .sm\\:pt-0{
      padding-top: 0px;
    }
    .sm\\:pt-1{
      padding-top: 0.25rem;
    }
    .sm\\:pt-10{
      padding-top: 2.5rem;
    }
    .sm\\:pt-12{
      padding-top: 3rem;
    }
    .sm\\:pt-14{
      padding-top: 3.5rem;
    }
    .sm\\:pt-2{
      padding-top: 0.5rem;
    }
    .sm\\:pt-3{
      padding-top: 0.75rem;
    }
    .sm\\:pt-4{
      padding-top: 1rem;
    }
    .sm\\:pt-6{
      padding-top: 1.5rem;
    }
    .sm\\:pt-8{
      padding-top: 2rem;
    }
    .sm\\:pt-\\[10px\\]{
      padding-top: 10px;
    }
    .sm\\:pt-\\[14px\\]{
      padding-top: 14px;
    }
    .sm\\:pt-\\[20px\\]{
      padding-top: 20px;
    }
    .sm\\:pt-\\[26px\\]{
      padding-top: 26px;
    }
    .sm\\:pt-\\[40px\\]{
      padding-top: 40px;
    }
    .sm\\:pt-\\[60px\\]{
      padding-top: 60px;
    }
    .sm\\:text-left{
      text-align: left;
    }
    .sm\\:text-\\[18px\\]{
      font-size: 18px;
    }
    .sm\\:text-\\[20px\\]{
      font-size: 20px;
    }
    .sm\\:text-\\[24px\\]{
      font-size: 24px;
    }
    .sm\\:text-\\[32px\\]{
      font-size: 32px;
    }
  }
  @media (min-width: 768px){
    .md\\:col-span-12{
      grid-column: span 12 / span 12;
    }
    .md\\:col-span-3{
      grid-column: span 3 / span 3;
    }
    .md\\:col-span-4{
      grid-column: span 4 / span 4;
    }
    .md\\:col-span-5{
      grid-column: span 5 / span 5;
    }
    .md\\:col-span-6{
      grid-column: span 6 / span 6;
    }
    .md\\:col-span-7{
      grid-column: span 7 / span 7;
    }
    .md\\:col-span-9{
      grid-column: span 9 / span 9;
    }
    .md\\:mx-auto{
      margin-left: auto;
      margin-right: auto;
    }
    .md\\:ml-\\[30rem\\]{
      margin-left: 30rem;
    }
    .md\\:mt-0{
      margin-top: 0px;
    }
    .md\\:hidden{
      display: none;
    }
    .md\\:h-\\[300px\\]{
      height: 300px;
    }
    .md\\:h-full{
      height: 100%;
    }
    .md\\:w-full{
      width: 100%;
    }
    .md\\:justify-start{
      justify-content: flex-start;
    }
    .md\\:px-20{
      padding-left: 5rem;
      padding-right: 5rem;
    }
    .md\\:px-28{
      padding-left: 7rem;
      padding-right: 7rem;
    }
    .md\\:px-\\[16px\\]{
      padding-left: 16px;
      padding-right: 16px;
    }
    .md\\:px-\\[20px\\]{
      padding-left: 20px;
      padding-right: 20px;
    }
    .md\\:px-\\[60px\\]{
      padding-left: 60px;
      padding-right: 60px;
    }
    .md\\:py-14{
      padding-top: 3.5rem;
      padding-bottom: 3.5rem;
    }
    .md\\:py-20{
      padding-top: 5rem;
      padding-bottom: 5rem;
    }
    .md\\:py-3{
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    .md\\:py-\\[20px\\]{
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .md\\:py-\\[60px\\]{
      padding-top: 60px;
      padding-bottom: 60px;
    }
    .md\\:pb-20{
      padding-bottom: 5rem;
    }
    .md\\:pb-\\[60px\\]{
      padding-bottom: 60px;
    }
    .md\\:pb-\\[80px\\]{
      padding-bottom: 80px;
    }
    .md\\:pl-0{
      padding-left: 0px;
    }
    .md\\:pl-4{
      padding-left: 1rem;
    }
    .md\\:pt-0{
      padding-top: 0px;
    }
    .md\\:pt-1{
      padding-top: 0.25rem;
    }
    .md\\:pt-20{
      padding-top: 5rem;
    }
    .md\\:pt-\\[50px\\]{
      padding-top: 50px;
    }
    .md\\:pt-\\[60px\\]{
      padding-top: 60px;
    }
    .md\\:text-left{
      text-align: left;
    }
    .md\\:text-\\[20px\\]{
      font-size: 20px;
    }
    .md\\:text-\\[24px\\]{
      font-size: 24px;
    }
    .md\\:text-\\[28px\\]{
      font-size: 28px;
    }
  }
  @media (min-width: 992px){
    .lg\\:col-span-12{
      grid-column: span 12 / span 12;
    }
    .lg\\:col-span-2{
      grid-column: span 2 / span 2;
    }
    .lg\\:col-span-3{
      grid-column: span 3 / span 3;
    }
    .lg\\:col-span-4{
      grid-column: span 4 / span 4;
    }
    .lg\\:col-span-5{
      grid-column: span 5 / span 5;
    }
    .lg\\:col-span-6{
      grid-column: span 6 / span 6;
    }
    .lg\\:col-span-7{
      grid-column: span 7 / span 7;
    }
    .lg\\:col-span-8{
      grid-column: span 8 / span 8;
    }
    .lg\\:mt-8{
      margin-top: 2rem;
    }
    .lg\\:flex{
      display: flex;
    }
    .lg\\:hidden{
      display: none;
    }
    .lg\\:h-\\[300px\\]{
      height: 300px;
    }
    .lg\\:w-\\[300px\\]{
      width: 300px;
    }
    .lg\\:w-auto{
      width: auto;
    }
    .lg\\:items-center{
      align-items: center;
    }
    .lg\\:justify-between{
      justify-content: space-between;
    }
    .lg\\:px-16{
      padding-left: 4rem;
      padding-right: 4rem;
    }
    .lg\\:px-32{
      padding-left: 8rem;
      padding-right: 8rem;
    }
    .lg\\:px-6{
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
    .lg\\:px-\\[120px\\]{
      padding-left: 120px;
      padding-right: 120px;
    }
    .lg\\:py-2{
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .lg\\:py-20{
      padding-top: 5rem;
      padding-bottom: 5rem;
    }
    .lg\\:py-\\[100px\\]{
      padding-top: 100px;
      padding-bottom: 100px;
    }
    .lg\\:py-\\[120px\\]{
      padding-top: 120px;
      padding-bottom: 120px;
    }
    .lg\\:pb-\\[100px\\]{
      padding-bottom: 100px;
    }
    .lg\\:pr-0{
      padding-right: 0px;
    }
    .lg\\:pt-0{
      padding-top: 0px;
    }
    .lg\\:pt-3{
      padding-top: 0.75rem;
    }
    .lg\\:pt-\\[100px\\]{
      padding-top: 100px;
    }
    .lg\\:pt-\\[120px\\]{
      padding-top: 120px;
    }
    .lg\\:pt-\\[8rem\\]{
      padding-top: 8rem;
    }
    .lg\\:text-\\[28px\\]{
      font-size: 28px;
    }
  }
  @media (min-width: 1200px){
    .xl\\:col-span-3{
      grid-column: span 3 / span 3;
    }
    .xl\\:col-span-4{
      grid-column: span 4 / span 4;
    }
    .xl\\:col-span-5{
      grid-column: span 5 / span 5;
    }
    .xl\\:col-span-6{
      grid-column: span 6 / span 6;
    }
    .xl\\:col-span-7{
      grid-column: span 7 / span 7;
    }
    .xl\\:col-span-8{
      grid-column: span 8 / span 8;
    }
    .xl\\:ml-0{
      margin-left: 0px;
    }
    .xl\\:mt-0{
      margin-top: 0px;
    }
    .xl\\:h-full{
      height: 100%;
    }
    .xl\\:w-\\[170px\\]{
      width: 170px;
    }
    .xl\\:w-\\[400px\\]{
      width: 400px;
    }
    .xl\\:justify-center{
      justify-content: center;
    }
    .xl\\:px-24{
      padding-left: 6rem;
      padding-right: 6rem;
    }
    .xl\\:px-3{
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
    .xl\\:px-6{
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
    .xl\\:px-\\[160px\\]{
      padding-left: 160px;
      padding-right: 160px;
    }
    .xl\\:py-2{
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .xl\\:py-3{
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    .xl\\:py-4{
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
    .xl\\:py-\\[100px\\]{
      padding-top: 100px;
      padding-bottom: 100px;
    }
    .xl\\:pl-3{
      padding-left: 0.75rem;
    }
    .xl\\:pl-6{
      padding-left: 1.5rem;
    }
    .xl\\:pt-0{
      padding-top: 0px;
    }
    .xl\\:text-\\[24px\\]{
      font-size: 24px;
    }
    .xl\\:text-\\[28px\\]{
      font-size: 28px;
    }
    .xl\\:text-\\[32px\\]{
      font-size: 32px;
    }
  }
  @media (min-width: 1296px){
    .\\32xl\\:col-span-3{
      grid-column: span 3 / span 3;
    }
    .\\32xl\\:col-span-4{
      grid-column: span 4 / span 4;
    }
    .\\32xl\\:col-span-6{
      grid-column: span 6 / span 6;
    }
    .\\32xl\\:col-span-8{
      grid-column: span 8 / span 8;
    }
    .\\32xl\\:col-span-9{
      grid-column: span 9 / span 9;
    }
    .\\32xl\\:mt-0{
      margin-top: 0px;
    }
    .\\32xl\\:justify-between{
      justify-content: space-between;
    }
    .\\32xl\\:px-\\[200px\\]{
      padding-left: 200px;
      padding-right: 200px;
    }
    .\\32xl\\:py-0{
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .\\32xl\\:py-\\[120px\\]{
      padding-top: 120px;
      padding-bottom: 120px;
    }
    .\\32xl\\:pt-0{
      padding-top: 0px;
    }
  }
  @media (min-width: 1600px){
    .\\33xl\\:mt-0{
      margin-top: 0px;
    }
  }
  




/* card styling */
/* .cardContainer{
  border: red solid 2px ;
} */

/* .cardContainer {
  max-width:20%;
  
} */

`, "",{"version":3,"sources":["webpack://./src/Wolfstyle.css"],"names":[],"mappings":"AAAA;;wFAEwF;AACxF,uBAAuB;;AAEvB,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;;AAGnB;IACI,mBAAmB;AACvB;;AAEA;IACI,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAIE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IAGf,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;;;IAIE,yBAAyB;IAEzB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,cAAc;IACd,aAAa;IACb,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,0CAA0C;EAC5C;EACA;;IAEE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,aAAa;IACb,6CAA6C;EAC/C;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,UAAU;EACZ;EACA;;IAEE,WAAW;IACX,cAAc;IACd,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;EAClC;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,QAAQ;EACV;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,OAAO;EACT;EACA;IACE,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,QAAQ;EACV;EACA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE;;MAEE;IACF;MACE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,UAAU;IACZ;IACA;MACE,MAAM;MACN,SAAS;IACX;IACA;MACE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,8BAA8B;MAC9B,SAAS;MACT,SAAS;MACT,SAAS;MACT,gBAAgB;MAChB,eAAe;MACf,sBAAsB;IACxB;IACA;MACE,UAAU;IACZ;IACA;MACE,UAAU;MACV,QAAQ;IACV;IACA;MACE,MAAM;MACN,QAAQ;MACR,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,8BAA8B;MAC9B,eAAe;MACf,kBAAkB;MAClB,UAAU;IACZ;EACF;EACA;IACE;MAEE,sBAAsB;IACxB;;IAEA;MAEE,mBAAmB;IACrB;;IAEA;MAEE,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;;wFAEsF;EACtF,8JAA8J,oBAAoB,CAAC,qBAAqB,CAAC,iBAAiB,CAAC,6IAA6I,oBAAoB,CAAC,qBAAqB,CAAC,iBAAiB,CAAC,2IAA2I,eAAe,CAAC,aAAa,CAAC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,OAAO,CAAC,QAAQ,CAAC,eAAe,CAAC,iIAAiI,aAAa,CAAC,6IAA6I,aAAa,CAAC,kCAAkC,CAAC,+HAA+H,aAAa,CAAC,+BAA+B,CAAC,uKAAuK,iBAAiB,CAAC,yJAAiS,uBAAuB,CAAC,4VAAge,2BAA2B,CAAC,mMAA2U,uBAAuB,CAAqH,uBAAuB,CAAC,+FAA+F,iBAAiB;EACrtF;;sFAEoF;EACpF;;;;;;;;;;IAUE;;GAED,WAAW,wBAAwB,CAAC,2CAA4rE,CAAC,eAAe,CAAC,iBAAiB,CAAC,MAAM,4BAA4B,CAAC,QAAQ,gBAAgB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,eAAe,CAAC,eAAe,CAAC,SAAS,CAAC,SAAS,CAAC,iCAAiC,qBAAqB,CAAC,gBAAgB,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,SAAS,CAAC,YAAY,CAAC,6BAA6B,CAAC,sBAAsB,CAAC,8CAA8C,8BAA8B,CAAC,uBAAuB,kBAAkB,CAAC,uCAAuC,kBAAkB,CAAC,cAAc,aAAa,CAAC,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,6BAA6B,CAAC,8BAA8B,iBAAiB,CAAC,oDAAoD,WAAW,CAAC,mCAAmC,sBAAsB,CAAC,oCAAoC,CAAC,sCAAsC,uBAAuB,CAAoC,0BAA0B,CAAC,sDAAsD,kBAAkB,CAAC,yQAAyQ,2BAA2B,CAAC,sLAAsL,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,UAAU,CAAC,WAAW,CAAC,mBAAmB,CAAC,UAAU,CAAC,gCAAgC,0BAA0B,CAAC,qCAAqC,sEAAsE,CAAC,sCAAsC,uEAAuE,CAAC,oCAAoC,qEAAqE,CAAC,uCAAuC,wEAAwE,CAAC,iCAAiC,aAAa,CAAC,oBAAoB,CAAC,uBAAuB,CAAC,oDAAoD,YAAY,CAAC,+CAA+C,6BAA6B,CAAC,mDAAmD,4BAA4B,CAAC,iDAAiD,4BAA4B,CAAC,yCAAyC,UAAU,CAAC,aAAa,CAAC,UAAU,CAAC,6EAA6E,wDAAwD,CAAC,2DAA2D,WAAW,CAAC,cAAc,CAAC,yCAAyC,CAAC,2EAA2E,uDAAuD,CAAC,yDAAyD,UAAU,CAAC,aAAa,CAAC,0CAA0C,CAAC,+CAA+C,+BAA+B,CAAC,uBAAuB,CAAC,8BAA8B,kCAAkC,CAAC,uBAAuB,CAAC,uDAAuD,UAAU,CAAC,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,mBAAmB,CAAC,yEAAyE,UAAU,CAAC,gCAAgC,CAAC,uEAAuE,SAAS,CAAC,iCAAiC,CAAC,MAAM,6BAA6B,CAAC,wCAAwC,iBAAiB,CAAC,OAAO,CAAC,kDAAkD,CAAC,oCAAoC,CAAC,yDAAyD,CAAC,UAAU,CAAC,cAAc,CAAC,YAAY,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,8DAA8D,CAAC,sFAAsF,WAAW,CAAC,WAAW,CAAC,mBAAmB,CAAC,kFAAkF,SAAS,CAAC,WAAW,CAAC,mBAAmB,CAAC,gGAAgG,sBAAsB,CAAC,oDAAoD,wBAAwB,CAAC,uCAAuC,CAAC,6BAA6B,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,aAAa,CAAC,oDAAoD,SAAS,CAAC,UAAU,CAAC,gEAAgE,cAAc,CAAC,oDAAoD,UAAU,CAAC,SAAS,CAAC,gEAAgE,cAAc,CAAC,oBAAoB,YAAY,CAAC,mBAAmB,iBAAiB,CAAC,iBAAiB,CAAC,sBAAsB,CAAC,4BAA4B,CAAC,UAAU,CAAC,4CAA4C,SAAS,CAAC,6FAA6F,sBAAsB,CAAC,4JAA4J,WAAW,CAAC,MAAM,CAAC,UAAU,CAAC,mCAAmC,eAAe,CAAC,WAAW,CAAC,6DAA6D,oBAAoB,CAAC,iBAAiB,CAAC,oEAAoE,kBAAkB,CAAC,yEAAyE,kBAAkB,CAAC,yEAAyE,oBAAoB,CAAC,8EAA8E,oBAAoB,CAAC,yEAAyE,oBAAoB,CAAC,8EAA8E,oBAAoB,CAAC,0BAA0B,oFAAoF,CAAC,sFAAsF,CAAC,oBAAoB,CAAC,iBAAiB,CAAC,8DAA8D,CAAC,4DAA4D,CAAC,gCAAgC,WAAW,CAAC,QAAQ,CAAC,SAAS,CAAC,eAAe,CAAyB,eAAe,CAAC,uDAAuD,cAAc,CAAC,qCAAqC,sBAAsB,CAAC,iCAAiC,kDAAkD,CAAC,mEAAmE,CAAC,kGAAkG,UAAU,CAAC,OAAO,CAAC,iCAAiC,CAAC,sJAAsJ,yDAAyD,CAAC,aAAa,CAAC,sKAAsK,OAAO,CAAC,0BAA0B,CAAC,SAAS,CAAC,0NAA0N,oBAAoB,CAAC,gCAAgC,CAAC,0JAA0J,2DAA2D,CAAC,0KAA0K,QAAQ,CAAC,0BAA0B,CAAC,kBAAkB,CAAC,8NAA8N,iCAAiC,CAAC,2FAA2F,kCAAkC,CAAC,+BAA+B,0BAA0B,CAAC,iBAAiB,CAAC,mEAAmE,mEAAmE,CAAC,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,UAAU,CAAC,WAAW,CAAC,kBAAkB,CAAC,yBAAyB,CAAC,+EAA+E,0BAA0B,CAAC,sSAAsS,UAAU,CAAC,UAAU,CAAC,MAAM,CAAC,KAAK,CAAC,sSAAsS,SAAS,CAAC,WAAW,CAAC,MAAM,CAAC,KAAK,CAAC,wBAAwB,YAAY,CAAC,kBAAkB,kBAAkB,CAAC,iBAAiB,CAAC,qBAAqB,CAAC,yBAAyB,CAAC,yFAAyF,sBAAsB,CAAC,mFAAmF,iBAAiB,CAAC,OAAO,CAAC,UAAU,CAAC,UAAU,CAAC,UAAU,CAAC,SAAS,CAAC,+EAA+E,iBAAiB,CAAC,SAAS,CAAC,MAAM,CAAC,UAAU,CAAC,SAAS,CAAC,UAAU,CAAC,uBAAuB,WAAW,CAAC,UAAU,CAAC,iBAAiB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC,MAAM,CAAC,KAAK,CAAC,8BAA8B,WAAW,CAAC,uBAAuB,YAAY,CAAC,uBAAuB,UAAU,CAAC,WAAW,CAAC,YAAY,CAAC,sBAAsB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,oFAAoF,cAAc,CAAC,eAAe,CAAC,kBAAkB,CAAC,qBAAqB,WAAW,CAAC,uBAAuB,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,QAAQ,CAAC,OAAO,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,UAAU,CAAC,oBAAoB,CAAC,qBAAqB,CAAC,wEAAwE,CAAC,iBAAiB,CAAC,4BAA4B,CAAC,+HAA+H,kDAAkD,CAAC,6BAA6B,6BAA6B,CAAC,6BAA6B,6BAA6B,CAAC,iCAAiC,GAAG,sBAAsB,CAAC,KAAK,wBAAwB,CAAC,CAAC,6BAA6B,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,mBAAmB,CAAC,SAAS,CAAC,aAAa,CAAC,kCAAkC,mCAAmC,CAAC,aAAa,CAAC,6BAA6B,cAAc,CAAC,oCAAoC,cAAc,CAAC,qBAAqB,CAAC,4CAA4C,mCAAmC,CAAC,2BAA2B,mBAAmB,CAAC,2BAA2B,CAAC,yCAAyC,mBAAmB,CAAC,yFAAyF,mBAAmB,CAAC,aAAa,gBAAgB,CAAC,2BAA2B,mBAAmB,CAAoC,0BAA0B,CAAC,SAAS,CAAC,iBAAiB,CAAC,oBAAoB,CAAC,UAAU,CAAC,WAAW,CAAC,yCAAyC,mBAAmB,CAAC,sCAAsC,uBAAuB,CAAC,yFAAyF,mBAAmB,CAAC,gJAAgJ,mBAAmB,CAAC,kBAAkB,CAAC,8JAA8J,SAAS,CAAoC,0BAA0B,CAAC,iCAAiC,iBAAiB,CAAC,MAAM,CAAC,UAAU,CAAC,UAAU,CAAC,WAAW,CAAC,UAAU,CAAC,SAAS,CAAC,wCAAwC,UAAU,CAAC,eAAe,CAAC,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,QAAQ,CAAC,OAAO,CAAC,iBAAiB,CAAC,aAAa,gBAAgB,CAAC,2BAA2B,mBAAmB,CAAoC,0BAA0B,CAAC,SAAS,CAAC,yCAAyC,mBAAmB,CAAC,yFAAyF,mBAAmB,CAAC,8JAA8J,SAAS,CAAoC,0BAA0B,CAAC,+BAAkE,0BAA0B,CAAC,eAAe,CAAC,4CAA4C,CAAC,cAAc,gBAAgB,CAAC,4BAA4B,8BAA8B,CAAoC,0BAA0B,CAAC,eAAe;EAC72f;;+EAE6E;EAC7E,qFAAqF,wBAAwB,CAAC,+EAA+E,kBAAkB,CAAC,uGAAuG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,uFAAuF,uBAAuB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,oBAAoB,CAAC,uFAAuF,wBAAwB,CAAC,iFAAiF,kBAAkB,CAAC,yGAAyG,qBAAqB,CAAC,yFAAyF,sBAAsB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,mBAAmB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,sBAAsB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,mBAAmB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,wBAAwB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,qBAAqB,CAAC,yFAAyF,yBAAyB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,sBAAsB,CAAC,yFAAyF,sBAAsB,CAAC,mFAAmF,kBAAkB,CAAC,2GAA2G,mBAAmB,CAAC,qFAAqF,wDAAwD,CAAC,iFAAiF,+BAA+B,CAAC,uFAAuF,kCAAkC,CAAC,yFAAyF,mCAAmC,CAAC,+FAA+F,sCAAsC,CAAC,iGAAiG,0DAA0D,CAAC,mGAAmG,4DAA4D,CAAC,yGAAyG,2DAA2D,CAAC,iGAAiG,wDAAwD,CAAC,mGAAmG,wDAAwD,CAAC,yGAAyG,yDAAyD,CAAC,iGAAiG,yDAAyD,CAAC,mGAAmG,wDAAwD,CAAC,yGAAyG,2DAA2D,CAAC,mGAAmG,yDAAyD,CAAC,qGAAqG,wDAAwD,CAAC,2GAA2G,2DAA2D,CAAC,mGAAmG,yDAAyD,CAAC,qGAAqG,wDAAwD,CAAC,2GAA2G,2DAA2D,CAAC,iCAAiC,SAAS,CAAC,qCAAqC,CAAC,6CAA6C,SAAS,CAAC,uBAAuB,CAAC,mBAAmB,gCAAgC,CAAC,qBAAqB,iCAAiC,CAAC,sBAAsB,iCAAiC,CAAC,qBAAqB,gCAAgC,CAAC,yBAAyB,qCAAqC,CAAC,wBAAwB,oCAAoC,CAAC,2BAA2B,sCAAsC,CAAC,0BAA0B,qCAAqC,CAAC,iCAAiC,SAAS,CAAC,qCAAqC,CAAC,6CAA6C,SAAS,CAAC,gCAAgC,CAAC,mBAAmB,mBAAmB,CAAC,sBAAsB,0CAA0C,CAAC,wBAAwB,2CAA2C,CAAC,yBAAyB,2CAA2C,CAAC,wBAAwB,0CAA0C,CAAC,oBAAoB,oBAAoB,CAAC,uBAAuB,2CAA2C,CAAC,yBAAyB,4CAA4C,CAAC,0BAA0B,4CAA4C,CAAC,yBAAyB,2CAA2C,CAAC,mCAAmC,6BAA6B,CAAC,+CAA+C,uBAAuB,CAAC,oBAAoB,+BAA+B,CAAC,sBAAsB,gCAAgC,CAAC,uBAAuB,gCAAgC,CAAC,sBAAsB,+BAA+B,CAAC,iCAAiC,0BAA0B,CAAC,6BAA6B,CAAC,qBAAqB,8CAA8C,CAAC,iCAAiC,wCAAwC,CAAC,sBAAsB,6CAA6C,CAAC,kCAAkC,wCAAwC,CAAC,mBAAmB,8CAA8C,CAAC,+BAA+B,wCAAwC,CAAC,qBAAqB,6CAA6C,CAAC,iCAAiC,wCAAwC;EACp8yB;;iFAE+E;EAC/E;;IAEE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;;EAEA;;wFAEsF;EACtF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA+EG;;;EAGH;;yLAEuL;EACvL;;;;;;GAMC;EACD;;GAEC;EACD;;;GAGC;EACD;;;IAGE,sBAAsB,EAAE,MAAM;IAC9B,eAAe,EAAE,MAAM;IACvB,mBAAmB,EAAE,MAAM;IAC3B,qBAAqB,EAAE,MAAM;EAC/B;EACA;;IAEE,gBAAgB;EAClB;EACA;;;;;;;;GAQC;EACD;;IAEE,gBAAgB,EAAE,MAAM;IACxB,8BAA8B,EAAE,MAAM,EACpB,MAAM;IAErB,WAAW,EAAE,MAAM;IACtB,8LAA8L,EAAE,MAAM;IACtM,6BAA6B,EAAE,MAAM;IACrC,+BAA+B,EAAE,MAAM;IACvC,wCAAwC,EAAE,MAAM;EAClD;EACA;;;GAGC;EACD;IACE,SAAS,EAAE,MAAM;IACjB,oBAAoB,EAAE,MAAM;EAC9B;EACA;;;;GAIC;EACD;IACE,SAAS,EAAE,MAAM;IACjB,cAAc,EAAE,MAAM;IACtB,qBAAqB,EAAE,MAAM;EAC/B;EACA;;GAEC;EACD;IACE,0BAA0B;IAC1B,yCAAyC;YACjC,iCAAiC;EAC3C;EACA;;GAEC;EACD;;;;;;IAME,kBAAkB;IAClB,oBAAoB;EACtB;EACA;;GAEC;EACD;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;;GAEC;EACD;;IAEE,mBAAmB;EACrB;EACA;;;;;GAKC;EACD;;;;IAIE,+GAA+G,EAAE,MAAM;IACvH,6BAA6B,EAAE,MAAM;IACrC,+BAA+B,EAAE,MAAM;IACvC,cAAc,EAAE,MAAM;EACxB;EACA;;GAEC;EACD;IACE,cAAc;EAChB;EACA;;GAEC;EACD;;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;;;GAIC;EACD;IACE,cAAc,EAAE,MAAM;IACtB,qBAAqB,EAAE,MAAM;IAC7B,yBAAyB,EAAE,MAAM;EACnC;EACA;;;;GAIC;EACD;;;;;IAKE,oBAAoB,EAAE,MAAM;IAC5B,8BAA8B,EAAE,MAAM;IACtC,gCAAgC,EAAE,MAAM;IACxC,eAAe,EAAE,MAAM;IACvB,oBAAoB,EAAE,MAAM;IAC5B,oBAAoB,EAAE,MAAM;IAC5B,uBAAuB,EAAE,MAAM;IAC/B,cAAc,EAAE,MAAM;IACtB,SAAS,EAAE,MAAM;IACjB,UAAU,EAAE,MAAM;EACpB;EACA;;GAEC;EACD;;IAEE,oBAAoB;EACtB;EACA;;;GAGC;EACD;;;;IAIE,0BAA0B,EAAE,MAAM;IAClC,6BAA6B,EAAE,MAAM;IACrC,sBAAsB,EAAE,MAAM;EAChC;EACA;;GAEC;EACD;IACE,aAAa;EACf;EACA;;GAEC;EACD;IACE,gBAAgB;EAClB;EACA;;GAEC;EACD;IACE,wBAAwB;EAC1B;EACA;;GAEC;EACD;;IAEE,YAAY;EACd;EACA;;;GAGC;EACD;IACE,6BAA6B,EAAE,MAAM;IACrC,oBAAoB,EAAE,MAAM;EAC9B;EACA;;GAEC;EACD;IACE,wBAAwB;EAC1B;EACA;;;GAGC;EACD;IACE,0BAA0B,EAAE,MAAM;IAClC,aAAa,EAAE,MAAM;EACvB;EACA;;GAEC;EACD;IACE,kBAAkB;EACpB;EACA;;GAEC;EACD;;;;;;;;;;;;;IAaE,SAAS;EACX;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;;;IAGE,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;EACA;;GAEC;EACD;IACE,UAAU;EACZ;EACA;;GAEC;EACD;IACE,gBAAgB;EAClB;EACA;;;GAGC;EAKD;;IAEE,UAAU,EAAE,MAAM;IAClB,cAAc,EAAE,MAAM;EACxB;EACA;;GAEC;EACD;;IAEE,eAAe;EACjB;EACA;;GAEC;EACD;IACE,eAAe;EACjB;EACA;;;;GAIC;EACD;;;;;;;;IAQE,cAAc,EAAE,MAAM;IACtB,sBAAsB,EAAE,MAAM;EAChC;EACA;;GAEC;EACD;;IAEE,eAAe;IACf,YAAY;EACd;EACA,wEAAwE;EACxE;IACE,aAAa;EACf;EACA;MACI,iBAAiB;IACnB;EACF;;;;IAIE,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE;;;;MAIE,mBAAmB;MACnB,oBAAoB;IACtB;EACF;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,sCAAsC;IACtC,mEAAmE;IACnE,uHAAuH;EACzH;EACA;;IAEE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,wCAAwC;IACxC,0CAA0C;IAC1C,mCAAmC;IACnC,8BAA8B;IAC9B,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,wCAAwC;IACxC,0CAA0C;IAC1C,mCAAmC;IACnC,8BAA8B;IAC9B,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE;MACE,qBAAqB;MACrB,sBAAsB;IACxB;EACF;EACA;IACE;MACE,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;IACpB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;EACF;EACA;MACI,6DAA6D;IAC/D;EACF;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IAEE,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,8KAA8K;IAC9K,+LAA+L;EACjM;EACA;IACE,sBAAsB;IACtB,8KAA8K;IAC9K,+LAA+L;EACjM;EACA;IACE,kBAAkB;IAClB,oLAAoL;IACpL,+LAA+L;EACjM;EACA;IACE,iBAAiB;IACjB,mLAAmL;IACnL,+LAA+L;EACjM;EACA;IACE,+LAA+L;EACjM;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;EACA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,iCAAiC;IACjC,wDAAwD;EAC1D;EACA;IACE,sBAAsB;IACtB,iCAAiC;IACjC,wDAAwD;EAC1D;EACA;IACE,sBAAsB;IACtB,iCAAiC;IACjC,wDAAwD;EAC1D;EACA;IACE,sBAAsB;IACtB,iCAAiC;IACjC,wDAAwD;EAC1D;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,2DAA2D;EAC7D;EACA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,yDAAyD;EAC3D;EACA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,0DAA0D;EAC5D;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,2DAA2D;EAC7D;EACA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,qDAAqD;EACvD;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,sCAAsC;IACtC,yDAAyD;EAC3D;EACA;IACE,kBAAkB;IAClB,uCAAuC;IACvC,0DAA0D;EAC5D;EACA;IAEK,iBAAiB;EACtB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,+CAA+C;EACjD;EACA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,6CAA6C;EAC/C;EACA;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,kDAAkD;EACpD;EACA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,gDAAgD;EAClD;EACA;IACE,oBAAoB;IACpB,4BAA4B;IAC5B,iDAAiD;EACnD;EACA;IACE,8EAA8E;IAC9E,8FAA8F;IAC9F,mHAAmH;IACnH,uHAAuH;EACzH;EACA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,4KAA4K;IAC5K,iLAAiL;EACnL;EACA;IACE,yBAAyB;IACzB,6KAA6K;IAC7K,iLAAiL;EACnL;EACA;IACE,iLAAiL;EACnL;EACA;IAEE,wJAAwJ;IAExJ,wDAAwD;IACxD,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wDAAwD;EAC1D;EACA;;MAEI,wBAAwB;MACxB,SAAS;IACX;EACF;IACE;MACE,8BAA8B;IAChC;IACA;MACE,+BAA+B;IACjC;IACA;MACE,iCAAiC;IACnC;IACA;MACE,kCAAkC;IACpC;EACF;EACA;MACI,iCAAiC;IACnC;EACF;;MAEI,aAAa;MACb,wBAAwB;IAC1B;EACF;MACI,wCAAwC;IAC1C;EACF;IACE,sBAAsB;IACtB,kCAAkC;IAClC,yDAAyD;EAC3D;EACA;IACE,cAAc;EAChB;EACA;MACI,iCAAiC;MACjC,cAAc;MACd,SAAS;MACT,UAAU;MACV,iBAAiB;MACjB,eAAe;MACf,kBAAkB;IACpB;EACF;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;EACA;;IAEE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,6BAA6B;EAC/B;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;EAC3B;EAKA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;EACd;EACA;IACE;MACE,YAAY;IACd;EACF;EACA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,2DAA2D;IAC3D,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;IACZ,+CAA+C;EACjD;EACA;IACE,2CAA2C;IAC3C,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;IACZ,oCAAoC;EACtC;EACA;IACE,uCAAuC;IACvC,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,WAAW;IACX,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,gDAAgD;IAChD,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,iCAAiC;IACjC,wDAAwD;EAC1D;;EAEA;IACE;MACE,YAAY;MACZ,sBAAsB;IACxB;EACF;;EAEA;IACE,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;EAC3B;EAKA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA,mDAAmD;EACnD,mDAAmD;EACnD,4DAA4D;EAC5D,oBAAoB;EACpB;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,6CAA6C;IAC7C,0BAA0B;IAC1B,+CAA+C;IAC/C,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB,wDAAwD;EACxD,sDAAsD;EACtD,yDAAyD;EACzD;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,eAAe;IACf,UAAU;IACV,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,QAAQ;IACR,eAAe;IACf,aAAa;IACb,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,WAAW;IACX,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;EACA;IACE,6CAA6C;EAC/C;;EAEA,qDAAqD;EACrD,+DAA+D;EAC/D;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;EACA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;EACtC;EACA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;EACA;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,4BAA4B;IAC9B;EACF;EACA;IACE,6CAA6C;EAC/C;;EAEA,4DAA4D;EAC5D,6DAA6D;EAC7D;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;EACA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,8DAA8D;IAC9D,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,yBAAyB;EAC3B;;EAEA,0DAA0D;EAC1D,gEAAgE;EAChE;IACE,0CAA0C;IAC1C,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;EACjB;;EAEA,2DAA2D;EAC3D,sDAAsD;EACtD,8DAA8D;EAC9D,+DAA+D;EAC/D;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,qFAAqF;EACvF;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,OAAO;IACP,WAAW;IACX,gCAAgC;IAChC,mBAAmB;IACnB,yFAAyF;EAC3F;EACA;IACE,YAAY;EACd;;EAEA,2DAA2D;EAC3D,8DAA8D;EAC9D,+DAA+D;EAC/D,+DAA+D;EAC/D;IACE,oCAAoC;IACpC,oCAAoC;EACtC;EACA;IACE,qFAAqF;IAElF,iBAAiB;IACpB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,OAAO;IACP,gCAAgC;IAChC,mBAAmB;IACnB,yFAAyF;EAC3F;EACA;IACE,YAAY;EACd;;EAEA,4DAA4D;EAC5D,+DAA+D;EAC/D,4DAA4D;EAC5D,8DAA8D;EAC9D;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,yCAAyC;IACzC,qBAAqB;EACvB;EACA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,YAAY;EACd;;EAEA,2DAA2D;EAC3D,4DAA4D;EAC5D,2EAA2E;EAC3E,4EAA4E;EAC5E;IACE,kEAAkE;IAClE,iFAAiF;IACjF,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,yEAAyE;EACzE,iFAAiF;EACjF;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA,4EAA4E;EAC5E,yEAAyE;EACzE,sDAAsD;EACtD,8EAA8E;EAC9E;IACE,kKAAgK;IAE7J,iBAAiB;EACtB;;EAEA,0EAA0E;EAC1E,sDAAsD;EACtD,uDAAuD;EACvD,uEAAuE;EACvE;IACE,4IAAmI;IAEhI,iBAAiB;IACpB,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;;EAEA,iEAAiE;EACjE,qDAAqD;EACrD;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA,yDAAyD;EACzD,uCAAuC;EACvC;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;;;;IAIE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC,sDAAsD;EACtD;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;IAEhB,iBAAiB;IACpB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IAEhB,iBAAiB;EACtB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,gDAAgD;EAClD;;EAEA,oDAAoD;EACpD,sBAAsB;EACtB;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;EAChB;;EAEA,oBAAoB;EACpB,8BAA8B;EAC9B;IACE,mBAAmB;IACnB,eAAe;IACf,kEAAkE;IAClE,iFAAiF;IACjF,yBAAyB;EAC3B;;EAEA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,cAAc;IACd,oCAAoC;EACtC;;EAEA,4BAA4B;EAC5B,+BAA+B;EAC/B;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,6BAA6B;EAC7B,4BAA4B;EAC5B;IACE,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B,+BAA+B;EAC/B;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA,6BAA6B;EAC7B,4CAA4C;EAC5C;IACE,kEAAkE;IAClE,iFAAiF;IACjF,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,oCAAoC;IACpC,YAAY;EACd;;EAEA,0CAA0C;EAC1C,2BAA2B;EAC3B;IACE,kEAAkE;IAClE,iFAAiF;IACjF,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,kEAAkE;IAClE,iFAAiF;IACjF,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,yBAAyB;EACzB,qBAAqB;EACrB;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,oBAAoB;MACpB,0BAA0B;MAC1B,sCAAsC;IACxC;IACA;MACE,wBAAwB;MACxB,0BAA0B;MAC1B,sCAAsC;IACxC;IACA;MACE,wBAAwB;MACxB,0BAA0B;MAC1B,sCAAsC;IACxC;IACA;MACE,sCAAsC;MACtC,UAAU;MACV,0BAA0B;MAC1B,sCAAsC;IACxC;IACA;MACE,4BAA4B;MAC5B,UAAU;IACZ;EACF;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;;EAEA,mBAAmB;EACnB,oCAAoC;EACpC;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA,kCAAkC;EAClC,iBAAiB;EACjB;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA,eAAe;EACf,cAAc;EACd;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA,YAAY;EACZ,qCAAqC;EACrC;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,cAAc;EAChB;;EAEA,mCAAmC;EACnC,mDAAmD;EACnD,uDAAuD;EACvD;IACE;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,4BAA4B;MAC5B,sCAAsC;MACtC,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,cAAc;MACd,YAAY;MACZ,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,SAAS;MACT,WAAW;IACb;IACA;MACE,cAAc;MACd,YAAY;MACZ,eAAe;MACf,eAAe;IACjB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,WAAW;MACX,WAAW;MACX,yBAAyB;IAC3B;IACA;MACE,UAAU;MACV,WAAW;MACX,yBAAyB;MACzB,kBAAkB;IACpB;IACA;;;;MAIE,WAAW;MACX,gBAAgB;IAClB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,kBAAkB;MAClB,YAAY;IACd;IACA;MACE,kBAAkB;MAClB,YAAY;IACd;IACA;MACE,kBAAkB;MAClB,YAAY;IACd;EACF;EACA;IACE;MACE,WAAW;MACX,WAAW;MACX,yBAAyB;IAC3B;IACA;MACE,WAAW;MACX,WAAW;MACX,yBAAyB;MACzB,kBAAkB;IACpB;IACA;;;;MAIE,WAAW;MACX,gBAAgB;IAClB;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,WAAW;MACX,cAAc;MACd,WAAW;MACX,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,SAAS;MACT,UAAU;IACZ;IACA;MACE,WAAW;MACX,cAAc;MACd,WAAW;MACX,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,SAAS;MACT,WAAW;IACb;IACA;MACE,WAAW;MACX,WAAW;MACX,yBAAyB;IAC3B;IACA;MACE,WAAW;MACX,WAAW;MACX,yBAAyB;MACzB,kBAAkB;IACpB;IACA;;;;MAIE,WAAW;MACX,gBAAgB;IAClB;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA,iDAAiD;EAMjD;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,kDAAkD;EACpD;EACA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,0KAA0K;IAC1K,iLAAiL;EACnL;EACA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,yDAAyD;EAC3D;EACA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,0DAA0D;EAC5D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,qCAAqC;IACrC,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,sCAAsC;IACtC,yDAAyD;EAC3D;EACA;IACE,kBAAkB;IAClB,uCAAuC;IACvC,0DAA0D;EAC5D;EACA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,gDAAgD;EAClD;EACA;IACE,oBAAoB;IACpB,4BAA4B;IAC5B,iDAAiD;EACnD;EACA;IACE,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,sCAAsC;IACtC,yDAAyD;EAC3D;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,qKAAqK;IACrK,+LAA+L;EACjM;EACA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,4KAA4K;IAC5K,iLAAiL;EACnL;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,sBAAsB;IACxB;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,sBAAsB;IACxB;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,8BAA8B;IAChC;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,WAAW;IACb;IACA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,kBAAkB;IACpB;IACA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,YAAY;IACd;IACA;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;IACA;MACE,WAAW;IACb;IACA;MACE,WAAW;IACb;IACA;MACE,uBAAuB;IACzB;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,WAAW;IACb;IACA;MACE,SAAS;IACX;IACA;MACE,oBAAoB;MACpB,qBAAqB;IACvB;IACA;MACE,oBAAoB;MACpB,qBAAqB;IACvB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,qBAAqB;MACrB,sBAAsB;IACxB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,oBAAoB;MACpB,qBAAqB;IACvB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;IACA;MACE,oBAAoB;MACpB,uBAAuB;IACzB;IACA;MACE,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,oBAAoB;MACpB,uBAAuB;IACzB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,uBAAuB;IACzB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,8BAA8B;IAChC;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,YAAY;IACd;IACA;MACE,WAAW;IACb;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,oBAAoB;MACpB,uBAAuB;IACzB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,8BAA8B;IAChC;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,gBAAgB;IAClB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,YAAY;IACd;IACA;MACE,WAAW;IACb;IACA;MACE,mBAAmB;IACrB;IACA;MACE,8BAA8B;IAChC;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,oBAAoB;MACpB,qBAAqB;IACvB;IACA;MACE,mBAAmB;MACnB,oBAAoB;IACtB;IACA;MACE,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,uBAAuB;IACzB;IACA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;IACA;MACE,qBAAqB;MACrB,sBAAsB;IACxB;IACA;MACE,oBAAoB;MACpB,qBAAqB;IACvB;IACA;MACE,mBAAmB;MACnB,oBAAoB;IACtB;IACA;MACE,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,oBAAoB;MACpB,uBAAuB;IACzB;IACA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;IACA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,eAAe;IACjB;IACA;MACE,8BAA8B;IAChC;IACA;MACE,mBAAmB;MACnB,oBAAoB;IACtB;IACA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;IACA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;IACA;MACE,gBAAgB;IAClB;EACF;EACA;IACE;MACE,eAAe;IACjB;EACF;;;;;;AAMF,iBAAiB;AACjB;;GAEG;;AAEH;;;GAGG","sourcesContent":["/*!*************************************************************************************!*\\\n  !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/magnific-popup.css ***!\n  \\*************************************************************************************/\n/* Magnific Popup CSS */\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\nbody{\n    background: #0f0f0f;\n}\n\n.mfp-bg {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1042;\n    overflow: hidden;\n    position: fixed;\n    background: #0b0b0b;\n    opacity: 0.8;\n  }\n  \n  .mfp-wrap {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1043;\n    position: fixed;\n    outline: none !important;\n    -webkit-backface-visibility: hidden;\n  }\n  \n  .mfp-container {\n    text-align: center;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    padding: 0 8px;\n    box-sizing: border-box;\n  }\n  \n  .mfp-container:before {\n    content: \"\";\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n  \n  .mfp-align-top .mfp-container:before {\n    display: none;\n  }\n  \n  .mfp-content {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 auto;\n    text-align: left;\n    z-index: 1045;\n  }\n  \n  .mfp-inline-holder .mfp-content,\n  .mfp-ajax-holder .mfp-content {\n    width: 100%;\n    cursor: auto;\n  }\n  \n  .mfp-ajax-cur {\n    cursor: progress;\n  }\n  \n  .mfp-zoom-out-cur,\n  .mfp-zoom-out-cur .mfp-image-holder .mfp-close {\n    cursor: -moz-zoom-out;\n    cursor: -webkit-zoom-out;\n    cursor: zoom-out;\n  }\n  \n  .mfp-zoom {\n    cursor: pointer;\n    cursor: -webkit-zoom-in;\n    cursor: -moz-zoom-in;\n    cursor: zoom-in;\n  }\n  \n  .mfp-auto-cursor .mfp-content {\n    cursor: auto;\n  }\n  \n  .mfp-close,\n  .mfp-arrow,\n  .mfp-preloader,\n  .mfp-counter {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n  }\n  \n  .mfp-loading.mfp-figure {\n    display: none;\n  }\n  \n  .mfp-hide {\n    display: none !important;\n  }\n  \n  .mfp-preloader {\n    color: #ccc;\n    position: absolute;\n    top: 50%;\n    width: auto;\n    text-align: center;\n    margin-top: -0.8em;\n    left: 8px;\n    right: 8px;\n    z-index: 1044;\n  }\n  .mfp-preloader a {\n    color: #ccc;\n  }\n  .mfp-preloader a:hover {\n    color: #fff;\n  }\n  \n  .mfp-s-ready .mfp-preloader {\n    display: none;\n  }\n  \n  .mfp-s-error .mfp-content {\n    display: none;\n  }\n  \n  button.mfp-close,\n  button.mfp-arrow {\n    overflow: visible;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    display: block;\n    outline: none;\n    padding: 0;\n    z-index: 1046;\n    box-shadow: none;\n    touch-action: manipulation;\n  }\n  button::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n  }\n  \n  .mfp-close {\n    width: 44px;\n    height: 44px;\n    line-height: 44px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    text-decoration: none;\n    text-align: center;\n    opacity: 0.65;\n    padding: 0 0 18px 10px;\n    color: #fff;\n    font-style: normal;\n    font-size: 28px;\n    font-family: Arial, Baskerville, monospace;\n  }\n  .mfp-close:hover,\n  .mfp-close:focus {\n    opacity: 1;\n  }\n  .mfp-close:active {\n    top: 1px;\n  }\n  \n  .mfp-close-btn-in .mfp-close {\n    color: #ffff;\n    margin-right: 6px;\n  }\n  \n  .mfp-image-holder .mfp-close,\n  .mfp-iframe-holder .mfp-close {\n    color: #fff;\n    right: -6px;\n    text-align: right;\n    padding-right: 6px;\n    width: 100%;\n  }\n  \n  .mfp-counter {\n    position: absolute;\n    top: 0;\n    right: 0;\n    color: #ccc;\n    font-size: 12px;\n    line-height: 18px;\n    white-space: nowrap;\n  }\n  \n  .mfp-arrow {\n    position: absolute;\n    opacity: 0.65;\n    margin: 0;\n    top: 50%;\n    margin-top: -55px;\n    padding: 0;\n    width: 90px;\n    height: 110px;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .mfp-arrow:active {\n    margin-top: -54px;\n  }\n  .mfp-arrow:hover,\n  .mfp-arrow:focus {\n    opacity: 1;\n  }\n  .mfp-arrow:before,\n  .mfp-arrow:after {\n    content: \"\";\n    display: block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    margin-top: 35px;\n    margin-left: 35px;\n    border: medium inset transparent;\n  }\n  .mfp-arrow:after {\n    border-top-width: 13px;\n    border-bottom-width: 13px;\n    top: 8px;\n  }\n  .mfp-arrow:before {\n    border-top-width: 21px;\n    border-bottom-width: 21px;\n    opacity: 0.7;\n  }\n  \n  .mfp-arrow-left {\n    left: 0;\n  }\n  .mfp-arrow-left:after {\n    border-right: 17px solid #fff;\n    margin-left: 31px;\n  }\n  .mfp-arrow-left:before {\n    margin-left: 25px;\n    border-right: 27px solid #3f3f3f;\n  }\n  \n  .mfp-arrow-right {\n    right: 0;\n  }\n  .mfp-arrow-right:after {\n    border-left: 17px solid #fff;\n    margin-left: 39px;\n  }\n  .mfp-arrow-right:before {\n    border-left: 27px solid #3f3f3f;\n  }\n  \n  .mfp-iframe-holder {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n  .mfp-iframe-holder .mfp-content {\n    line-height: 0;\n    width: 100%;\n    max-width: 900px;\n  }\n  .mfp-iframe-holder .mfp-close {\n    top: -40px;\n  }\n  \n  .mfp-iframe-scaler {\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    padding-top: 56.25%;\n  }\n  .mfp-iframe-scaler iframe {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #000;\n  }\n  \n  /* Main image in popup */\n  img.mfp-img {\n    width: auto;\n    max-width: 100%;\n    height: auto;\n    display: block;\n    line-height: 0;\n    box-sizing: border-box;\n    padding: 40px 0 40px;\n    margin: 0 auto;\n  }\n  \n  /* The shadow behind the image */\n  .mfp-figure {\n    line-height: 0;\n  }\n  .mfp-figure:after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 40px;\n    bottom: 40px;\n    display: block;\n    right: 0;\n    width: auto;\n    height: auto;\n    z-index: -1;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);\n    background: #444;\n  }\n  .mfp-figure small {\n    color: #bdbdbd;\n    display: block;\n    font-size: 12px;\n    line-height: 14px;\n  }\n  .mfp-figure figure {\n    margin: 0;\n  }\n  \n  .mfp-bottom-bar {\n    margin-top: -36px;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    cursor: auto;\n  }\n  \n  .mfp-title {\n    text-align: left;\n    line-height: 18px;\n    color: #f3f3f3;\n    word-wrap: break-word;\n    padding-right: 36px;\n  }\n  \n  .mfp-image-holder .mfp-content {\n    max-width: 100%;\n  }\n  \n  .mfp-gallery .mfp-image-holder .mfp-figure {\n    cursor: pointer;\n  }\n  \n  @media screen and (max-width: 800px) and (orientation: landscape),\n    screen and (max-height: 300px) {\n    /**\n     * Remove all paddings around the image on small screen\n     */\n    .mfp-img-mobile .mfp-image-holder {\n      padding-left: 0;\n      padding-right: 0;\n    }\n    .mfp-img-mobile img.mfp-img {\n      padding: 0;\n    }\n    .mfp-img-mobile .mfp-figure:after {\n      top: 0;\n      bottom: 0;\n    }\n    .mfp-img-mobile .mfp-figure small {\n      display: inline;\n      margin-left: 5px;\n    }\n    .mfp-img-mobile .mfp-bottom-bar {\n      background: rgba(0, 0, 0, 0.6);\n      bottom: 0;\n      margin: 0;\n      top: auto;\n      padding: 3px 5px;\n      position: fixed;\n      box-sizing: border-box;\n    }\n    .mfp-img-mobile .mfp-bottom-bar:empty {\n      padding: 0;\n    }\n    .mfp-img-mobile .mfp-counter {\n      right: 5px;\n      top: 3px;\n    }\n    .mfp-img-mobile .mfp-close {\n      top: 0;\n      right: 0;\n      width: 35px;\n      height: 35px;\n      line-height: 35px;\n      background: rgba(0, 0, 0, 0.6);\n      position: fixed;\n      text-align: center;\n      padding: 0;\n    }\n  }\n  @media all and (max-width: 900px) {\n    .mfp-arrow {\n      -webkit-transform: scale(0.75);\n      transform: scale(0.75);\n    }\n  \n    .mfp-arrow-left {\n      -webkit-transform-origin: 0;\n      transform-origin: 0;\n    }\n  \n    .mfp-arrow-right {\n      -webkit-transform-origin: 100%;\n      transform-origin: 100%;\n    }\n  \n    .mfp-container {\n      padding-left: 6px;\n      padding-right: 6px;\n    }\n  }\n  \n  /*!***********************************************************************************!*\\\n    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/odometer-min.css ***!\n    \\***********************************************************************************/\n  .odometer.odometer-auto-theme,.odometer.odometer-auto-theme .odometer-digit,.odometer.odometer-theme-default,.odometer.odometer-theme-default .odometer-digit{display:inline-block;vertical-align:middle;position:relative}.odometer.odometer-auto-theme .odometer-digit .odometer-digit-spacer,.odometer.odometer-theme-default .odometer-digit .odometer-digit-spacer{display:inline-block;vertical-align:middle;visibility:hidden}.odometer.odometer-auto-theme .odometer-digit .odometer-digit-inner,.odometer.odometer-theme-default .odometer-digit .odometer-digit-inner{text-align:left;display:block;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.odometer.odometer-auto-theme .odometer-digit .odometer-ribbon,.odometer.odometer-theme-default .odometer-digit .odometer-ribbon{display:block}.odometer.odometer-auto-theme .odometer-digit .odometer-ribbon-inner,.odometer.odometer-theme-default .odometer-digit .odometer-ribbon-inner{display:block;-webkit-backface-visibility:hidden}.odometer.odometer-auto-theme .odometer-digit .odometer-value,.odometer.odometer-theme-default .odometer-digit .odometer-value{display:block;-webkit-transform:translateZ(0)}.odometer.odometer-auto-theme .odometer-digit .odometer-value.odometer-last-value,.odometer.odometer-theme-default .odometer-digit .odometer-value.odometer-last-value{position:absolute}.odometer.odometer-auto-theme.odometer-animating-up .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-up .odometer-ribbon-inner{-webkit-transition:-webkit-transform 2s;-moz-transition:-moz-transform 2s;-ms-transition:-ms-transform 2s;-o-transition:-o-transform 2s;transition:transform 2s}.odometer.odometer-auto-theme.odometer-animating-down .odometer-ribbon-inner,.odometer.odometer-auto-theme.odometer-animating-up.odometer-animating .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-down .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-up.odometer-animating .odometer-ribbon-inner{-webkit-transform:translateY(-100%);-moz-transform:translateY(-100%);-ms-transform:translateY(-100%);-o-transform:translateY(-100%);transform:translateY(-100%)}.odometer.odometer-auto-theme.odometer-animating-down.odometer-animating .odometer-ribbon-inner,.odometer.odometer-theme-default.odometer-animating-down.odometer-animating .odometer-ribbon-inner{-webkit-transition:-webkit-transform 2s;-moz-transition:-moz-transform 2s;-ms-transition:-ms-transform 2s;-o-transition:-o-transform 2s;transition:transform 2s;-webkit-transform:translateY(0);-moz-transform:translateY(0);-ms-transform:translateY(0);-o-transform:translateY(0);transform:translateY(0)}.odometer.odometer-auto-theme .odometer-value,.odometer.odometer-theme-default .odometer-value{text-align:center}\n  /*!*********************************************************************************!*\\\n    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/swiper.min.css ***!\n    \\*********************************************************************************/\n  /**\n   * Swiper 8.4.7\n   * Most modern mobile touch slider and framework with hardware accelerated transitions\n   * https://swiperjs.com\n   *\n   * Copyright 2014-2023 Vladimir Kharlampidi\n   *\n   * Released under the MIT License\n   *\n   * Released on: January 30, 2023\n   */\n  \n   @font-face{font-family:swiper-icons;src:url(\"data:application/font-woff;charset=utf-8;base64, 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\");font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-virtual .swiper-slide{-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:'prev'}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:'next'}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:50%;background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl .swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-next+.swiper-slide,.swiper-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right,.swiper-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-flip{overflow:visible}.swiper-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right,.swiper-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-creative .swiper-slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards .swiper-slide{transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}\n  /*!**************************************************************************!*\\\n    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/aos.css ***!\n    \\**************************************************************************/\n  [data-aos][data-aos][data-aos-duration=\"50\"],body[data-aos-duration=\"50\"] [data-aos]{transition-duration:50ms}[data-aos][data-aos][data-aos-delay=\"50\"],body[data-aos-delay=\"50\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"50\"].aos-animate,body[data-aos-delay=\"50\"] [data-aos].aos-animate{transition-delay:50ms}[data-aos][data-aos][data-aos-duration=\"100\"],body[data-aos-duration=\"100\"] [data-aos]{transition-duration:.1s}[data-aos][data-aos][data-aos-delay=\"100\"],body[data-aos-delay=\"100\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"100\"].aos-animate,body[data-aos-delay=\"100\"] [data-aos].aos-animate{transition-delay:.1s}[data-aos][data-aos][data-aos-duration=\"150\"],body[data-aos-duration=\"150\"] [data-aos]{transition-duration:.15s}[data-aos][data-aos][data-aos-delay=\"150\"],body[data-aos-delay=\"150\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"150\"].aos-animate,body[data-aos-delay=\"150\"] [data-aos].aos-animate{transition-delay:.15s}[data-aos][data-aos][data-aos-duration=\"200\"],body[data-aos-duration=\"200\"] [data-aos]{transition-duration:.2s}[data-aos][data-aos][data-aos-delay=\"200\"],body[data-aos-delay=\"200\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"200\"].aos-animate,body[data-aos-delay=\"200\"] [data-aos].aos-animate{transition-delay:.2s}[data-aos][data-aos][data-aos-duration=\"250\"],body[data-aos-duration=\"250\"] [data-aos]{transition-duration:.25s}[data-aos][data-aos][data-aos-delay=\"250\"],body[data-aos-delay=\"250\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"250\"].aos-animate,body[data-aos-delay=\"250\"] [data-aos].aos-animate{transition-delay:.25s}[data-aos][data-aos][data-aos-duration=\"300\"],body[data-aos-duration=\"300\"] [data-aos]{transition-duration:.3s}[data-aos][data-aos][data-aos-delay=\"300\"],body[data-aos-delay=\"300\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"300\"].aos-animate,body[data-aos-delay=\"300\"] [data-aos].aos-animate{transition-delay:.3s}[data-aos][data-aos][data-aos-duration=\"350\"],body[data-aos-duration=\"350\"] [data-aos]{transition-duration:.35s}[data-aos][data-aos][data-aos-delay=\"350\"],body[data-aos-delay=\"350\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"350\"].aos-animate,body[data-aos-delay=\"350\"] [data-aos].aos-animate{transition-delay:.35s}[data-aos][data-aos][data-aos-duration=\"400\"],body[data-aos-duration=\"400\"] [data-aos]{transition-duration:.4s}[data-aos][data-aos][data-aos-delay=\"400\"],body[data-aos-delay=\"400\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"400\"].aos-animate,body[data-aos-delay=\"400\"] [data-aos].aos-animate{transition-delay:.4s}[data-aos][data-aos][data-aos-duration=\"450\"],body[data-aos-duration=\"450\"] [data-aos]{transition-duration:.45s}[data-aos][data-aos][data-aos-delay=\"450\"],body[data-aos-delay=\"450\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"450\"].aos-animate,body[data-aos-delay=\"450\"] [data-aos].aos-animate{transition-delay:.45s}[data-aos][data-aos][data-aos-duration=\"500\"],body[data-aos-duration=\"500\"] [data-aos]{transition-duration:.5s}[data-aos][data-aos][data-aos-delay=\"500\"],body[data-aos-delay=\"500\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"500\"].aos-animate,body[data-aos-delay=\"500\"] [data-aos].aos-animate{transition-delay:.5s}[data-aos][data-aos][data-aos-duration=\"550\"],body[data-aos-duration=\"550\"] [data-aos]{transition-duration:.55s}[data-aos][data-aos][data-aos-delay=\"550\"],body[data-aos-delay=\"550\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"550\"].aos-animate,body[data-aos-delay=\"550\"] [data-aos].aos-animate{transition-delay:.55s}[data-aos][data-aos][data-aos-duration=\"600\"],body[data-aos-duration=\"600\"] [data-aos]{transition-duration:.6s}[data-aos][data-aos][data-aos-delay=\"600\"],body[data-aos-delay=\"600\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"600\"].aos-animate,body[data-aos-delay=\"600\"] [data-aos].aos-animate{transition-delay:.6s}[data-aos][data-aos][data-aos-duration=\"650\"],body[data-aos-duration=\"650\"] [data-aos]{transition-duration:.65s}[data-aos][data-aos][data-aos-delay=\"650\"],body[data-aos-delay=\"650\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"650\"].aos-animate,body[data-aos-delay=\"650\"] [data-aos].aos-animate{transition-delay:.65s}[data-aos][data-aos][data-aos-duration=\"700\"],body[data-aos-duration=\"700\"] [data-aos]{transition-duration:.7s}[data-aos][data-aos][data-aos-delay=\"700\"],body[data-aos-delay=\"700\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"700\"].aos-animate,body[data-aos-delay=\"700\"] [data-aos].aos-animate{transition-delay:.7s}[data-aos][data-aos][data-aos-duration=\"750\"],body[data-aos-duration=\"750\"] [data-aos]{transition-duration:.75s}[data-aos][data-aos][data-aos-delay=\"750\"],body[data-aos-delay=\"750\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"750\"].aos-animate,body[data-aos-delay=\"750\"] [data-aos].aos-animate{transition-delay:.75s}[data-aos][data-aos][data-aos-duration=\"800\"],body[data-aos-duration=\"800\"] [data-aos]{transition-duration:.8s}[data-aos][data-aos][data-aos-delay=\"800\"],body[data-aos-delay=\"800\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"800\"].aos-animate,body[data-aos-delay=\"800\"] [data-aos].aos-animate{transition-delay:.8s}[data-aos][data-aos][data-aos-duration=\"850\"],body[data-aos-duration=\"850\"] [data-aos]{transition-duration:.85s}[data-aos][data-aos][data-aos-delay=\"850\"],body[data-aos-delay=\"850\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"850\"].aos-animate,body[data-aos-delay=\"850\"] [data-aos].aos-animate{transition-delay:.85s}[data-aos][data-aos][data-aos-duration=\"900\"],body[data-aos-duration=\"900\"] [data-aos]{transition-duration:.9s}[data-aos][data-aos][data-aos-delay=\"900\"],body[data-aos-delay=\"900\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"900\"].aos-animate,body[data-aos-delay=\"900\"] [data-aos].aos-animate{transition-delay:.9s}[data-aos][data-aos][data-aos-duration=\"950\"],body[data-aos-duration=\"950\"] [data-aos]{transition-duration:.95s}[data-aos][data-aos][data-aos-delay=\"950\"],body[data-aos-delay=\"950\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"950\"].aos-animate,body[data-aos-delay=\"950\"] [data-aos].aos-animate{transition-delay:.95s}[data-aos][data-aos][data-aos-duration=\"1000\"],body[data-aos-duration=\"1000\"] [data-aos]{transition-duration:1s}[data-aos][data-aos][data-aos-delay=\"1000\"],body[data-aos-delay=\"1000\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1000\"].aos-animate,body[data-aos-delay=\"1000\"] [data-aos].aos-animate{transition-delay:1s}[data-aos][data-aos][data-aos-duration=\"1050\"],body[data-aos-duration=\"1050\"] [data-aos]{transition-duration:1.05s}[data-aos][data-aos][data-aos-delay=\"1050\"],body[data-aos-delay=\"1050\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1050\"].aos-animate,body[data-aos-delay=\"1050\"] [data-aos].aos-animate{transition-delay:1.05s}[data-aos][data-aos][data-aos-duration=\"1100\"],body[data-aos-duration=\"1100\"] [data-aos]{transition-duration:1.1s}[data-aos][data-aos][data-aos-delay=\"1100\"],body[data-aos-delay=\"1100\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1100\"].aos-animate,body[data-aos-delay=\"1100\"] [data-aos].aos-animate{transition-delay:1.1s}[data-aos][data-aos][data-aos-duration=\"1150\"],body[data-aos-duration=\"1150\"] [data-aos]{transition-duration:1.15s}[data-aos][data-aos][data-aos-delay=\"1150\"],body[data-aos-delay=\"1150\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1150\"].aos-animate,body[data-aos-delay=\"1150\"] [data-aos].aos-animate{transition-delay:1.15s}[data-aos][data-aos][data-aos-duration=\"1200\"],body[data-aos-duration=\"1200\"] [data-aos]{transition-duration:1.2s}[data-aos][data-aos][data-aos-delay=\"1200\"],body[data-aos-delay=\"1200\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1200\"].aos-animate,body[data-aos-delay=\"1200\"] [data-aos].aos-animate{transition-delay:1.2s}[data-aos][data-aos][data-aos-duration=\"1250\"],body[data-aos-duration=\"1250\"] [data-aos]{transition-duration:1.25s}[data-aos][data-aos][data-aos-delay=\"1250\"],body[data-aos-delay=\"1250\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1250\"].aos-animate,body[data-aos-delay=\"1250\"] [data-aos].aos-animate{transition-delay:1.25s}[data-aos][data-aos][data-aos-duration=\"1300\"],body[data-aos-duration=\"1300\"] [data-aos]{transition-duration:1.3s}[data-aos][data-aos][data-aos-delay=\"1300\"],body[data-aos-delay=\"1300\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1300\"].aos-animate,body[data-aos-delay=\"1300\"] [data-aos].aos-animate{transition-delay:1.3s}[data-aos][data-aos][data-aos-duration=\"1350\"],body[data-aos-duration=\"1350\"] [data-aos]{transition-duration:1.35s}[data-aos][data-aos][data-aos-delay=\"1350\"],body[data-aos-delay=\"1350\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1350\"].aos-animate,body[data-aos-delay=\"1350\"] [data-aos].aos-animate{transition-delay:1.35s}[data-aos][data-aos][data-aos-duration=\"1400\"],body[data-aos-duration=\"1400\"] [data-aos]{transition-duration:1.4s}[data-aos][data-aos][data-aos-delay=\"1400\"],body[data-aos-delay=\"1400\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1400\"].aos-animate,body[data-aos-delay=\"1400\"] [data-aos].aos-animate{transition-delay:1.4s}[data-aos][data-aos][data-aos-duration=\"1450\"],body[data-aos-duration=\"1450\"] [data-aos]{transition-duration:1.45s}[data-aos][data-aos][data-aos-delay=\"1450\"],body[data-aos-delay=\"1450\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1450\"].aos-animate,body[data-aos-delay=\"1450\"] [data-aos].aos-animate{transition-delay:1.45s}[data-aos][data-aos][data-aos-duration=\"1500\"],body[data-aos-duration=\"1500\"] [data-aos]{transition-duration:1.5s}[data-aos][data-aos][data-aos-delay=\"1500\"],body[data-aos-delay=\"1500\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1500\"].aos-animate,body[data-aos-delay=\"1500\"] [data-aos].aos-animate{transition-delay:1.5s}[data-aos][data-aos][data-aos-duration=\"1550\"],body[data-aos-duration=\"1550\"] [data-aos]{transition-duration:1.55s}[data-aos][data-aos][data-aos-delay=\"1550\"],body[data-aos-delay=\"1550\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1550\"].aos-animate,body[data-aos-delay=\"1550\"] [data-aos].aos-animate{transition-delay:1.55s}[data-aos][data-aos][data-aos-duration=\"1600\"],body[data-aos-duration=\"1600\"] [data-aos]{transition-duration:1.6s}[data-aos][data-aos][data-aos-delay=\"1600\"],body[data-aos-delay=\"1600\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1600\"].aos-animate,body[data-aos-delay=\"1600\"] [data-aos].aos-animate{transition-delay:1.6s}[data-aos][data-aos][data-aos-duration=\"1650\"],body[data-aos-duration=\"1650\"] [data-aos]{transition-duration:1.65s}[data-aos][data-aos][data-aos-delay=\"1650\"],body[data-aos-delay=\"1650\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1650\"].aos-animate,body[data-aos-delay=\"1650\"] [data-aos].aos-animate{transition-delay:1.65s}[data-aos][data-aos][data-aos-duration=\"1700\"],body[data-aos-duration=\"1700\"] [data-aos]{transition-duration:1.7s}[data-aos][data-aos][data-aos-delay=\"1700\"],body[data-aos-delay=\"1700\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1700\"].aos-animate,body[data-aos-delay=\"1700\"] [data-aos].aos-animate{transition-delay:1.7s}[data-aos][data-aos][data-aos-duration=\"1750\"],body[data-aos-duration=\"1750\"] [data-aos]{transition-duration:1.75s}[data-aos][data-aos][data-aos-delay=\"1750\"],body[data-aos-delay=\"1750\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1750\"].aos-animate,body[data-aos-delay=\"1750\"] [data-aos].aos-animate{transition-delay:1.75s}[data-aos][data-aos][data-aos-duration=\"1800\"],body[data-aos-duration=\"1800\"] [data-aos]{transition-duration:1.8s}[data-aos][data-aos][data-aos-delay=\"1800\"],body[data-aos-delay=\"1800\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1800\"].aos-animate,body[data-aos-delay=\"1800\"] [data-aos].aos-animate{transition-delay:1.8s}[data-aos][data-aos][data-aos-duration=\"1850\"],body[data-aos-duration=\"1850\"] [data-aos]{transition-duration:1.85s}[data-aos][data-aos][data-aos-delay=\"1850\"],body[data-aos-delay=\"1850\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1850\"].aos-animate,body[data-aos-delay=\"1850\"] [data-aos].aos-animate{transition-delay:1.85s}[data-aos][data-aos][data-aos-duration=\"1900\"],body[data-aos-duration=\"1900\"] [data-aos]{transition-duration:1.9s}[data-aos][data-aos][data-aos-delay=\"1900\"],body[data-aos-delay=\"1900\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1900\"].aos-animate,body[data-aos-delay=\"1900\"] [data-aos].aos-animate{transition-delay:1.9s}[data-aos][data-aos][data-aos-duration=\"1950\"],body[data-aos-duration=\"1950\"] [data-aos]{transition-duration:1.95s}[data-aos][data-aos][data-aos-delay=\"1950\"],body[data-aos-delay=\"1950\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"1950\"].aos-animate,body[data-aos-delay=\"1950\"] [data-aos].aos-animate{transition-delay:1.95s}[data-aos][data-aos][data-aos-duration=\"2000\"],body[data-aos-duration=\"2000\"] [data-aos]{transition-duration:2s}[data-aos][data-aos][data-aos-delay=\"2000\"],body[data-aos-delay=\"2000\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2000\"].aos-animate,body[data-aos-delay=\"2000\"] [data-aos].aos-animate{transition-delay:2s}[data-aos][data-aos][data-aos-duration=\"2050\"],body[data-aos-duration=\"2050\"] [data-aos]{transition-duration:2.05s}[data-aos][data-aos][data-aos-delay=\"2050\"],body[data-aos-delay=\"2050\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2050\"].aos-animate,body[data-aos-delay=\"2050\"] [data-aos].aos-animate{transition-delay:2.05s}[data-aos][data-aos][data-aos-duration=\"2100\"],body[data-aos-duration=\"2100\"] [data-aos]{transition-duration:2.1s}[data-aos][data-aos][data-aos-delay=\"2100\"],body[data-aos-delay=\"2100\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2100\"].aos-animate,body[data-aos-delay=\"2100\"] [data-aos].aos-animate{transition-delay:2.1s}[data-aos][data-aos][data-aos-duration=\"2150\"],body[data-aos-duration=\"2150\"] [data-aos]{transition-duration:2.15s}[data-aos][data-aos][data-aos-delay=\"2150\"],body[data-aos-delay=\"2150\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2150\"].aos-animate,body[data-aos-delay=\"2150\"] [data-aos].aos-animate{transition-delay:2.15s}[data-aos][data-aos][data-aos-duration=\"2200\"],body[data-aos-duration=\"2200\"] [data-aos]{transition-duration:2.2s}[data-aos][data-aos][data-aos-delay=\"2200\"],body[data-aos-delay=\"2200\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2200\"].aos-animate,body[data-aos-delay=\"2200\"] [data-aos].aos-animate{transition-delay:2.2s}[data-aos][data-aos][data-aos-duration=\"2250\"],body[data-aos-duration=\"2250\"] [data-aos]{transition-duration:2.25s}[data-aos][data-aos][data-aos-delay=\"2250\"],body[data-aos-delay=\"2250\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2250\"].aos-animate,body[data-aos-delay=\"2250\"] [data-aos].aos-animate{transition-delay:2.25s}[data-aos][data-aos][data-aos-duration=\"2300\"],body[data-aos-duration=\"2300\"] [data-aos]{transition-duration:2.3s}[data-aos][data-aos][data-aos-delay=\"2300\"],body[data-aos-delay=\"2300\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2300\"].aos-animate,body[data-aos-delay=\"2300\"] [data-aos].aos-animate{transition-delay:2.3s}[data-aos][data-aos][data-aos-duration=\"2350\"],body[data-aos-duration=\"2350\"] [data-aos]{transition-duration:2.35s}[data-aos][data-aos][data-aos-delay=\"2350\"],body[data-aos-delay=\"2350\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2350\"].aos-animate,body[data-aos-delay=\"2350\"] [data-aos].aos-animate{transition-delay:2.35s}[data-aos][data-aos][data-aos-duration=\"2400\"],body[data-aos-duration=\"2400\"] [data-aos]{transition-duration:2.4s}[data-aos][data-aos][data-aos-delay=\"2400\"],body[data-aos-delay=\"2400\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2400\"].aos-animate,body[data-aos-delay=\"2400\"] [data-aos].aos-animate{transition-delay:2.4s}[data-aos][data-aos][data-aos-duration=\"2450\"],body[data-aos-duration=\"2450\"] [data-aos]{transition-duration:2.45s}[data-aos][data-aos][data-aos-delay=\"2450\"],body[data-aos-delay=\"2450\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2450\"].aos-animate,body[data-aos-delay=\"2450\"] [data-aos].aos-animate{transition-delay:2.45s}[data-aos][data-aos][data-aos-duration=\"2500\"],body[data-aos-duration=\"2500\"] [data-aos]{transition-duration:2.5s}[data-aos][data-aos][data-aos-delay=\"2500\"],body[data-aos-delay=\"2500\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2500\"].aos-animate,body[data-aos-delay=\"2500\"] [data-aos].aos-animate{transition-delay:2.5s}[data-aos][data-aos][data-aos-duration=\"2550\"],body[data-aos-duration=\"2550\"] [data-aos]{transition-duration:2.55s}[data-aos][data-aos][data-aos-delay=\"2550\"],body[data-aos-delay=\"2550\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2550\"].aos-animate,body[data-aos-delay=\"2550\"] [data-aos].aos-animate{transition-delay:2.55s}[data-aos][data-aos][data-aos-duration=\"2600\"],body[data-aos-duration=\"2600\"] [data-aos]{transition-duration:2.6s}[data-aos][data-aos][data-aos-delay=\"2600\"],body[data-aos-delay=\"2600\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2600\"].aos-animate,body[data-aos-delay=\"2600\"] [data-aos].aos-animate{transition-delay:2.6s}[data-aos][data-aos][data-aos-duration=\"2650\"],body[data-aos-duration=\"2650\"] [data-aos]{transition-duration:2.65s}[data-aos][data-aos][data-aos-delay=\"2650\"],body[data-aos-delay=\"2650\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2650\"].aos-animate,body[data-aos-delay=\"2650\"] [data-aos].aos-animate{transition-delay:2.65s}[data-aos][data-aos][data-aos-duration=\"2700\"],body[data-aos-duration=\"2700\"] [data-aos]{transition-duration:2.7s}[data-aos][data-aos][data-aos-delay=\"2700\"],body[data-aos-delay=\"2700\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2700\"].aos-animate,body[data-aos-delay=\"2700\"] [data-aos].aos-animate{transition-delay:2.7s}[data-aos][data-aos][data-aos-duration=\"2750\"],body[data-aos-duration=\"2750\"] [data-aos]{transition-duration:2.75s}[data-aos][data-aos][data-aos-delay=\"2750\"],body[data-aos-delay=\"2750\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2750\"].aos-animate,body[data-aos-delay=\"2750\"] [data-aos].aos-animate{transition-delay:2.75s}[data-aos][data-aos][data-aos-duration=\"2800\"],body[data-aos-duration=\"2800\"] [data-aos]{transition-duration:2.8s}[data-aos][data-aos][data-aos-delay=\"2800\"],body[data-aos-delay=\"2800\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2800\"].aos-animate,body[data-aos-delay=\"2800\"] [data-aos].aos-animate{transition-delay:2.8s}[data-aos][data-aos][data-aos-duration=\"2850\"],body[data-aos-duration=\"2850\"] [data-aos]{transition-duration:2.85s}[data-aos][data-aos][data-aos-delay=\"2850\"],body[data-aos-delay=\"2850\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2850\"].aos-animate,body[data-aos-delay=\"2850\"] [data-aos].aos-animate{transition-delay:2.85s}[data-aos][data-aos][data-aos-duration=\"2900\"],body[data-aos-duration=\"2900\"] [data-aos]{transition-duration:2.9s}[data-aos][data-aos][data-aos-delay=\"2900\"],body[data-aos-delay=\"2900\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2900\"].aos-animate,body[data-aos-delay=\"2900\"] [data-aos].aos-animate{transition-delay:2.9s}[data-aos][data-aos][data-aos-duration=\"2950\"],body[data-aos-duration=\"2950\"] [data-aos]{transition-duration:2.95s}[data-aos][data-aos][data-aos-delay=\"2950\"],body[data-aos-delay=\"2950\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"2950\"].aos-animate,body[data-aos-delay=\"2950\"] [data-aos].aos-animate{transition-delay:2.95s}[data-aos][data-aos][data-aos-duration=\"3000\"],body[data-aos-duration=\"3000\"] [data-aos]{transition-duration:3s}[data-aos][data-aos][data-aos-delay=\"3000\"],body[data-aos-delay=\"3000\"] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay=\"3000\"].aos-animate,body[data-aos-delay=\"3000\"] [data-aos].aos-animate{transition-delay:3s}[data-aos][data-aos][data-aos-easing=linear],body[data-aos-easing=linear] [data-aos]{transition-timing-function:cubic-bezier(.25,.25,.75,.75)}[data-aos][data-aos][data-aos-easing=ease],body[data-aos-easing=ease] [data-aos]{transition-timing-function:ease}[data-aos][data-aos][data-aos-easing=ease-in],body[data-aos-easing=ease-in] [data-aos]{transition-timing-function:ease-in}[data-aos][data-aos][data-aos-easing=ease-out],body[data-aos-easing=ease-out] [data-aos]{transition-timing-function:ease-out}[data-aos][data-aos][data-aos-easing=ease-in-out],body[data-aos-easing=ease-in-out] [data-aos]{transition-timing-function:ease-in-out}[data-aos][data-aos][data-aos-easing=ease-in-back],body[data-aos-easing=ease-in-back] [data-aos]{transition-timing-function:cubic-bezier(.6,-.28,.735,.045)}[data-aos][data-aos][data-aos-easing=ease-out-back],body[data-aos-easing=ease-out-back] [data-aos]{transition-timing-function:cubic-bezier(.175,.885,.32,1.275)}[data-aos][data-aos][data-aos-easing=ease-in-out-back],body[data-aos-easing=ease-in-out-back] [data-aos]{transition-timing-function:cubic-bezier(.68,-.55,.265,1.55)}[data-aos][data-aos][data-aos-easing=ease-in-sine],body[data-aos-easing=ease-in-sine] [data-aos]{transition-timing-function:cubic-bezier(.47,0,.745,.715)}[data-aos][data-aos][data-aos-easing=ease-out-sine],body[data-aos-easing=ease-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.39,.575,.565,1)}[data-aos][data-aos][data-aos-easing=ease-in-out-sine],body[data-aos-easing=ease-in-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.445,.05,.55,.95)}[data-aos][data-aos][data-aos-easing=ease-in-quad],body[data-aos-easing=ease-in-quad] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quad],body[data-aos-easing=ease-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quad],body[data-aos-easing=ease-in-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-cubic],body[data-aos-easing=ease-in-cubic] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-cubic],body[data-aos-easing=ease-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-cubic],body[data-aos-easing=ease-in-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-quart],body[data-aos-easing=ease-in-quart] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quart],body[data-aos-easing=ease-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quart],body[data-aos-easing=ease-in-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos^=fade][data-aos^=fade]{opacity:0;transition-property:opacity,transform}[data-aos^=fade][data-aos^=fade].aos-animate{opacity:1;transform:translateZ(0)}[data-aos=fade-up]{transform:translate3d(0,100px,0)}[data-aos=fade-down]{transform:translate3d(0,-100px,0)}[data-aos=fade-right]{transform:translate3d(-100px,0,0)}[data-aos=fade-left]{transform:translate3d(100px,0,0)}[data-aos=fade-up-right]{transform:translate3d(-100px,100px,0)}[data-aos=fade-up-left]{transform:translate3d(100px,100px,0)}[data-aos=fade-down-right]{transform:translate3d(-100px,-100px,0)}[data-aos=fade-down-left]{transform:translate3d(100px,-100px,0)}[data-aos^=zoom][data-aos^=zoom]{opacity:0;transition-property:opacity,transform}[data-aos^=zoom][data-aos^=zoom].aos-animate{opacity:1;transform:translateZ(0) scale(1)}[data-aos=zoom-in]{transform:scale(.6)}[data-aos=zoom-in-up]{transform:translate3d(0,100px,0) scale(.6)}[data-aos=zoom-in-down]{transform:translate3d(0,-100px,0) scale(.6)}[data-aos=zoom-in-right]{transform:translate3d(-100px,0,0) scale(.6)}[data-aos=zoom-in-left]{transform:translate3d(100px,0,0) scale(.6)}[data-aos=zoom-out]{transform:scale(1.2)}[data-aos=zoom-out-up]{transform:translate3d(0,100px,0) scale(1.2)}[data-aos=zoom-out-down]{transform:translate3d(0,-100px,0) scale(1.2)}[data-aos=zoom-out-right]{transform:translate3d(-100px,0,0) scale(1.2)}[data-aos=zoom-out-left]{transform:translate3d(100px,0,0) scale(1.2)}[data-aos^=slide][data-aos^=slide]{transition-property:transform}[data-aos^=slide][data-aos^=slide].aos-animate{transform:translateZ(0)}[data-aos=slide-up]{transform:translate3d(0,100%,0)}[data-aos=slide-down]{transform:translate3d(0,-100%,0)}[data-aos=slide-right]{transform:translate3d(-100%,0,0)}[data-aos=slide-left]{transform:translate3d(100%,0,0)}[data-aos^=flip][data-aos^=flip]{backface-visibility:hidden;transition-property:transform}[data-aos=flip-left]{transform:perspective(2500px) rotateY(-100deg)}[data-aos=flip-left].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-right]{transform:perspective(2500px) rotateY(100deg)}[data-aos=flip-right].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-up]{transform:perspective(2500px) rotateX(-100deg)}[data-aos=flip-up].aos-animate{transform:perspective(2500px) rotateX(0)}[data-aos=flip-down]{transform:perspective(2500px) rotateX(100deg)}[data-aos=flip-down].aos-animate{transform:perspective(2500px) rotateX(0)}\n  /*!****************************************************************************!*\\\n    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/css/lenis.css ***!\n    \\****************************************************************************/\n  html.lenis,\n  html.lenis body {\n    height: auto;\n  }\n  .lenis.lenis-smooth [data-lenis-prevent] {\n    overscroll-behavior: contain;\n  }\n  .lenis.lenis-stopped {\n    overflow: clip;\n  }\n  .lenis.lenis-smooth iframe {\n    pointer-events: none;\n  }\n  \n  /*!***********************************************************************************!*\\\n    !*** css ./node_modules/css-loader/dist/cjs.js!./src/assets/fonts/fontssheet.css ***!\n    \\***********************************************************************************/\n  /* @font-face {\n      font-family: 'Outfit';\n      src: url(../../e1ea969df8d6180041fc.woff2) format('woff2'),\n          url(../../a5e8bfd70b3d1e85cac5.woff) format('woff');\n      font-weight: 900;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../666034473b9e795630bc.woff2) format('woff2'),\n          url(../../c74427bd9ad8aa578047.woff) format('woff');\n      font-weight: 100;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../f57facd89540c8266079.woff2) format('woff2'),\n          url(../../d9020b8d98ddb5dd0096.woff) format('woff');\n      font-weight: bold;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../2042e98f726bba6575a4.woff2) format('woff2'),\n          url(../../d3b8dfd22bd5c5321ee3.woff) format('woff');\n      font-weight: 200;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../f06abb0216a6d29d98e5.woff2) format('woff2'),\n          url(../../e59dd696d0eaa24d06a2.woff) format('woff');\n      font-weight: 500;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../f45af692fc4b8e0ebb13.woff2) format('woff2'),\n          url(../../48c93fcdf7aca0b7d879.woff) format('woff');\n      font-weight: 600;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../2905368f4c2d332bb2f5.woff2) format('woff2'),\n          url(../../986130b3058b61f28dd6.woff) format('woff');\n      font-weight: bold;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../4778f5f8a0f7abc3264c.woff2) format('woff2'),\n          url(../../b37239988a1c40c98331.woff) format('woff');\n      font-weight: 300;\n      font-style: normal;\n      font-display: swap;\n  }\n  \n  @font-face {\n      font-family: 'Outfit';\n      src: url(../../74ec9eaf7e28cc27b2b5.woff2) format('woff2'),\n          url(../../705e9dc8aaf333441d29.woff) format('woff');\n      font-weight: normal;\n      font-style: normal;\n      font-display: swap;\n  } */\n  \n  \n  /*!************************************************************************************************************************************************************************************!*\\\n    !*** css ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].use[2]!./node_modules/sass-loader/dist/cjs.js!./src/scss/style.scss ***!\n    \\************************************************************************************************************************************************************************************/\n  /*\n  Template Name: gameWolf - gaming HTML Template;\n  Author: ThemesWolf;\n  Version: 1.0;\n  Description: gaming HTML Template;\n  Tags: HTML, SASS, Tailwind CSS,  JavaScript;\n  */\n  /*\n  ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com\n  */\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n  */\n  *,\n  ::before,\n  ::after {\n    box-sizing: border-box; /* 1 */\n    border-width: 0; /* 2 */\n    border-style: solid; /* 2 */\n    border-color: #e5e7eb; /* 2 */\n  }\n  ::before,\n  ::after {\n    --tw-content: '';\n  }\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS\n  */\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    -moz-tab-size: 4; /* 3 */\n    -o-tab-size: 4;\n       tab-size: 4; /* 3 */\n    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; /* 4 */\n    font-feature-settings: normal; /* 5 */\n    font-variation-settings: normal; /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n  /*\n  1. Remove the margin in all browsers.\n  2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n  */\n  body {\n    margin: 0; /* 1 */\n    line-height: inherit; /* 2 */\n  }\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Ensure horizontal rules are visible by default.\n  */\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n  */\n  abbr:where([title]) {\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n            text-decoration: underline dotted;\n  }\n  /*\n  Remove the default font size and weight for headings.\n  */\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n  */\n  a {\n    color: inherit;\n    text-decoration: inherit;\n  }\n  /*\n  Add the correct font weight in Edge and Safari.\n  */\n  b,\n  strong {\n    font-weight: bolder;\n  }\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n  */\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n    font-feature-settings: normal; /* 2 */\n    font-variation-settings: normal; /* 3 */\n    font-size: 1em; /* 4 */\n  }\n  /*\n  Add the correct font size in all browsers.\n  */\n  small {\n    font-size: 80%;\n  }\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n  */\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n  */\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n  /*\n  1. Change the font styles in all browsers.\n  2. Remove the margin in Firefox and Safari.\n  3. Remove default padding in all browsers.\n  */\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    font-size: 100%; /* 1 */\n    font-weight: inherit; /* 1 */\n    line-height: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 3 */\n  }\n  /*\n  Remove the inheritance of text transform in Edge and Firefox.\n  */\n  button,\n  select {\n    text-transform: none;\n  }\n  /*\n  1. Correct the inability to style clickable types in iOS and Safari.\n  2. Remove default button styles.\n  */\n  button,\n  input:where([type='button']),\n  input:where([type='reset']),\n  input:where([type='submit']) {\n    -webkit-appearance: button; /* 1 */\n    background-color: transparent; /* 2 */\n    background-image: none; /* 2 */\n  }\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n  */\n  :-moz-focusring {\n    outline: auto;\n  }\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n  */\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n  */\n  progress {\n    vertical-align: baseline;\n  }\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n  */\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n  /*\n  1. Correct the odd appearance in Chrome and Safari.\n  2. Correct the outline style in Safari.\n  */\n  [type='search'] {\n    -webkit-appearance: textfield; /* 1 */\n    outline-offset: -2px; /* 2 */\n  }\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n  */\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  /*\n  1. Correct the inability to style clickable types in iOS and Safari.\n  2. Change font properties to `inherit` in Safari.\n  */\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; /* 1 */\n    font: inherit; /* 2 */\n  }\n  /*\n  Add the correct display in Chrome and Safari.\n  */\n  summary {\n    display: list-item;\n  }\n  /*\n  Removes the default spacing and border for appropriate elements.\n  */\n  blockquote,\n  dl,\n  dd,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  hr,\n  figure,\n  p,\n  pre {\n    margin: 0;\n  }\n  fieldset {\n    margin: 0;\n    padding: 0;\n  }\n  legend {\n    padding: 0;\n  }\n  ol,\n  ul,\n  menu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n  /*\n  Reset default styling for dialogs.\n  */\n  dialog {\n    padding: 0;\n  }\n  /*\n  Prevent resizing textareas horizontally by default.\n  */\n  textarea {\n    resize: vertical;\n  }\n  /*\n  1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n  2. Set the default placeholder color to the user's configured gray 400 color.\n  */\n  input::-moz-placeholder, textarea::-moz-placeholder {\n    opacity: 1; /* 1 */\n    color: #9ca3af; /* 2 */\n  }\n  input::placeholder,\n  textarea::placeholder {\n    opacity: 1; /* 1 */\n    color: #9ca3af; /* 2 */\n  }\n  /*\n  Set the default cursor for buttons.\n  */\n  button,\n  [role=\"button\"] {\n    cursor: pointer;\n  }\n  /*\n  Make sure disabled buttons don't get the pointer cursor.\n  */\n  :disabled {\n    cursor: default;\n  }\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n     This can trigger a poorly considered lint error in some tools but is included by design.\n  */\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n  */\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n  /* Make elements with the HTML hidden attribute stay hidden by default */\n  [hidden] {\n    display: none;\n  }\n  i {\n      font-size: 1.5rem;\n    }\n  a,\n    p,\n    span,\n    td{\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    font-weight: 300;\n  }\n  @media (min-width: 768px){\n    a,\n    p,\n    span,\n    td{\n      font-size: 1.125rem;\n      line-height: 1.75rem;\n    }\n  }\n  span{\n    display: block;\n  }\n  h1{\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 120%;\n  }\n  @media (min-width: 576px){\n    h1{\n      font-size: 24px;\n    }\n  }\n  @media (min-width: 768px){\n    h1{\n      font-size: 36px;\n    }\n  }\n  @media (min-width: 1200px){\n    h1{\n      font-size: 64px;\n    }\n  }\n  h2{\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 120%;\n  }\n  @media (min-width: 576px){\n    h2{\n      font-size: 24px;\n    }\n  }\n  @media (min-width: 992px){\n    h2{\n      font-size: 30px;\n    }\n  }\n  @media (min-width: 1200px){\n    h2{\n      font-size: 40px;\n    }\n  }\n  h3{\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 120%;\n  }\n  @media (min-width: 576px){\n    h3{\n      font-weight: 700;\n    }\n  }\n  @media (min-width: 992px){\n    h3{\n      font-size: 24px;\n    }\n  }\n  @media (min-width: 1200px){\n    h3{\n      font-size: 32px;\n    }\n  }\n  h4{\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 120%;\n  }\n  @media (min-width: 768px){\n    h4{\n      font-size: 20px;\n      font-weight: 700;\n    }\n  }\n  @media (min-width: 1200px){\n    h4{\n      font-size: 24px;\n    }\n  }\n  h5{\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 150%;\n  }\n  @media (min-width: 768px){\n    h5{\n      font-size: 20px;\n      font-weight: 700;\n    }\n  }\n  h6{\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 150%;\n    --tw-shadow: 0 0 rgba(0,0,0,0);\n    --tw-shadow-colored: 0 0 rgba(0,0,0,0);\n    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);\n  }\n  input:focus,\n    textarea:focus{\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  *, ::before, ::after{\n    --tw-border-spacing-x: 0;\n    --tw-border-spacing-y: 0;\n    --tw-translate-x: 0;\n    --tw-translate-y: 0;\n    --tw-rotate: 0;\n    --tw-skew-x: 0;\n    --tw-skew-y: 0;\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    --tw-pan-x:  ;\n    --tw-pan-y:  ;\n    --tw-pinch-zoom:  ;\n    --tw-scroll-snap-strictness: proximity;\n    --tw-gradient-from-position:  ;\n    --tw-gradient-via-position:  ;\n    --tw-gradient-to-position:  ;\n    --tw-ordinal:  ;\n    --tw-slashed-zero:  ;\n    --tw-numeric-figure:  ;\n    --tw-numeric-spacing:  ;\n    --tw-numeric-fraction:  ;\n    --tw-ring-inset:  ;\n    --tw-ring-offset-width: 0px;\n    --tw-ring-offset-color: #fff;\n    --tw-ring-color: rgba(59, 130, 246, 0.5);\n    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);\n    --tw-ring-shadow: 0 0 rgba(0,0,0,0);\n    --tw-shadow: 0 0 rgba(0,0,0,0);\n    --tw-shadow-colored: 0 0 rgba(0,0,0,0);\n    --tw-blur:  ;\n    --tw-brightness:  ;\n    --tw-contrast:  ;\n    --tw-grayscale:  ;\n    --tw-hue-rotate:  ;\n    --tw-invert:  ;\n    --tw-saturate:  ;\n    --tw-sepia:  ;\n    --tw-drop-shadow:  ;\n    --tw-backdrop-blur:  ;\n    --tw-backdrop-brightness:  ;\n    --tw-backdrop-contrast:  ;\n    --tw-backdrop-grayscale:  ;\n    --tw-backdrop-hue-rotate:  ;\n    --tw-backdrop-invert:  ;\n    --tw-backdrop-opacity:  ;\n    --tw-backdrop-saturate:  ;\n    --tw-backdrop-sepia:  ;\n    --tw-contain-size:  ;\n    --tw-contain-layout:  ;\n    --tw-contain-paint:  ;\n    --tw-contain-style:  ;\n  }\n  ::backdrop{\n    --tw-border-spacing-x: 0;\n    --tw-border-spacing-y: 0;\n    --tw-translate-x: 0;\n    --tw-translate-y: 0;\n    --tw-rotate: 0;\n    --tw-skew-x: 0;\n    --tw-skew-y: 0;\n    --tw-scale-x: 1;\n    --tw-scale-y: 1;\n    --tw-pan-x:  ;\n    --tw-pan-y:  ;\n    --tw-pinch-zoom:  ;\n    --tw-scroll-snap-strictness: proximity;\n    --tw-gradient-from-position:  ;\n    --tw-gradient-via-position:  ;\n    --tw-gradient-to-position:  ;\n    --tw-ordinal:  ;\n    --tw-slashed-zero:  ;\n    --tw-numeric-figure:  ;\n    --tw-numeric-spacing:  ;\n    --tw-numeric-fraction:  ;\n    --tw-ring-inset:  ;\n    --tw-ring-offset-width: 0px;\n    --tw-ring-offset-color: #fff;\n    --tw-ring-color: rgba(59, 130, 246, 0.5);\n    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);\n    --tw-ring-shadow: 0 0 rgba(0,0,0,0);\n    --tw-shadow: 0 0 rgba(0,0,0,0);\n    --tw-shadow-colored: 0 0 rgba(0,0,0,0);\n    --tw-blur:  ;\n    --tw-brightness:  ;\n    --tw-contrast:  ;\n    --tw-grayscale:  ;\n    --tw-hue-rotate:  ;\n    --tw-invert:  ;\n    --tw-saturate:  ;\n    --tw-sepia:  ;\n    --tw-drop-shadow:  ;\n    --tw-backdrop-blur:  ;\n    --tw-backdrop-brightness:  ;\n    --tw-backdrop-contrast:  ;\n    --tw-backdrop-grayscale:  ;\n    --tw-backdrop-hue-rotate:  ;\n    --tw-backdrop-invert:  ;\n    --tw-backdrop-opacity:  ;\n    --tw-backdrop-saturate:  ;\n    --tw-backdrop-sepia:  ;\n    --tw-contain-size:  ;\n    --tw-contain-layout:  ;\n    --tw-contain-paint:  ;\n    --tw-contain-style:  ;\n  }\n  .container{\n    width: 100%;\n  }\n  @media (min-width: 576px){\n    .container{\n      max-width: 576px;\n    }\n  }\n  @media (min-width: 768px){\n    .container{\n      max-width: 768px;\n    }\n  }\n  @media (min-width: 992px){\n    .container{\n      max-width: 992px;\n    }\n  }\n  @media (min-width: 1200px){\n    .container{\n      max-width: 1200px;\n    }\n  }\n  @media (min-width: 1296px){\n    .container{\n      max-width: 1296px;\n    }\n  }\n  @media (min-width: 1600px){\n    .container{\n      max-width: 1600px;\n    }\n  }\n  @media (min-width: 1800px){\n    .container{\n      max-width: 1800px;\n    }\n  }\n  .container{\n    margin-left: auto;\n    margin-right: auto;\n  }\n  @media not all and (min-width: 576px){\n    .container{\n      padding-left: 0.75rem;\n      padding-right: 0.75rem;\n    }\n  }\n  @media (min-width: 576px){\n    .container{\n      max-width: 540px;\n      padding-left: 0px;\n      padding-right: 0px;\n    }\n  }\n  @media (min-width: 768px){\n    .container{\n      max-width: 720px;\n    }\n  }\n  @media (min-width: 992px){\n    .container{\n      max-width: 960px;\n    }\n  }\n  @media (min-width: 1200px){\n    .container{\n      max-width: 1140px;\n    }\n  }\n  @media (min-width: 1296px){\n    .container{\n      max-width: 1296px;\n    }\n  }\n  .lin {\n      color: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    }\n  .visible{\n    visibility: visible;\n  }\n  .collapse{\n    visibility: collapse;\n  }\n  .static{\n    position: static;\n  }\n  .fixed{\n    position: fixed;\n  }\n  .absolute{\n    position: absolute;\n  }\n  .relative{\n    position: relative;\n  }\n  .sticky{\n    position: sticky;\n  }\n  .bottom-\\[18px\\]{\n    bottom: 18px;\n  }\n  .bottom-\\[20px\\]{\n    bottom: 20px;\n  }\n  .left-0{\n    left: 0px;\n  }\n  .left-1\\/2{\n    left: 50%;\n  }\n  .right-0{\n    right: 0px;\n  }\n  .top-0{\n    top: 0px;\n  }\n  .top-1\\/2{\n    top: 50%;\n  }\n  .-z-10{\n    z-index: -10;\n  }\n  .z-0{\n    z-index: 0;\n  }\n  .z-10{\n    z-index: 10;\n  }\n  .z-30{\n    z-index: 30;\n  }\n  .z-40{\n    z-index: 40;\n  }\n  .col-span-12{\n    grid-column: span 12 / span 12;\n  }\n  .col-span-2{\n    grid-column: span 2 / span 2;\n  }\n  .col-span-6{\n    grid-column: span 6 / span 6;\n  }\n  .m-auto{\n    margin: auto;\n  }\n  .-mx-5{\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n  .mx-0{\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  .mx-4{\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  .my-4{\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .-ml-4{\n    margin-left: -1rem;\n  }\n  .-ml-5{\n    margin-left: -1.25rem;\n  }\n  .-ml-6{\n    margin-left: -1.5rem;\n  }\n  .-ml-\\[14px\\]{\n    margin-left: -14px;\n  }\n  .-mt-4{\n    margin-top: -1rem;\n  }\n  .-mt-5{\n    margin-top: -1.25rem;\n  }\n  .-mt-8{\n    margin-top: -2rem;\n  }\n  .-mt-\\[0\\.6rem\\]{\n    margin-top: -0.6rem;\n  }\n  .-mt-\\[16px\\]{\n    margin-top: -16px;\n  }\n  .-mt-\\[30px\\]{\n    margin-top: -30px;\n  }\n  .mb-3{\n    margin-bottom: 0.75rem;\n  }\n  .mb-4{\n    margin-bottom: 1rem;\n  }\n  .ml-0{\n    margin-left: 0px;\n  }\n  .ml-1{\n    margin-left: 0.25rem;\n  }\n  .ml-2{\n    margin-left: 0.5rem;\n  }\n  .ml-3{\n    margin-left: 0.75rem;\n  }\n  .ml-4{\n    margin-left: 1rem;\n  }\n  .ml-\\[10rem\\]{\n    margin-left: 10rem;\n  }\n  .ml-\\[6rem\\]{\n    margin-left: 6rem;\n  }\n  .ml-\\[8px\\]{\n    margin-left: 8px;\n  }\n  .mr-2{\n    margin-right: 0.5rem;\n  }\n  .mr-\\[0\\.5rem\\]{\n    margin-right: 0.5rem;\n  }\n  .mt-1{\n    margin-top: 0.25rem;\n  }\n  .mt-10{\n    margin-top: 2.5rem;\n  }\n  .mt-2{\n    margin-top: 0.5rem;\n  }\n  .mt-3{\n    margin-top: 0.75rem;\n  }\n  .mt-4{\n    margin-top: 1rem;\n  }\n  .mt-6{\n    margin-top: 1.5rem;\n  }\n  .mt-\\[1\\.5rem\\]{\n    margin-top: 1.5rem;\n  }\n  .mt-\\[24\\%\\]{\n    margin-top: 24%;\n  }\n  .mt-\\[2rem\\]{\n    margin-top: 2rem;\n  }\n  .block{\n    display: block;\n  }\n  .inline-block{\n    display: inline-block;\n  }\n  .inline{\n    display: inline;\n  }\n  .flex{\n    display: flex;\n  }\n  .table{\n    display: table;\n  }\n  .grid{\n    display: grid;\n  }\n  .contents{\n    display: contents;\n  }\n  .hidden{\n    display: none;\n  }\n  .size-10{\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n  .size-9{\n    width: 2.25rem;\n    height: 2.25rem;\n  }\n  .h-\\[100px\\]{\n    height: 100px;\n  }\n  .h-\\[110px\\]{\n    height: 110px;\n  }\n  .h-\\[220px\\]{\n    height: 220px;\n  }\n  .h-\\[25px\\]{\n    height: 25px;\n  }\n  .h-\\[34px\\]{\n    height: 34px;\n  }\n  .h-\\[40px\\]{\n    height: 40px;\n  }\n  .h-\\[50px\\]{\n    height: 50px;\n  }\n  .h-auto{\n    height: auto;\n  }\n  .h-full{\n    height: 100%;\n  }\n  .\\!w-fit{\n    width: -moz-fit-content !important;\n    width: fit-content !important;\n  }\n  .w-\\[100px\\]{\n    width: 100px;\n  }\n  .w-\\[140px\\]{\n    width: 140px;\n  }\n  .w-\\[200px\\]{\n    width: 200px;\n  }\n  .w-\\[240px\\]{\n    width: 240px;\n  }\n  .w-\\[25px\\]{\n    width: 25px;\n  }\n  .w-\\[34px\\]{\n    width: 34px;\n  }\n  .w-\\[40\\%\\]{\n    width: 40%;\n  }\n  .w-\\[40px\\]{\n    width: 40px;\n  }\n  .w-\\[45px\\]{\n    width: 45px;\n  }\n  .w-\\[50px\\]{\n    width: 50px;\n  }\n  .w-full{\n    width: 100%;\n  }\n  .-translate-x-1\\/2{\n    --tw-translate-x: -50%;\n    transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n  .-translate-y-1\\/2{\n    --tw-translate-y: -50%;\n    transform: translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n  .-rotate-3{\n    --tw-rotate: -3deg;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-3deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n  .rotate-3{\n    --tw-rotate: 3deg;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(3deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n  .transform{\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n  .cursor-pointer{\n    cursor: pointer;\n  }\n  .resize{\n    resize: both;\n  }\n  .grid-cols-10{\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n  .grid-cols-12{\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n  .flex-col{\n    flex-direction: column;\n  }\n  .flex-wrap{\n    flex-wrap: wrap;\n  }\n  .items-center{\n    align-items: center;\n  }\n  .justify-end{\n    justify-content: flex-end;\n  }\n  .justify-center{\n    justify-content: center;\n  }\n  .justify-between{\n    justify-content: space-between;\n  }\n  .gap-1{\n    gap: 0.25rem;\n  }\n  .gap-2{\n    gap: 0.5rem;\n  }\n  .gap-3{\n    gap: 0.75rem;\n  }\n  .gap-4{\n    gap: 1rem;\n  }\n  .gap-6{\n    gap: 1.5rem;\n  }\n  .gap-8{\n    gap: 2rem;\n  }\n  .overflow-hidden{\n    overflow: hidden;\n  }\n  .overflow-scroll{\n    overflow: scroll;\n  }\n  .overflow-x-hidden{\n    overflow-x: hidden;\n  }\n  .rounded-2xl{\n    border-radius: 1rem;\n  }\n  .rounded-3xl{\n    border-radius: 1.5rem;\n  }\n  .rounded-full{\n    border-radius: 9999px;\n  }\n  .rounded-lg{\n    border-radius: 0.5rem;\n  }\n  .rounded-xl{\n    border-radius: 0.75rem;\n  }\n  .rounded-b-2xl{\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n  .rounded-b-3xl{\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n  .rounded-t-2xl{\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n  .rounded-t-3xl{\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n  .border{\n    border-width: 1px;\n  }\n  .border-2{\n    border-width: 2px;\n  }\n  .border-b-2{\n    border-bottom-width: 2px;\n  }\n  .border-t-2{\n    border-top-width: 2px;\n  }\n  .border-dotted{\n    border-style: dotted;\n  }\n  .border-none{\n    border-style: none;\n  }\n  .border-nu2{\n    --tw-border-opacity: 1;\n    border-color: rgba(15, 15, 15, 1);\n    border-color: rgba(15, 15, 15, var(--tw-border-opacity));\n  }\n  .border-nu4{\n    --tw-border-opacity: 1;\n    border-color: rgba(24, 25, 31, 1);\n    border-color: rgba(24, 25, 31, var(--tw-border-opacity));\n  }\n  .border-nu7{\n    --tw-border-opacity: 1;\n    border-color: rgba(19, 24, 31, 1);\n    border-color: rgba(19, 24, 31, var(--tw-border-opacity));\n  }\n  .border-nu8{\n    --tw-border-opacity: 1;\n    border-color: rgba(35, 38, 39, 1);\n    border-color: rgba(35, 38, 39, var(--tw-border-opacity));\n  }\n  .border-nu9{\n    --tw-border-opacity: 1;\n    border-color: rgba(135, 139, 149, 1);\n    border-color: rgba(135, 139, 149, var(--tw-border-opacity));\n  }\n  .border-primary{\n    --tw-border-opacity: 1;\n    border-color: rgba(255, 50, 90, 1);\n    border-color: rgba(255, 50, 90, var(--tw-border-opacity));\n  }\n  .border-secondary{\n    --tw-border-opacity: 1;\n    border-color: rgba(242, 150, 32, 1);\n    border-color: rgba(242, 150, 32, var(--tw-border-opacity));\n  }\n  .border-white{\n    --tw-border-opacity: 1;\n    border-color: rgba(255, 255, 255, 1);\n    border-color: rgba(255, 255, 255, var(--tw-border-opacity));\n  }\n  .bg-nu12{\n    --tw-bg-opacity: 1;\n    background-color: rgba(0, 0, 0, 1);\n    background-color: rgba(0, 0, 0, var(--tw-bg-opacity));\n  }\n  .bg-nu2{\n    --tw-bg-opacity: 1;\n    background-color: rgba(15, 15, 15, 1);\n    background-color: rgba(15, 15, 15, var(--tw-bg-opacity));\n  }\n  .bg-nu4{\n    --tw-bg-opacity: 1;\n    background-color: rgba(24, 25, 31, 1);\n    background-color: rgba(24, 25, 31, var(--tw-bg-opacity));\n  }\n  .bg-nu6{\n    --tw-bg-opacity: 1;\n    background-color: rgba(52, 56, 57, 1);\n    background-color: rgba(52, 56, 57, var(--tw-bg-opacity));\n  }\n  .bg-nu7{\n    --tw-bg-opacity: 1;\n    background-color: rgba(19, 24, 31, 1);\n    background-color: rgba(19, 24, 31, var(--tw-bg-opacity));\n  }\n  .bg-nu8{\n    --tw-bg-opacity: 1;\n    background-color: rgba(35, 38, 39, 1);\n    background-color: rgba(35, 38, 39, var(--tw-bg-opacity));\n  }\n  .bg-primary{\n    --tw-bg-opacity: 1;\n    background-color: rgba(255, 50, 90, 1);\n    background-color: rgba(255, 50, 90, var(--tw-bg-opacity));\n  }\n  .bg-secondary{\n    --tw-bg-opacity: 1;\n    background-color: rgba(242, 150, 32, 1);\n    background-color: rgba(242, 150, 32, var(--tw-bg-opacity));\n  }\n  .object-cover{\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n  .px-1{\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .px-10{\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .px-2{\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .px-24{\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n  .px-28{\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n  .px-3{\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .px-4{\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .px-5{\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .px-6{\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .px-7{\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .px-8{\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .px-\\[2px\\]{\n    padding-left: 2px;\n    padding-right: 2px;\n  }\n  .px-\\[3px\\]{\n    padding-left: 3px;\n    padding-right: 3px;\n  }\n  .px-\\[8px\\]{\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n  .py-0{\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n  .py-1{\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .py-10{\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .py-12{\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n  .py-2{\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .py-3{\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .py-4{\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .py-6{\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .py-8{\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .py-\\[10px\\]{\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .py-\\[110px\\]{\n    padding-top: 110px;\n    padding-bottom: 110px;\n  }\n  .py-\\[2px\\]{\n    padding-top: 2px;\n    padding-bottom: 2px;\n  }\n  .py-\\[3px\\]{\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n  .py-\\[60px\\]{\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n  .py-\\[6px\\]{\n    padding-top: 6px;\n    padding-bottom: 6px;\n  }\n  .pb-10{\n    padding-bottom: 2.5rem;\n  }\n  .pb-12{\n    padding-bottom: 3rem;\n  }\n  .pb-2{\n    padding-bottom: 0.5rem;\n  }\n  .pb-20{\n    padding-bottom: 5rem;\n  }\n  .pb-3{\n    padding-bottom: 0.75rem;\n  }\n  .pb-4{\n    padding-bottom: 1rem;\n  }\n  .pb-6{\n    padding-bottom: 1.5rem;\n  }\n  .pb-8{\n    padding-bottom: 2rem;\n  }\n  .pb-\\[10px\\]{\n    padding-bottom: 10px;\n  }\n  .pb-\\[2rem\\]{\n    padding-bottom: 2rem;\n  }\n  .pb-\\[90px\\]{\n    padding-bottom: 90px;\n  }\n  .pl-0{\n    padding-left: 0px;\n  }\n  .pl-1{\n    padding-left: 0.25rem;\n  }\n  .pl-2{\n    padding-left: 0.5rem;\n  }\n  .pl-3{\n    padding-left: 0.75rem;\n  }\n  .pl-4{\n    padding-left: 1rem;\n  }\n  .pl-6{\n    padding-left: 1.5rem;\n  }\n  .pr-1{\n    padding-right: 0.25rem;\n  }\n  .pr-2{\n    padding-right: 0.5rem;\n  }\n  .pr-3{\n    padding-right: 0.75rem;\n  }\n  .pr-4{\n    padding-right: 1rem;\n  }\n  .pr-\\[5px\\]{\n    padding-right: 5px;\n  }\n  .pr-\\[90px\\]{\n    padding-right: 90px;\n  }\n  .pt-0{\n    padding-top: 0px;\n  }\n  .pt-1{\n    padding-top: 0.25rem;\n  }\n  .pt-10{\n    padding-top: 2.5rem;\n  }\n  .pt-12{\n    padding-top: 3rem;\n  }\n  .pt-2{\n    padding-top: 0.5rem;\n  }\n  .pt-3{\n    padding-top: 0.75rem;\n  }\n  .pt-4{\n    padding-top: 1rem;\n  }\n  .pt-5{\n    padding-top: 1.25rem;\n  }\n  .pt-6{\n    padding-top: 1.5rem;\n  }\n  .pt-8{\n    padding-top: 2rem;\n  }\n  .pt-\\[1rem\\]{\n    padding-top: 1rem;\n  }\n  .pt-\\[2px\\]{\n    padding-top: 2px;\n  }\n  .pt-\\[60px\\]{\n    padding-top: 60px;\n  }\n  .pt-\\[6px\\]{\n    padding-top: 6px;\n  }\n  .pt-\\[6rem\\]{\n    padding-top: 6rem;\n  }\n  .text-left{\n    text-align: left;\n  }\n  .text-center{\n    text-align: center;\n  }\n  .text-\\[14px\\]{\n    font-size: 14px;\n  }\n  .text-\\[16px\\]{\n    font-size: 16px;\n  }\n  .text-\\[18px\\]{\n    font-size: 18px;\n  }\n  .text-\\[20px\\]{\n    font-size: 20px;\n  }\n  .text-\\[24px\\]{\n    font-size: 24px;\n  }\n  .text-\\[34px\\]{\n    font-size: 34px;\n  }\n  .font-bold{\n    font-weight: 700;\n  }\n  .font-medium{\n    font-weight: 500;\n  }\n  .font-semibold{\n    font-weight: 600;\n  }\n  .text-nu1{\n    --tw-text-opacity: 1;\n    color: rgba(255, 255, 255, 1);\n    color: rgba(255, 255, 255, var(--tw-text-opacity));\n  }\n  .text-nu14{\n    --tw-text-opacity: 1;\n    color: rgba(182, 182, 182, 1);\n    color: rgba(182, 182, 182, var(--tw-text-opacity));\n  }\n  .text-nu2{\n    --tw-text-opacity: 1;\n    color: rgba(15, 15, 15, 1);\n    color: rgba(15, 15, 15, var(--tw-text-opacity));\n  }\n  .text-nu3{\n    --tw-text-opacity: 1;\n    color: rgba(0, 17, 0, 1);\n    color: rgba(0, 17, 0, var(--tw-text-opacity));\n  }\n  .text-nu9{\n    --tw-text-opacity: 1;\n    color: rgba(135, 139, 149, 1);\n    color: rgba(135, 139, 149, var(--tw-text-opacity));\n  }\n  .text-primary{\n    --tw-text-opacity: 1;\n    color: rgba(255, 50, 90, 1);\n    color: rgba(255, 50, 90, var(--tw-text-opacity));\n  }\n  .text-secondary{\n    --tw-text-opacity: 1;\n    color: rgba(242, 150, 32, 1);\n    color: rgba(242, 150, 32, var(--tw-text-opacity));\n  }\n  .shadow{\n    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);\n    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\n    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);\n  }\n  .outline-none{\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n  .outline{\n    outline-style: solid;\n  }\n  .blur{\n    --tw-blur: blur(8px);\n    filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n  }\n  .invert{\n    --tw-invert: invert(100%);\n    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) invert(100%) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n  }\n  .filter{\n    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n  }\n  .transition{\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transition-duration: 150ms;\n  }\n  .duration-500{\n    transition-duration: 500ms;\n  }\n  .duration-700{\n    transition-duration: 700ms;\n  }\n  .ease-in-out{\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  input[type=number]::-webkit-inner-spin-button,\n    input[type=number]::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  @media (min-width: 576px){\n    table thead tr th:first-of-type{\n      border-top-left-radius: 0.5rem;\n    }\n    table thead tr th:last-of-type{\n      border-top-right-radius: 0.5rem;\n    }\n    table tbody tr:last-of-type td:first-of-type{\n      border-bottom-left-radius: 0.5rem;\n    }\n    table tbody tr:last-of-type td:last-of-type{\n      border-bottom-right-radius: 0.5rem;\n    }\n  }\n  td {\n      vertical-align: middle !important;\n    }\n  input[type=date]::-webkit-inner-spin-button,\n    input[type=date]::-webkit-calendar-picker-indicator {\n      display: none;\n      -webkit-appearance: none;\n    }\n  * {\n      -webkit-tap-highlight-color: transparent;\n    }\n  input:checked + div{\n    --tw-border-opacity: 1;\n    border-color: rgba(255, 50, 90, 1);\n    border-color: rgba(255, 50, 90, var(--tw-border-opacity));\n  }\n  input:checked + div svg{\n    display: block;\n  }\n  body {\n      font-family: \"Outfit\", sans-serif;\n      color: #050505;\n      margin: 0;\n      padding: 0;\n      line-height: 160%;\n      font-size: 16px;\n      overflow-y: scroll;\n    }\n  ::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  ::-webkit-scrollbar-track {\n    background-color: #263e26;\n    border-radius: 80px;\n  }\n  \n  ::-webkit-scrollbar-thumb {\n    border-radius: 80px;\n    background: #F29620;\n  }\n  \n  section,\n  footer {\n    overflow: hidden;\n    overflow-x: hidden;\n  }\n  \n  img {\n    max-width: 100%;\n    height: auto;\n  }\n  \n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n  }\n  ul li,\n  ol li {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n  \n  button {\n    border: none;\n    cursor: pointer;\n    font-size: 18px;\n    line-height: 150%;\n    padding: 0;\n    background-color: transparent;\n  }\n  \n  input,\n  textarea {\n    padding: 12px 20px;\n    width: 100%;\n    outline-color: transparent;\n    font-size: 16px;\n    border-radius: 10px;\n    background-color: transparent;\n    border: 1px solid #B3B6B9;\n  }\n  input::-moz-placeholder, textarea::-moz-placeholder {\n    color: #F5F5DC;\n    font-size: 16px;\n  }\n  input::placeholder,\n  textarea::placeholder {\n    color: #F5F5DC;\n    font-size: 16px;\n  }\n  \n  .d-center{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .max-auto {\n    max-width: 100%;\n  }\n  \n  .max-un {\n    max-width: none;\n    max-width: initial;\n  }\n  \n  .d-rtl {\n    direction: rtl;\n  }\n  \n  .v-line::before {\n    position: absolute;\n    content: \"\";\n    width: 1px;\n    height: 40px;\n    background-color: #222;\n  }\n  .v-line.lg::before{\n    height: 60px;\n    width: 0.125rem;\n    opacity: 0.4;\n  }\n  @media (min-width: 992px){\n    .v-line.lg::before{\n      height: 60px;\n    }\n  }\n  .v-line.lgx::before{\n    height: 173px;\n    width: 1px;\n    --tw-bg-opacity: 1;\n    background-color: rgba(179, 182, 185, 1);\n    background-color: rgba(179, 182, 185, var(--tw-bg-opacity));\n    opacity: 0.3;\n  }\n  .v-line.lg2::before {\n    height: 17px;\n    padding: 1px;\n    background-color: rgba(var(--s2), 1) !important;\n  }\n  .v-line.xl::before {\n    background-color: rgb(var(--p7)) !important;\n    height: 15px;\n  }\n  .v-line.sm::before {\n    height: 25px;\n  }\n  .v-line.smx::before {\n    width: 1px;\n    height: 20px;\n    background: rgba(255, 255, 255, 0.2);\n  }\n  .v-line.dashed::before {\n    border-right: 1px dashed rgb(var(--n5));\n    background: transparent;\n  }\n  \n  iframe {\n    border: 0;\n    width: 100%;\n  }\n  \n  .display-4 {\n    line-height: 120% !important;\n  }\n  \n  .tabcontents {\n    position: relative;\n  }\n  \n  .nav-links {\n    transition: 0.5s linear;\n  }\n  .nav-links.active {\n    background-color: #282828;\n  }\n  \n  .tabitem {\n    transform: translateY(100px);\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    width: 100%;\n    opacity: 0;\n    transition: 0.5s all;\n  }\n  \n  .tabitem.active {\n    position: static;\n    position: initial;\n    z-index: 1;\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  .styleshadow:hover {\n    box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.08);\n    transform: scale(1.05);\n    z-index: 10;\n  }\n  \n  .table-style table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    border-top: 1px solid #1E2132;\n    min-width: 768px;\n  }\n  .table-style tr {\n    border-bottom: 1px solid #1E2132;\n  }\n  \n  .max-unset {\n    max-width: none;\n    max-width: initial;\n  }\n  \n  .accordion-single {\n    transition: 0.5s linear;\n  }\n  .accordion-single.active .accordion-btn {\n    transition: 0.5s linear;\n  }\n  .accordion-single.active .arrowclickable {\n    transform: rotate(180deg);\n    transition: 0.5s linear;\n  }\n  .accordion-single.active .arrowclickable .ph-plus {\n    display: none;\n  }\n  .accordion-single.active .arrowclickable .ph-minus {\n    display: block;\n  }\n  .accordion-single .arrowclickable {\n    transition: 0.5s linear;\n  }\n  \n  .trapezoid{\n    width: 225px;\n    border-top-width: 60px;\n    --tw-border-opacity: 1;\n    border-color: rgba(40, 40, 40, 1);\n    border-color: rgba(40, 40, 40, var(--tw-border-opacity));\n  }\n  \n  @media (min-width: 576px){\n    .trapezoid{\n      width: 325px;\n      border-top-width: 80px;\n    }\n  }\n  \n  .trapezoid {\n    border-left: 25px solid transparent;\n    border-right: 25px solid transparent;\n    margin: 0 auto;\n  }\n  \n  .btnstyle {\n    position: relative;\n    display: inline-block;\n    background: transparent;\n    transition: linear 0.6s;\n  }\n  .btnstyle:hover {\n    box-shadow: inset 0 160px 0 0 #263e26;\n  }\n  .btnstyle.active {\n    box-shadow: inset 0 160px 0 0 #263e26;\n  }\n  \n  .common_area, .common_area2, .common_area3, .common_area4 {\n    transform: translateY(-500px);\n    transition: 0.6s linear;\n  }\n  .common_area.show, .common_area2.show, .common_area3.show, .common_area4.show {\n    transform: translateY(0);\n  }\n  \n  .common_areaname, .common_areaname2, .common_areaname3, .common_areaname4 {\n    transform: translateY(0);\n    transition: 0.6s linear;\n  }\n  .common_areaname.show, .common_areaname2.show, .common_areaname3.show, .common_areaname4.show {\n    transform: translateY(90px);\n  }\n  \n  input,\n  textarea {\n    padding: 12px 20px;\n    width: 100%;\n    outline-color: transparent;\n    font-size: 16px;\n    border-radius: 10px;\n    background-color: transparent;\n    border: 1px solid #B3B6B9;\n  }\n  input::-moz-placeholder, textarea::-moz-placeholder {\n    color: #F5F5DC;\n    font-size: 16px;\n  }\n  input::placeholder,\n  textarea::placeholder {\n    color: #F5F5DC;\n    font-size: 16px;\n  }\n  \n  /*################# css contents #################*/\n  /*################################################*/\n  /*=============== 1. preloader section stat ===============*/\n  /* Preloader start */\n  body {\n    overflow: hidden;\n  }\n  \n  #preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #000000;\n    z-index: 9999 !important;\n  }\n  \n  #status {\n    width: 200px;\n    height: 200px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    background-repeat: no-repeat;\n    background-position: center;\n    margin: -100px 0 0 -100px;\n  }\n  \n  /* progress bar start */\n  :root {\n    --progress-bar-width: 100px;\n    --progress-bar-height: 100px;\n  }\n  \n  .circular-progress {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .inner-circle {\n    position: absolute;\n    width: calc(100px - 20px);\n    width: calc(var(--progress-bar-width) - 20px);\n    height: calc(100px - 20px);\n    height: calc(var(--progress-bar-height) - 20px);\n    border-radius: 50%;\n    background-color: #000000;\n  }\n  \n  .percentage {\n    position: relative;\n    font-size: 20px;\n    font-weight: 800;\n    color: rgba(0, 0, 0, 0.8);\n  }\n  \n  /* Preloader end */\n  /*=============== preloader section end ===============*/\n  /*################# home page start #################*/\n  /*=============== 2. header section stat ===============*/\n  .header-section .header {\n    z-index: 999 !important;\n  }\n  .header-section .header .dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #263e26;\n    min-width: 160px;\n  }\n  .header-section .header .dropdown-content a {\n    float: none;\n    color: white;\n    padding: 7px 16px;\n    display: block;\n  }\n  .header-section .header .dropdown-content a:hover {\n    background-color: #263e26;\n    color: white;\n    transition: 0.8s;\n  }\n  .header-section .header .dropdown:hover .dropdown-content {\n    display: block;\n    transition: 0.8s;\n  }\n  .header-section .header .sidenav {\n    height: 80%;\n    width: 100%;\n    position: fixed;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    overflow-x: hidden;\n    padding-top: 20px;\n    margin-top: 4rem;\n  }\n  .header-section .header .sidenav a:hover,\n  .header-section .header .dropdown-btn:hover {\n    color: #f1f1f1;\n  }\n  .header-section .header .active {\n    color: white;\n  }\n  .header-section .header .dropdown-container {\n    display: none;\n  }\n  .header-section .header .nav-item a {\n    color: white;\n  }\n  .header-section .header .nav-item.active a {\n    color: #ff325a;\n  }\n  .header-section .header .sidepanel {\n    width: 0;\n    position: fixed;\n    z-index: 9999;\n    top: 0;\n    right: 0;\n    overflow-x: hidden;\n    transition: 0.5s;\n    height: 100vh;\n    background-color: #13181f;\n  }\n  .header-section .header .openbtn {\n    display: block;\n  }\n  .header-section .header .open {\n    display: block;\n    width: 440px;\n    height: 100vh;\n  }\n  .header-section .header {\n    position: fixed;\n    z-index: 1000;\n    height: 85px;\n    width: 100%;\n    transition: all ease-out 0.5s;\n  }\n  .header-section .activetwo {\n    background-color: #263e26;\n  }\n  .header-section .beforeAfter::before {\n    content: \"\";\n    display: block;\n    width: 40px;\n    height: 2px;\n    background-color: #878b95;\n    position: absolute;\n    top: 16px;\n    left: 100px;\n  }\n  .header-section .beforeAfter::after {\n    content: \"\";\n    display: block;\n    width: 40px;\n    height: 2px;\n    background-color: #878b95;\n    position: absolute;\n    top: 16px;\n    right: 100px;\n  }\n  .header-section .ourPartnerSection .container .brand-carouselTwo .swiper-wrapper {\n    transition-timing-function: linear !important;\n  }\n  \n  /*=============== header section end ===============*/\n  /*=============== 3. hero section nav ber stat ===============*/\n  .hero-section .container {\n    /* hero photo up down start */\n    /* hero photo up down end */\n  }\n  .hero-section .container .lin {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n  .hero-section .container img.vert-move {\n    animation: mover 2s infinite alternate;\n    margin-bottom: -10px;\n  }\n  @keyframes mover {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(-10px);\n    }\n  }\n  .hero-section .dwon-section .brand-carouselOne .swiper-wrapper {\n    transition-timing-function: linear !important;\n  }\n  \n  /*=============== hero section nav ber stat ===============*/\n  /*=============== 4. Our Games section start ===============*/\n  .ourGameSection .container {\n    /* swiper slider active start */\n    /* swiper slider active end */\n  }\n  .ourGameSection .container .card2 {\n    position: relative;\n    border: 5px solid transparent;\n    background: #18191f;\n    background-clip: padding-box;\n    border-radius: 10px;\n    z-index: 1;\n  }\n  .ourGameSection .container .card2::after {\n    content: \"\";\n    position: absolute;\n    top: -5px;\n    bottom: -5px;\n    left: -5px;\n    right: -5px;\n    background: linear-gradient(to bottom right, #22c1c3, #fdbb2d);\n    z-index: -1;\n    border-radius: 10px;\n  }\n  .ourGameSection .container .slider-games .swiper-slide-active {\n    transform: scale(1.1);\n    transition: 1s;\n    background-color: #263e26;\n  }\n  \n  /*=============== Our Games section start ===============*/\n  /*=============== 5. Explore Game section start ===============*/\n  .exploreGame-section .container {\n    /*  Explore Game section tab video start */\n    /*  Explore Game section tab video end */\n  }\n  .exploreGame-section .container .tab-block .tab-mnu {\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n  }\n  .exploreGame-section .container .tab-block .tab-mnu:after {\n    content: \"\";\n  }\n  .exploreGame-section .container .tab-block .tab-mnu li {\n    padding-top: 13px;\n    padding-bottom: 13px;\n    cursor: pointer;\n    border-left: 6px solid #0f0f0f;\n  }\n  .exploreGame-section .container .tab-block .tab-mnu .active {\n    background-color: #263e26;\n    border-left: 6px solid #ff325a;\n    color: white;\n    cursor: pointer;\n  }\n  \n  /*=============== Explore Game section end ===============*/\n  /*################# home page start #################*/\n  /*################# top trending page start #################*/\n  /*=============== 6. top trending section stat ===============*/\n  .topTrendingSection .container .topTrend:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    z-index: 10;\n    background: linear-gradient(1deg, rgba(3, 3, 4, 0.9) -3.02%, rgba(3, 3, 4, 0) 99.06%);\n  }\n  .topTrendingSection .container .topTrend1:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    height: 0%;\n    width: 100%;\n    bottom: 2px;\n    left: 0;\n    z-index: 12;\n    transition: height 0.5s ease-out;\n    border-radius: 24px;\n    background: linear-gradient(1deg, rgba(7, 255, 7, 0.555) -3.02%, rgba(3, 3, 4, 0) 99.06%);\n  }\n  .topTrendingSection .container .topTrend1:hover:before {\n    height: 100%;\n  }\n  \n  /*=============== top trending section end ===============*/\n  /*################# top trending page start #################*/\n  /*################# popular games page start #################*/\n  /*=============== 7. popular games section end ===============*/\n  .popularGame-section .container {\n    /* popular games card before start */\n    /* popular games card before start */\n  }\n  .popularGame-section .container .popularGame {\n    background: linear-gradient(1deg, rgba(3, 3, 4, 0.9) -3.02%, rgba(3, 3, 4, 0) 99.06%);\n    -o-object-fit: cover;\n       object-fit: cover;\n    position: relative;\n  }\n  .popularGame-section .container .popularGame:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    height: 0%;\n    width: 100%;\n    bottom: 2px;\n    left: 0;\n    transition: height 0.5s ease-out;\n    border-radius: 24px;\n    background: linear-gradient(1deg, rgba(7, 255, 7, 0.555) -3.02%, rgba(3, 3, 4, 0) 99.06%);\n  }\n  .popularGame-section .container .popularGame:hover:before {\n    height: 100%;\n  }\n  \n  /*=============== popular games section end ===============*/\n  /*################# popular games page start #################*/\n  /*################# achievements page end #################*/\n  /*=============== 8. achievements section end ===============*/\n  .achievements-section .container .buttonAch {\n    color: #fff;\n    transition: all 0.3s ease;\n  }\n  .achievements-section .container .buttonAch:focus {\n    animation: clickEffect 0.3s ease forwards;\n    transform: scale(0.9);\n  }\n  .achievements-section .container .buttonAch.active {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    color: white;\n  }\n  \n  /*=============== achievements section end ===============*/\n  /*################# achievements page end #################*/\n  /*################# achievements introduction page start #################*/\n  /*=============== 9. achievements introduction section stat ===============*/\n  .introductionStartSection .container .bttsx:hover {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    transition: 0.8s;\n    border-radius: 50px;\n  }\n  \n  /*=============== achievements introduction section stat ===============*/\n  /*=============== 10. achievements introduction faq section stat ===============*/\n  .achievementFaq .container .header-area {\n    padding: 10px 0;\n    cursor: pointer;\n  }\n  .achievementFaq .container .active .header-area .btnfrv {\n    display: none;\n  }\n  .achievementFaq .container .content-area {\n    display: none;\n  }\n  .achievementFaq .container .active .header-area .btnfadd {\n    display: block;\n  }\n  .achievementFaq .container .active .header-area .btnfadd i {\n    color: #ff325a;\n  }\n  .achievementFaq .container .active .header-area .text {\n    color: #ff325a;\n  }\n  \n  /*=============== achievements introduction faq section end ===============*/\n  /*################# achievements introduction page end #################*/\n  /*################# bounty page end #################*/\n  /*=============== 11. bounty bred crumb section section start ===============*/\n  .bounty-bredCrumb {\n    background: linear-gradient(180deg, rgba(19, 18, 18, 0.78) 25.81%, rgba(20, 20, 20, 0.88) 63.99%, #0f0f0f 100%), url(../public/images/bounty-hero.png) no-repeat;\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n  \n  /*=============== bounty bred crumb section section start ===============*/\n  /*################# bounty page end #################*/\n  /*################# bred crumb start #################*/\n  /*=============== 12. bred crumb section section start ===============*/\n  .bred-crumb {\n    background: linear-gradient(91deg, rgba(6, 7, 7, 0.753) 0.97%, rgba(2, 2, 2, 0.897) 100%), url(../public/images/game.png) no-repeat;\n    -o-object-fit: cover;\n       object-fit: cover;\n    width: 100%;\n    height: 100%;\n    background-color: #0f0f0f;\n  }\n  \n  /*=============== bred crumb section section end ===============*/\n  /*################# bred crumb end #################*/\n  .navbar-inverse.menu ul li a {\n    background: transparent;\n  }\n  \n  .navbar-inverse.menu ul li a:hover,\n  .navbar-inverse.menu ul li a.active,\n  .navbar-inverse.menu ul li a.active:hover {\n    color: #ff325a;\n  }\n  \n  /*=============== 13. global style start ===============*/\n  /* our games section pagination start */\n  .pageHead {\n    width: 100%;\n    height: 1px;\n    background-color: #ff325a;\n  }\n  .pageHead .swiper-pagination-bullet {\n    width: 140px;\n    height: 4px;\n    background-color: #ff325a;\n    border-radius: 0px;\n  }\n  \n  .swiper-pagination-bullets,\n  .swiper-pagination-bullets.swiper-pagination-horizontal,\n  .swiper-pagination-custom,\n  .swiper-pagination-fraction {\n    width: 100%;\n    margin-top: -6px;\n  }\n  \n  .swiper-pagination {\n    position: relative;\n  }\n  \n  /* our games section pagination end */\n  /* hero infinity round image tag animation css start */\n  @keyframes rotate-full {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n  @keyframes rotate {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n  @keyframes infinite-spinning {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  .animated {\n    animation-duration: 1s;\n    animation-fill-mode: both;\n  }\n  .animated .infinite {\n    animation-iteration-count: infinite;\n  }\n  \n  .box1 {\n    border-radius: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    transform: rotate(0deg);\n  }\n  .box1 img {\n    border-radius: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n  \n  .rotate {\n    animation: rotation-full 5s infinite linear;\n  }\n  \n  .rotate-full {\n    animation: infinite-spinning 16s infinite linear;\n  }\n  \n  /* hero infinity round image tag animation css end */\n  /* card button start */\n  .salBa-area .salBa {\n    padding: 2px;\n    border: 2px solid #e1e500;\n    border: dotted;\n  }\n  \n  /* card button end */\n  /* global button style start */\n  .buttonx {\n    border-radius: 50px;\n    cursor: pointer;\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    transition: all 0.5s ease;\n  }\n  \n  .buttonx:hover {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    color: #0f0f0f;\n    box-shadow: #ff325a 0px 7px 29px 0px;\n  }\n  \n  /* global button style end */\n  /* img zoom in zoom out start */\n  .img-box {\n    overflow: hidden;\n  }\n  \n  .img {\n    background-size: cover;\n    transition: all 1s ease;\n  }\n  \n  .img:hover {\n    transform: scale(1.1, 1.1);\n  }\n  \n  /* img zoom in zoom out end */\n  /* Newsletter hidden start */\n  .globl {\n    overflow: hidden;\n  }\n  \n  /* Newsletter hidden end */\n  /* swiper slider active start */\n  .slider-researches .swiper-slide-active {\n    border: 2px solid #f29620;\n    transition: 1s;\n    background-color: #263e26;\n  }\n  \n  /* swiper slider active end */\n  /* bounty section card & color hover start */\n  .bounty-section:hover .bounty-area .bounty i {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    transition: 0.8s;\n  }\n  \n  .bounty-section:hover .bounty-areax .bountyx i {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    transition: 1s;\n  }\n  \n  .bounty-section:hover .butt-area .butt {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    box-shadow: #29171a 0px 7px 29px 0px;\n    color: white;\n  }\n  \n  .bounty-section:hover .num {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    box-shadow: #1f1013 0px 7px 29px 0px;\n    color: white;\n  }\n  \n  /* bounty section card & color hover end */\n  /* tab style active start */\n  .tab-btn:hover {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    box-shadow: #29171a 0px 7px 29px 0px;\n    color: white;\n  }\n  \n  .tab-btn.active {\n    background: linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%);\n    background: var(--Button, linear-gradient(100deg, #ff325a 9.67%, #e1e500 87.06%));\n    box-shadow: #29171a 0px 7px 29px 0px;\n    color: white;\n  }\n  \n  .content {\n    display: none;\n  }\n  \n  .content.show {\n    display: flex;\n  }\n  \n  /* tab style active end */\n  /* tab propup start */\n  .white-popup {\n    position: relative;\n    width: auto;\n    max-width: 500px;\n    margin: 0 auto;\n  }\n  \n  .mfp-zoom-in .mfp-with-anim {\n    opacity: 0;\n    transition: all 0.2s ease-in-out;\n    transform: scale(0.8);\n  }\n  .mfp-zoom-in.mfp-bg {\n    opacity: 0;\n    transition: all 0.3s ease-out;\n  }\n  .mfp-zoom-in.mfp-ready .mfp-with-anim {\n    opacity: 1;\n    transform: scale(1);\n  }\n  .mfp-zoom-in.mfp-ready.mfp-bg {\n    opacity: 0.8;\n  }\n  .mfp-zoom-in.mfp-removing .mfp-with-anim {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  .mfp-zoom-in.mfp-removing.mfp-bg {\n    opacity: 0;\n  }\n  \n  @keyframes hinge {\n    0% {\n      transform: rotate(0);\n      transform-origin: top left;\n      animation-timing-function: ease-in-out;\n    }\n    20%, 60% {\n      transform: rotate(80deg);\n      transform-origin: top left;\n      animation-timing-function: ease-in-out;\n    }\n    40% {\n      transform: rotate(60deg);\n      transform-origin: top left;\n      animation-timing-function: ease-in-out;\n    }\n    80% {\n      transform: rotate(60deg) translateY(0);\n      opacity: 1;\n      transform-origin: top left;\n      animation-timing-function: ease-in-out;\n    }\n    100% {\n      transform: translateY(700px);\n      opacity: 0;\n    }\n  }\n  .hinge {\n    animation-duration: 1s;\n    animation-name: hinge;\n  }\n  \n  .mfp-with-fade .mfp-content, .mfp-with-fade.mfp-bg {\n    opacity: 0;\n    transition: opacity 0.5s ease-out;\n  }\n  .mfp-with-fade.mfp-ready .mfp-content {\n    opacity: 1;\n  }\n  .mfp-with-fade.mfp-ready.mfp-bg {\n    opacity: 0.8;\n  }\n  .mfp-with-fade .mfp-close {\n    color: white;\n  }\n  .mfp-with-fade.mfp-removing.mfp-bg {\n    opacity: 0;\n  }\n  \n  table {\n    border-collapse: collapse;\n    width: 100%;\n    border-spacing: 0;\n  }\n  \n  th,\n  td {\n    text-align: left;\n    padding: 8px;\n  }\n  \n  /* tab propup end */\n  /* Gamefi Index card sing in start */\n  .beforeX::before {\n    content: \"\";\n    display: block;\n    width: 40px;\n    height: 2px;\n    background-color: #878b95;\n    position: absolute;\n    top: 26px;\n    left: 100px;\n  }\n  \n  .beforeX::after {\n    content: \"\";\n    display: block;\n    width: 40px;\n    height: 2px;\n    background-color: #878b95;\n    position: absolute;\n    top: 26px;\n    right: 100px;\n  }\n  \n  /* Gamefi Index card sing in end */\n  /* Wallet start */\n  .beforeWal::before {\n    content: \"\";\n    display: block;\n    width: 40px;\n    height: 2px;\n    background-color: #878b95;\n    position: absolute;\n    top: 34px;\n    left: 20px;\n  }\n  \n  .beforeWal::after {\n    content: \"\";\n    display: block;\n    width: 40px;\n    height: 2px;\n    background-color: #878b95;\n    position: absolute;\n    top: 34px;\n    right: 20px;\n  }\n  \n  /* Wallet end */\n  /* tab start */\n  .tab__list {\n    display: flex;\n  }\n  .tab__item:before {\n    content: \"\";\n    position: absolute;\n    top: 95%;\n    left: 0;\n    height: 2px;\n    width: 100%;\n    background: #ff325a;\n    transition: 0.2s;\n    visibility: hidden;\n    opacity: 0;\n  }\n  .tab__item.is--active {\n    color: white;\n    position: relative;\n  }\n  .tab__item.is--active:before {\n    visibility: visible;\n    opacity: 1;\n  }\n  .tab__content-item {\n    display: none;\n  }\n  .tab__content-item.is--active {\n    display: block;\n  }\n  \n  /* tab end */\n  /* footer Benefit hover color start */\n  .icons {\n    opacity: 0;\n    transition: 1s;\n  }\n  \n  .arrIcon:hover .icons {\n    opacity: 100;\n    color: #ff325a;\n    transition: 1s;\n  }\n  \n  /* footer Benefit hover color end */\n  /*=============== global style end ===============*/\n  /*=============== 14. responsive start ===============*/\n  @media screen and (max-width: 992px) {\n    .header-section .header .container #mobile-menu {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100vh;\n      background: #263e26;\n      transform: translateX(-100%);\n      transition: transform 0.3s ease-in-out;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .header-section .header .container #mobile-menu.show-menu {\n      transform: translateX(0%);\n    }\n    .header-section .header .container #hamburger-cross {\n      display: block;\n      color: white;\n      cursor: pointer;\n      font-size: 40px;\n      position: absolute;\n      top: 20px;\n      right: 26px;\n    }\n    .header-section .header .container #hamburger-menu {\n      display: block;\n      color: white;\n      cursor: pointer;\n      font-size: 24px;\n    }\n    .header-section .header .container .dropdown-content {\n      min-width: 220px;\n      margin-left: 12rem;\n      margin-top: -3rem;\n      text-align: center;\n      background-color: red;\n    }\n    .ourGameSection .container .pageHead {\n      width: 100%;\n      height: 1px;\n      background-color: #ff325a;\n    }\n    .ourGameSection .container .pageHead .swiper-pagination-bullet {\n      width: 20%;\n      height: 4px;\n      background-color: #ff325a;\n      border-radius: 0px;\n    }\n    .ourGameSection .container .swiper-pagination-bullets,\n    .ourGameSection .container .swiper-pagination-bullets.swiper-pagination-horizontal,\n    .ourGameSection .container .swiper-pagination-custom,\n    .ourGameSection .container .swiper-pagination-fraction {\n      width: 100%;\n      margin-top: -6px;\n    }\n    .ourGameSection .container .swiper-pagination {\n      position: relative;\n    }\n    .leadTabel {\n      overflow-x: scroll;\n      width: 90rem;\n    }\n    .leadTabely {\n      overflow-x: scroll;\n      width: 60rem;\n    }\n    .leadTabelx {\n      overflow-x: scroll;\n      width: 30rem;\n    }\n  }\n  @media (max-width: 768px) {\n    .pageHead {\n      width: 100%;\n      height: 1px;\n      background-color: #ff325a;\n    }\n    .pageHead .swiper-pagination-bullet {\n      width: 80px;\n      height: 4px;\n      background-color: #ff325a;\n      border-radius: 0px;\n    }\n    .swiper-pagination-bullets,\n    .swiper-pagination-bullets.swiper-pagination-horizontal,\n    .swiper-pagination-custom,\n    .swiper-pagination-fraction {\n      width: 100%;\n      margin-top: -6px;\n    }\n    .swiper-pagination {\n      position: relative;\n    }\n  }\n  @media screen and (max-width: 576px) {\n    .icon4 {\n      margin-top: 0;\n    }\n  }\n  @media screen and (max-width: 568px) {\n    .icon1 {\n      margin-top: 0;\n    }\n    .icon2 {\n      margin-top: 0;\n    }\n    .icon3 {\n      margin-top: 0;\n    }\n  }\n  @media (max-width: 500px) {\n    .navHero-section .header .beforeAfter::before {\n      content: \"\";\n      display: block;\n      width: 40px;\n      height: 2px;\n      background-color: #878b95;\n      position: absolute;\n      top: 12px;\n      left: 60px;\n    }\n    .navHero-section .header .beforeAfter::after {\n      content: \"\";\n      display: block;\n      width: 40px;\n      height: 2px;\n      background-color: #878b95;\n      position: absolute;\n      top: 12px;\n      right: 60px;\n    }\n    .pageHead {\n      width: 100%;\n      height: 1px;\n      background-color: #ff325a;\n    }\n    .pageHead .swiper-pagination-bullet {\n      width: 20px;\n      height: 4px;\n      background-color: #ff325a;\n      border-radius: 0px;\n    }\n    .swiper-pagination-bullets,\n    .swiper-pagination-bullets.swiper-pagination-horizontal,\n    .swiper-pagination-custom,\n    .swiper-pagination-fraction {\n      width: 100%;\n      margin-top: -6px;\n    }\n    .swiper-pagination {\n      position: relative;\n    }\n  }\n  @media screen and (max-width: 472px) {\n    .icon3 {\n      margin-top: 2rem;\n    }\n  }\n  @media screen and (max-width: 408px) {\n    .icon2 {\n      margin-top: 2rem;\n    }\n  }\n  @media screen and (max-width: 344px) {\n    .icon4 {\n      margin-top: 1rem;\n    }\n  }\n  @media screen and (max-width: 342px) {\n    .icon1 {\n      margin-top: 2rem;\n    }\n  }\n  /*=============== responsive end ===============*/\n  .placeholder\\:text-nu1::-moz-placeholder{\n    --tw-text-opacity: 1;\n    color: rgba(255, 255, 255, 1);\n    color: rgba(255, 255, 255, var(--tw-text-opacity));\n  }\n  .placeholder\\:text-nu1::placeholder{\n    --tw-text-opacity: 1;\n    color: rgba(255, 255, 255, 1);\n    color: rgba(255, 255, 255, var(--tw-text-opacity));\n  }\n  .before\\:absolute::before{\n    content: var(--tw-content);\n    position: absolute;\n  }\n  .before\\:-right-4::before{\n    content: var(--tw-content);\n    right: -1rem;\n  }\n  .before\\:-top-44::before{\n    content: var(--tw-content);\n    top: -11rem;\n  }\n  .before\\:h-28::before{\n    content: var(--tw-content);\n    height: 7rem;\n  }\n  .before\\:w-28::before{\n    content: var(--tw-content);\n    width: 7rem;\n  }\n  .before\\:rounded-full::before{\n    content: var(--tw-content);\n    border-radius: 9999px;\n  }\n  .before\\:border-8::before{\n    content: var(--tw-content);\n    border-width: 8px;\n  }\n  .before\\:bg-transparent::before{\n    content: var(--tw-content);\n    background-color: transparent;\n  }\n  .before\\:opacity-50::before{\n    content: var(--tw-content);\n    opacity: 0.5;\n  }\n  .before\\:blur-none::before{\n    content: var(--tw-content);\n    --tw-blur: blur(0);\n    filter: blur(0) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n  }\n  .before\\:duration-700::before{\n    content: var(--tw-content);\n    transition-duration: 700ms;\n  }\n  .hover\\:ml-0:hover{\n    margin-left: 0px;\n  }\n  .hover\\:border-2:hover{\n    border-width: 2px;\n  }\n  .hover\\:border-primary:hover{\n    --tw-border-opacity: 1;\n    border-color: rgba(255, 50, 90, 1);\n    border-color: rgba(255, 50, 90, var(--tw-border-opacity));\n  }\n  .hover\\:border-secondary:hover{\n    --tw-border-opacity: 1;\n    border-color: rgba(242, 150, 32, 1);\n    border-color: rgba(242, 150, 32, var(--tw-border-opacity));\n  }\n  .hover\\:bg-nu10:hover{\n    --tw-bg-opacity: 1;\n    background-color: rgba(15, 39, 15, 1);\n    background-color: rgba(15, 39, 15, var(--tw-bg-opacity));\n  }\n  .hover\\:bg-nu11:hover{\n    --tw-bg-opacity: 1;\n    background-color: rgba(43, 22, 28, 1);\n    background-color: rgba(43, 22, 28, var(--tw-bg-opacity));\n  }\n  .hover\\:bg-nu13:hover{\n    --tw-bg-opacity: 1;\n    background-color: rgba(18, 38, 30, 1);\n    background-color: rgba(18, 38, 30, var(--tw-bg-opacity));\n  }\n  .hover\\:bg-nu5:hover{\n    --tw-bg-opacity: 1;\n    background-color: rgba(38, 62, 38, 1);\n    background-color: rgba(38, 62, 38, var(--tw-bg-opacity));\n  }\n  .hover\\:bg-primary:hover{\n    --tw-bg-opacity: 1;\n    background-color: rgba(255, 50, 90, 1);\n    background-color: rgba(255, 50, 90, var(--tw-bg-opacity));\n  }\n  .hover\\:bg-secondary:hover{\n    --tw-bg-opacity: 1;\n    background-color: rgba(242, 150, 32, 1);\n    background-color: rgba(242, 150, 32, var(--tw-bg-opacity));\n  }\n  .hover\\:text-primary:hover{\n    --tw-text-opacity: 1;\n    color: rgba(255, 50, 90, 1);\n    color: rgba(255, 50, 90, var(--tw-text-opacity));\n  }\n  .hover\\:text-secondary:hover{\n    --tw-text-opacity: 1;\n    color: rgba(242, 150, 32, 1);\n    color: rgba(242, 150, 32, var(--tw-text-opacity));\n  }\n  .hover\\:underline:hover{\n    text-decoration-line: underline;\n  }\n  .hover\\:duration-500:hover{\n    transition-duration: 500ms;\n  }\n  .hover\\:duration-700:hover{\n    transition-duration: 700ms;\n  }\n  .group:hover .group-hover\\:bg-primary{\n    --tw-bg-opacity: 1;\n    background-color: rgba(255, 50, 90, 1);\n    background-color: rgba(255, 50, 90, var(--tw-bg-opacity));\n  }\n  .group:hover .group-hover\\:before\\:right-44::before{\n    content: var(--tw-content);\n    right: 11rem;\n  }\n  .group:hover .group-hover\\:before\\:top-28::before{\n    content: var(--tw-content);\n    top: 7rem;\n  }\n  .group:hover .group-hover\\:before\\:scale-125::before{\n    content: var(--tw-content);\n    --tw-scale-x: 1.25;\n    --tw-scale-y: 1.25;\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.25) scaleY(1.25);\n    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n  }\n  .group:hover .group-hover\\:before\\:blur::before{\n    content: var(--tw-content);\n    --tw-blur: blur(8px);\n    filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n  }\n  @media not all and (min-width: 1296px){\n    .max-2xl\\:flex-wrap{\n      flex-wrap: wrap;\n    }\n  }\n  @media not all and (min-width: 1200px){\n    .max-xl\\:flex-wrap{\n      flex-wrap: wrap;\n    }\n  }\n  @media not all and (min-width: 992px){\n    .max-lg\\:flex-wrap{\n      flex-wrap: wrap;\n    }\n  }\n  @media not all and (min-width: 768px){\n    .max-md\\:flex-col{\n      flex-direction: column;\n    }\n    .max-md\\:flex-wrap{\n      flex-wrap: wrap;\n    }\n  }\n  @media not all and (min-width: 576px){\n    .max-sm\\:flex-col{\n      flex-direction: column;\n    }\n    .max-sm\\:flex-wrap{\n      flex-wrap: wrap;\n    }\n  }\n  @media (min-width: 576px){\n    .sm\\:col-span-1{\n      grid-column: span 1 / span 1;\n    }\n    .sm\\:col-span-10{\n      grid-column: span 10 / span 10;\n    }\n    .sm\\:col-span-3{\n      grid-column: span 3 / span 3;\n    }\n    .sm\\:col-span-4{\n      grid-column: span 4 / span 4;\n    }\n    .sm\\:col-span-6{\n      grid-column: span 6 / span 6;\n    }\n    .sm\\:col-span-8{\n      grid-column: span 8 / span 8;\n    }\n    .sm\\:m-0{\n      margin: 0px;\n    }\n    .sm\\:mx-0{\n      margin-left: 0px;\n      margin-right: 0px;\n    }\n    .sm\\:my-0{\n      margin-top: 0px;\n      margin-bottom: 0px;\n    }\n    .sm\\:my-10{\n      margin-top: 2.5rem;\n      margin-bottom: 2.5rem;\n    }\n    .sm\\:-mt-0{\n      margin-top: -0px;\n    }\n    .sm\\:-mt-4{\n      margin-top: -1rem;\n    }\n    .sm\\:-mt-7{\n      margin-top: -1.75rem;\n    }\n    .sm\\:-mt-\\[60px\\]{\n      margin-top: -60px;\n    }\n    .sm\\:mb-4{\n      margin-bottom: 1rem;\n    }\n    .sm\\:mb-6{\n      margin-bottom: 1.5rem;\n    }\n    .sm\\:ml-2{\n      margin-left: 0.5rem;\n    }\n    .sm\\:ml-\\[26rem\\]{\n      margin-left: 26rem;\n    }\n    .sm\\:mt-0{\n      margin-top: 0px;\n    }\n    .sm\\:mt-10{\n      margin-top: 2.5rem;\n    }\n    .sm\\:mt-16{\n      margin-top: 4rem;\n    }\n    .sm\\:mt-3{\n      margin-top: 0.75rem;\n    }\n    .sm\\:mt-4{\n      margin-top: 1rem;\n    }\n    .sm\\:mt-6{\n      margin-top: 1.5rem;\n    }\n    .sm\\:mt-8{\n      margin-top: 2rem;\n    }\n    .sm\\:mt-\\[20px\\]{\n      margin-top: 20px;\n    }\n    .sm\\:mt-\\[2rem\\]{\n      margin-top: 2rem;\n    }\n    .sm\\:mt-\\[30px\\]{\n      margin-top: 30px;\n    }\n    .sm\\:inline-block{\n      display: inline-block;\n    }\n    .sm\\:flex{\n      display: flex;\n    }\n    .sm\\:h-\\[250px\\]{\n      height: 250px;\n    }\n    .sm\\:h-\\[40px\\]{\n      height: 40px;\n    }\n    .sm\\:w-\\[30\\%\\]{\n      width: 30%;\n    }\n    .sm\\:w-\\[300px\\]{\n      width: 300px;\n    }\n    .sm\\:w-\\[40px\\]{\n      width: 40px;\n    }\n    .sm\\:w-auto{\n      width: auto;\n    }\n    .sm\\:justify-normal{\n      justify-content: normal;\n    }\n    .sm\\:justify-start{\n      justify-content: flex-start;\n    }\n    .sm\\:gap-6{\n      gap: 1.5rem;\n    }\n    .sm\\:gap-8{\n      gap: 2rem;\n    }\n    .sm\\:px-10{\n      padding-left: 2.5rem;\n      padding-right: 2.5rem;\n    }\n    .sm\\:px-14{\n      padding-left: 3.5rem;\n      padding-right: 3.5rem;\n    }\n    .sm\\:px-20{\n      padding-left: 5rem;\n      padding-right: 5rem;\n    }\n    .sm\\:px-3{\n      padding-left: 0.75rem;\n      padding-right: 0.75rem;\n    }\n    .sm\\:px-4{\n      padding-left: 1rem;\n      padding-right: 1rem;\n    }\n    .sm\\:px-6{\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n    .sm\\:px-8{\n      padding-left: 2rem;\n      padding-right: 2rem;\n    }\n    .sm\\:px-\\[10px\\]{\n      padding-left: 10px;\n      padding-right: 10px;\n    }\n    .sm\\:px-\\[12px\\]{\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n    .sm\\:px-\\[17px\\]{\n      padding-left: 17px;\n      padding-right: 17px;\n    }\n    .sm\\:px-\\[20px\\]{\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n    .sm\\:px-\\[8px\\]{\n      padding-left: 8px;\n      padding-right: 8px;\n    }\n    .sm\\:py-1{\n      padding-top: 0.25rem;\n      padding-bottom: 0.25rem;\n    }\n    .sm\\:py-10{\n      padding-top: 2.5rem;\n      padding-bottom: 2.5rem;\n    }\n    .sm\\:py-16{\n      padding-top: 4rem;\n      padding-bottom: 4rem;\n    }\n    .sm\\:py-2{\n      padding-top: 0.5rem;\n      padding-bottom: 0.5rem;\n    }\n    .sm\\:py-3{\n      padding-top: 0.75rem;\n      padding-bottom: 0.75rem;\n    }\n    .sm\\:py-4{\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n    }\n    .sm\\:py-6{\n      padding-top: 1.5rem;\n      padding-bottom: 1.5rem;\n    }\n    .sm\\:py-8{\n      padding-top: 2rem;\n      padding-bottom: 2rem;\n    }\n    .sm\\:py-\\[180px\\]{\n      padding-top: 180px;\n      padding-bottom: 180px;\n    }\n    .sm\\:py-\\[20px\\]{\n      padding-top: 20px;\n      padding-bottom: 20px;\n    }\n    .sm\\:py-\\[30px\\]{\n      padding-top: 30px;\n      padding-bottom: 30px;\n    }\n    .sm\\:py-\\[60px\\]{\n      padding-top: 60px;\n      padding-bottom: 60px;\n    }\n    .sm\\:pb-0{\n      padding-bottom: 0px;\n    }\n    .sm\\:pb-10{\n      padding-bottom: 2.5rem;\n    }\n    .sm\\:pb-12{\n      padding-bottom: 3rem;\n    }\n    .sm\\:pb-16{\n      padding-bottom: 4rem;\n    }\n    .sm\\:pb-3{\n      padding-bottom: 0.75rem;\n    }\n    .sm\\:pb-4{\n      padding-bottom: 1rem;\n    }\n    .sm\\:pb-6{\n      padding-bottom: 1.5rem;\n    }\n    .sm\\:pb-8{\n      padding-bottom: 2rem;\n    }\n    .sm\\:pb-\\[30px\\]{\n      padding-bottom: 30px;\n    }\n    .sm\\:pb-\\[60px\\]{\n      padding-bottom: 60px;\n    }\n    .sm\\:pl-0{\n      padding-left: 0px;\n    }\n    .sm\\:pl-2{\n      padding-left: 0.5rem;\n    }\n    .sm\\:pl-4{\n      padding-left: 1rem;\n    }\n    .sm\\:pt-0{\n      padding-top: 0px;\n    }\n    .sm\\:pt-1{\n      padding-top: 0.25rem;\n    }\n    .sm\\:pt-10{\n      padding-top: 2.5rem;\n    }\n    .sm\\:pt-12{\n      padding-top: 3rem;\n    }\n    .sm\\:pt-14{\n      padding-top: 3.5rem;\n    }\n    .sm\\:pt-2{\n      padding-top: 0.5rem;\n    }\n    .sm\\:pt-3{\n      padding-top: 0.75rem;\n    }\n    .sm\\:pt-4{\n      padding-top: 1rem;\n    }\n    .sm\\:pt-6{\n      padding-top: 1.5rem;\n    }\n    .sm\\:pt-8{\n      padding-top: 2rem;\n    }\n    .sm\\:pt-\\[10px\\]{\n      padding-top: 10px;\n    }\n    .sm\\:pt-\\[14px\\]{\n      padding-top: 14px;\n    }\n    .sm\\:pt-\\[20px\\]{\n      padding-top: 20px;\n    }\n    .sm\\:pt-\\[26px\\]{\n      padding-top: 26px;\n    }\n    .sm\\:pt-\\[40px\\]{\n      padding-top: 40px;\n    }\n    .sm\\:pt-\\[60px\\]{\n      padding-top: 60px;\n    }\n    .sm\\:text-left{\n      text-align: left;\n    }\n    .sm\\:text-\\[18px\\]{\n      font-size: 18px;\n    }\n    .sm\\:text-\\[20px\\]{\n      font-size: 20px;\n    }\n    .sm\\:text-\\[24px\\]{\n      font-size: 24px;\n    }\n    .sm\\:text-\\[32px\\]{\n      font-size: 32px;\n    }\n  }\n  @media (min-width: 768px){\n    .md\\:col-span-12{\n      grid-column: span 12 / span 12;\n    }\n    .md\\:col-span-3{\n      grid-column: span 3 / span 3;\n    }\n    .md\\:col-span-4{\n      grid-column: span 4 / span 4;\n    }\n    .md\\:col-span-5{\n      grid-column: span 5 / span 5;\n    }\n    .md\\:col-span-6{\n      grid-column: span 6 / span 6;\n    }\n    .md\\:col-span-7{\n      grid-column: span 7 / span 7;\n    }\n    .md\\:col-span-9{\n      grid-column: span 9 / span 9;\n    }\n    .md\\:mx-auto{\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .md\\:ml-\\[30rem\\]{\n      margin-left: 30rem;\n    }\n    .md\\:mt-0{\n      margin-top: 0px;\n    }\n    .md\\:hidden{\n      display: none;\n    }\n    .md\\:h-\\[300px\\]{\n      height: 300px;\n    }\n    .md\\:h-full{\n      height: 100%;\n    }\n    .md\\:w-full{\n      width: 100%;\n    }\n    .md\\:justify-start{\n      justify-content: flex-start;\n    }\n    .md\\:px-20{\n      padding-left: 5rem;\n      padding-right: 5rem;\n    }\n    .md\\:px-28{\n      padding-left: 7rem;\n      padding-right: 7rem;\n    }\n    .md\\:px-\\[16px\\]{\n      padding-left: 16px;\n      padding-right: 16px;\n    }\n    .md\\:px-\\[20px\\]{\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n    .md\\:px-\\[60px\\]{\n      padding-left: 60px;\n      padding-right: 60px;\n    }\n    .md\\:py-14{\n      padding-top: 3.5rem;\n      padding-bottom: 3.5rem;\n    }\n    .md\\:py-20{\n      padding-top: 5rem;\n      padding-bottom: 5rem;\n    }\n    .md\\:py-3{\n      padding-top: 0.75rem;\n      padding-bottom: 0.75rem;\n    }\n    .md\\:py-\\[20px\\]{\n      padding-top: 20px;\n      padding-bottom: 20px;\n    }\n    .md\\:py-\\[60px\\]{\n      padding-top: 60px;\n      padding-bottom: 60px;\n    }\n    .md\\:pb-20{\n      padding-bottom: 5rem;\n    }\n    .md\\:pb-\\[60px\\]{\n      padding-bottom: 60px;\n    }\n    .md\\:pb-\\[80px\\]{\n      padding-bottom: 80px;\n    }\n    .md\\:pl-0{\n      padding-left: 0px;\n    }\n    .md\\:pl-4{\n      padding-left: 1rem;\n    }\n    .md\\:pt-0{\n      padding-top: 0px;\n    }\n    .md\\:pt-1{\n      padding-top: 0.25rem;\n    }\n    .md\\:pt-20{\n      padding-top: 5rem;\n    }\n    .md\\:pt-\\[50px\\]{\n      padding-top: 50px;\n    }\n    .md\\:pt-\\[60px\\]{\n      padding-top: 60px;\n    }\n    .md\\:text-left{\n      text-align: left;\n    }\n    .md\\:text-\\[20px\\]{\n      font-size: 20px;\n    }\n    .md\\:text-\\[24px\\]{\n      font-size: 24px;\n    }\n    .md\\:text-\\[28px\\]{\n      font-size: 28px;\n    }\n  }\n  @media (min-width: 992px){\n    .lg\\:col-span-12{\n      grid-column: span 12 / span 12;\n    }\n    .lg\\:col-span-2{\n      grid-column: span 2 / span 2;\n    }\n    .lg\\:col-span-3{\n      grid-column: span 3 / span 3;\n    }\n    .lg\\:col-span-4{\n      grid-column: span 4 / span 4;\n    }\n    .lg\\:col-span-5{\n      grid-column: span 5 / span 5;\n    }\n    .lg\\:col-span-6{\n      grid-column: span 6 / span 6;\n    }\n    .lg\\:col-span-7{\n      grid-column: span 7 / span 7;\n    }\n    .lg\\:col-span-8{\n      grid-column: span 8 / span 8;\n    }\n    .lg\\:mt-8{\n      margin-top: 2rem;\n    }\n    .lg\\:flex{\n      display: flex;\n    }\n    .lg\\:hidden{\n      display: none;\n    }\n    .lg\\:h-\\[300px\\]{\n      height: 300px;\n    }\n    .lg\\:w-\\[300px\\]{\n      width: 300px;\n    }\n    .lg\\:w-auto{\n      width: auto;\n    }\n    .lg\\:items-center{\n      align-items: center;\n    }\n    .lg\\:justify-between{\n      justify-content: space-between;\n    }\n    .lg\\:px-16{\n      padding-left: 4rem;\n      padding-right: 4rem;\n    }\n    .lg\\:px-32{\n      padding-left: 8rem;\n      padding-right: 8rem;\n    }\n    .lg\\:px-6{\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n    .lg\\:px-\\[120px\\]{\n      padding-left: 120px;\n      padding-right: 120px;\n    }\n    .lg\\:py-2{\n      padding-top: 0.5rem;\n      padding-bottom: 0.5rem;\n    }\n    .lg\\:py-20{\n      padding-top: 5rem;\n      padding-bottom: 5rem;\n    }\n    .lg\\:py-\\[100px\\]{\n      padding-top: 100px;\n      padding-bottom: 100px;\n    }\n    .lg\\:py-\\[120px\\]{\n      padding-top: 120px;\n      padding-bottom: 120px;\n    }\n    .lg\\:pb-\\[100px\\]{\n      padding-bottom: 100px;\n    }\n    .lg\\:pr-0{\n      padding-right: 0px;\n    }\n    .lg\\:pt-0{\n      padding-top: 0px;\n    }\n    .lg\\:pt-3{\n      padding-top: 0.75rem;\n    }\n    .lg\\:pt-\\[100px\\]{\n      padding-top: 100px;\n    }\n    .lg\\:pt-\\[120px\\]{\n      padding-top: 120px;\n    }\n    .lg\\:pt-\\[8rem\\]{\n      padding-top: 8rem;\n    }\n    .lg\\:text-\\[28px\\]{\n      font-size: 28px;\n    }\n  }\n  @media (min-width: 1200px){\n    .xl\\:col-span-3{\n      grid-column: span 3 / span 3;\n    }\n    .xl\\:col-span-4{\n      grid-column: span 4 / span 4;\n    }\n    .xl\\:col-span-5{\n      grid-column: span 5 / span 5;\n    }\n    .xl\\:col-span-6{\n      grid-column: span 6 / span 6;\n    }\n    .xl\\:col-span-7{\n      grid-column: span 7 / span 7;\n    }\n    .xl\\:col-span-8{\n      grid-column: span 8 / span 8;\n    }\n    .xl\\:ml-0{\n      margin-left: 0px;\n    }\n    .xl\\:mt-0{\n      margin-top: 0px;\n    }\n    .xl\\:h-full{\n      height: 100%;\n    }\n    .xl\\:w-\\[170px\\]{\n      width: 170px;\n    }\n    .xl\\:w-\\[400px\\]{\n      width: 400px;\n    }\n    .xl\\:justify-center{\n      justify-content: center;\n    }\n    .xl\\:px-24{\n      padding-left: 6rem;\n      padding-right: 6rem;\n    }\n    .xl\\:px-3{\n      padding-left: 0.75rem;\n      padding-right: 0.75rem;\n    }\n    .xl\\:px-6{\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n    .xl\\:px-\\[160px\\]{\n      padding-left: 160px;\n      padding-right: 160px;\n    }\n    .xl\\:py-2{\n      padding-top: 0.5rem;\n      padding-bottom: 0.5rem;\n    }\n    .xl\\:py-3{\n      padding-top: 0.75rem;\n      padding-bottom: 0.75rem;\n    }\n    .xl\\:py-4{\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n    }\n    .xl\\:py-\\[100px\\]{\n      padding-top: 100px;\n      padding-bottom: 100px;\n    }\n    .xl\\:pl-3{\n      padding-left: 0.75rem;\n    }\n    .xl\\:pl-6{\n      padding-left: 1.5rem;\n    }\n    .xl\\:pt-0{\n      padding-top: 0px;\n    }\n    .xl\\:text-\\[24px\\]{\n      font-size: 24px;\n    }\n    .xl\\:text-\\[28px\\]{\n      font-size: 28px;\n    }\n    .xl\\:text-\\[32px\\]{\n      font-size: 32px;\n    }\n  }\n  @media (min-width: 1296px){\n    .\\32xl\\:col-span-3{\n      grid-column: span 3 / span 3;\n    }\n    .\\32xl\\:col-span-4{\n      grid-column: span 4 / span 4;\n    }\n    .\\32xl\\:col-span-6{\n      grid-column: span 6 / span 6;\n    }\n    .\\32xl\\:col-span-8{\n      grid-column: span 8 / span 8;\n    }\n    .\\32xl\\:col-span-9{\n      grid-column: span 9 / span 9;\n    }\n    .\\32xl\\:mt-0{\n      margin-top: 0px;\n    }\n    .\\32xl\\:justify-between{\n      justify-content: space-between;\n    }\n    .\\32xl\\:px-\\[200px\\]{\n      padding-left: 200px;\n      padding-right: 200px;\n    }\n    .\\32xl\\:py-0{\n      padding-top: 0px;\n      padding-bottom: 0px;\n    }\n    .\\32xl\\:py-\\[120px\\]{\n      padding-top: 120px;\n      padding-bottom: 120px;\n    }\n    .\\32xl\\:pt-0{\n      padding-top: 0px;\n    }\n  }\n  @media (min-width: 1600px){\n    .\\33xl\\:mt-0{\n      margin-top: 0px;\n    }\n  }\n  \n\n\n\n\n/* card styling */\n/* .cardContainer{\n  border: red solid 2px ;\n} */\n\n/* .cardContainer {\n  max-width:20%;\n  \n} */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
